var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import sampleIcon from "././assets/sample-icon.svg";
import visualIcon from "././assets/Visual - Change This.svg";
import formIcon from "././assets/Icon Token.svg";
import leftArrowDisabledIcon from "././assets/left-arrow-disabled-icon.svg";
import leftArrowIcon from "././assets/left-arrow-icon.svg";
import rightArrowIcon from "././assets/right-arrow-icon.svg";
import successIcon from "././assets/success.svg";
import crossIcon from "././assets/cross-icon.svg";
import attentionIcon from "././assets/attention-icon.svg";
import attachmentIcon from "././assets/attachment.svg";
import leftArrowBlackIcon from "././assets/Left Arrow Black.svg";
import addIcon from "././assets/add_circle.svg";
import fraudIcon from "././assets/Fraud-icon.svg";
import checkIcon from "././assets/check.svg";
var FORMS_LIBRARY_ASSETS = {
  SAMPLE_ICON: sampleIcon,
  FORM_ICON: formIcon,
  LEFT_ARROW_DISABLED_ICON: leftArrowDisabledIcon,
  LEFT_ARROW_ICON: leftArrowIcon,
  RIGHT_ARROW_ICON: rightArrowIcon,
  LEFT_ARROW_BLACK_ICON: leftArrowBlackIcon,
  SUCCESS_ICON: successIcon,
  CROSS_ICON: crossIcon,
  VISUAL_ICON: visualIcon,
  ATTENTION_ICON: attentionIcon,
  ATTACHMENT_ICON: attachmentIcon,
  ADD_ICON: addIcon,
  FRAUD_ICON: fraudIcon,
  CHECK_ICON: checkIcon
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(FORMS_LIBRARY_ASSETS);
};

// src/forms-library.routes.tsx
import React40 from "react";
import { Switch, Route, useRouteMatch } from "@leagueplatform/routing";

// src/components/forms-library.component.tsx
import React39, { useState as useState30, useEffect as useEffect36, useCallback } from "react";
import {
  Box as Box34,
  HeadingText as HeadingText31,
  Spinner as Spinner7,
  Card as Card2,
  TextAction as TextAction10
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset14 } from "@leagueplatform/asset-config";
import { getInitializationConfig as getInitializationConfig2 } from "@leagueplatform/core";
import { history } from "@leagueplatform/routing";

// src/components/forms/forms-type/medication/medication-forms.component.tsx
import React8, { useEffect as useEffect7, useState as useState6 } from "react";
import { StackLayout as StackLayout7, Spinner } from "@leagueplatform/genesis-core";

// src/components/forms/hooks/useFetchProfileData.tsx
import { useEffect, useState } from "react";

// src/components/forms/helpers.tsx
import { getPartnerAccessToken } from "@leagueplatform/sso-util";
import { format } from "date-fns";

// src/types/online-forms.types.ts
var FORM_PLAN_TYPE = /* @__PURE__ */ ((FORM_PLAN_TYPE2) => {
  FORM_PLAN_TYPE2["MEDICAL"] = "Medical";
  FORM_PLAN_TYPE2["DRUG"] = "Drug";
  FORM_PLAN_TYPE2["DENTAL"] = "Dental";
  FORM_PLAN_TYPE2["VISION"] = "Vision";
  FORM_PLAN_TYPE2["PHARMACY"] = "Pharmacy/Rx";
  return FORM_PLAN_TYPE2;
})(FORM_PLAN_TYPE || {});
var STATE_VALUE = [
  "AK",
  "AL",
  "AR",
  "AS",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DC",
  "DE",
  "FL",
  "GA",
  "GU",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MP",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VI",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY"
];
var SERVICE_TYPE_VALUE = [
  "Please Select",
  "Bifocal Lenses",
  "Contact Lenses",
  "Daily Wear Contact Lens Evaluation",
  "Extended Wear Contact Lens Evaluation",
  "Contact Lenses Standard Daily Wear (1 pair)",
  "Contact Lenses Disposable",
  "Eye Examination",
  "Frames",
  "Medically Necessary Contacts ",
  "Progressive Lenses",
  "Single Vision Lenses",
  "Trifocal Lenses"
];

// src/forms-library.config.ts
var defaultConfig = {
  HIGHMARK_API_URL: "https://api-qa.highmark.com/digital/v1",
  AMH_CDN_URL: "https://test.cdn.allmyhealth.com",
  HIGHMARK_CDN_URL: "https://test.cdn.highmark.com",
  STAGING_URL: "https://engen-forms-library-qa.web.app",
  LOCAL_URL: "https://app.local.league.dev:4000"
};
var formsLibraryConfig = defaultConfig;
var formsLibrary = {
  config(config) {
    if (!config)
      throw new Error("Forms Library: You must provide a config");
    formsLibraryConfig = __spreadValues(__spreadValues({}, defaultConfig), config);
  },
  getConfig() {
    if (!formsLibraryConfig)
      throw new Error("Forms Library: Configuration is not defined.");
    return formsLibraryConfig;
  }
};

// src/components/forms/helpers.tsx
var memberNameOption = (profileResponseData) => {
  var _a;
  const dependents = (_a = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a.dependents;
  const demographicsData = profileResponseData == null ? void 0 : profileResponseData.demographics;
  const dependentsUser = dependents == null ? void 0 : dependents.map((option) => ({
    value: `${option.firstName} ${option.lastName}`,
    label: `${option.firstName} ${option.lastName}`
  }));
  const mainUser = {
    value: `${demographicsData == null ? void 0 : demographicsData.firstName} ${demographicsData == null ? void 0 : demographicsData.lastName}`,
    label: `${demographicsData == null ? void 0 : demographicsData.firstName} ${demographicsData == null ? void 0 : demographicsData.lastName}`
  };
  dependentsUser == null ? void 0 : dependentsUser.unshift(mainUser);
  return dependentsUser;
};
function modifyNumber(value) {
  if (!value)
    return value;
  const phoneNumberLength = value.length;
  let phNum = "";
  if (phoneNumberLength === 10) {
    phNum = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
  }
  return phNum;
}
var phoneNumberOption = (profileResponseData) => {
  var _a;
  const contactPoints = (_a = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a.contactPoints;
  const filteredArray = contactPoints == null ? void 0 : contactPoints.filter(
    (option) => option.type === "Phone" /* PHONE */
  );
  const selectedNumber = filteredArray == null ? void 0 : filteredArray.map((option) => ({
    value: modifyNumber(option.value),
    label: `${option.use} ${":"}  ${modifyNumber(option.value)}`
  }));
  const otherPhoneNumber = {
    value: "Other" /* OTHERS */,
    label: "Other" /* OTHERS */
  };
  selectedNumber == null ? void 0 : selectedNumber.push(otherPhoneNumber);
  return selectedNumber;
};
function formatPhoneNumber(value) {
  if (!value)
    return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4)
    return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}
function stateOption() {
  var _a;
  const state = (_a = STATE_VALUE) == null ? void 0 : _a.map((option) => ({
    value: option,
    label: option
  }));
  return state;
}
function isEmpty(value) {
  return value === null || value === void 0 || (value == null ? void 0 : value.length) === 0;
}
function isNotEmpty(value) {
  if (!value)
    return value;
  return value.length > 0;
}
function isValidatePhoneLength(val) {
  return (val == null ? void 0 : val.length) >= 1 && (val == null ? void 0 : val.length) < 14;
}
function isValidZipCodeLength(val) {
  return (val == null ? void 0 : val.length) >= 1 && (val == null ? void 0 : val.length) <= 4;
}
function getAccessToken(url, apiType) {
  return __async(this, null, function* () {
    let formType = "";
    if (apiType === "forms") {
      const urlArr = url.split("=");
      const [, , urlP3] = urlArr;
      formType = urlP3;
    }
    let token = "";
    token = yield getPartnerAccessToken("highmark");
    const requestOptions = {
      method: "GET",
      headers: new Headers({
        Accept: "application/json",
        Authorization: `Bearer ${token}`
      })
    };
    try {
      return yield fetch(url, requestOptions).then((response) => {
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`
          );
        }
        return response.json();
      }).then((data) => {
        const resultData = __spreadProps(__spreadValues({}, data), {
          type: formType
        });
        return resultData;
      });
    } catch (error) {
      const errObj = {
        errMsg: error
      };
      return errObj;
    }
  });
}
function phoneRegex(val) {
  return val.replace(/[^0-9]/g, "").substring(0, 10);
}
function isAlphaNumbericWithSpace(val) {
  return val.replace(/[^a-zA-Z0-9 ]+/gi, "");
}
function isNoSpace(val) {
  return /^\s/.test(val);
}
function submitForm(formName) {
  return __async(this, null, function* () {
    var _a;
    const userData = JSON.parse(sessionStorage.getItem("formData") || "{}");
    let userData1 = {};
    switch (formName) {
      case "medicationexception" /* MEDICATION_EXCEPTION */:
        userData1 = {
          memberName: userData == null ? void 0 : userData.memberName,
          memberId: userData == null ? void 0 : userData.memberId,
          memberDob: format(new Date(userData == null ? void 0 : userData.dateOfBirth), "MM/dd/yyyy"),
          memberPhoneNo: (userData == null ? void 0 : userData.phoneNumber) === "Other" /* OTHERS */ ? phoneRegex(userData == null ? void 0 : userData.otherPhoneNumber) : phoneRegex(userData == null ? void 0 : userData.phoneNumber),
          prescriberName: userData == null ? void 0 : userData.fullName,
          prescriberFaxNo: userData == null ? void 0 : userData.faxNumber,
          prescriberPhoneNo: phoneRegex(userData == null ? void 0 : userData.prescriberPhoneNumber),
          addr1: userData == null ? void 0 : userData.addressLine1,
          city: userData == null ? void 0 : userData.city,
          state: userData == null ? void 0 : userData.state,
          zipCode: userData == null ? void 0 : userData.zipCode,
          medicationName: userData == null ? void 0 : userData.medicationName,
          reasonForMedication: userData == null ? void 0 : userData.reasonForMedication
        };
        break;
      case "steptherapy" /* STEP_THERAPY */:
        userData1 = {
          memberName: userData == null ? void 0 : userData.memberName,
          memberId: userData == null ? void 0 : userData.memberId,
          memberDob: format(new Date(userData == null ? void 0 : userData.dateOfBirth), "MM/dd/yyyy"),
          memberPhoneNo: (userData == null ? void 0 : userData.phoneNumber) === "Other" /* OTHERS */ ? phoneRegex(userData == null ? void 0 : userData.otherPhoneNumber) : phoneRegex(userData == null ? void 0 : userData.phoneNumber),
          prescriberName: userData == null ? void 0 : userData.prescriberName,
          prescriberPhoneNo: phoneRegex(userData == null ? void 0 : userData.prescriberPhoneNumber),
          drugName: userData == null ? void 0 : userData.drugName,
          strength: userData == null ? void 0 : userData.strength,
          quantity: userData == null ? void 0 : userData.quantity,
          reasonForRequest: userData == null ? void 0 : userData.explainYourRequest
        };
        break;
      case "dental-claim" /* DENTAL_CLAIM */:
        userData1 = {
          payload: {
            formType: "dental",
            dentalInfo: {
              dentalPlanName: userData == null ? void 0 : userData.dentalPlanName,
              dentalPlanAddress: `${userData == null ? void 0 : userData.dentalPlanAddress1}, ${userData.dentalPlanAddress2}, ${userData == null ? void 0 : userData.dentalPlanCity}, ${userData == null ? void 0 : userData.dentalPlanState} ${userData == null ? void 0 : userData.dentalPlanZipCode}`,
              transactionTypes: [
                `Statement of services: ${userData == null ? void 0 : userData.statementOfServices}`,
                `Request for Predetermination: ${userData == null ? void 0 : userData.requestForPredetermination}`,
                `Early and Periodic screening: ${userData == null ? void 0 : userData.earlyAndPeriodicScreening}`
              ],
              memberName: userData == null ? void 0 : userData.memberName,
              address: `${userData == null ? void 0 : userData.addressLine1}, ${userData.addressLine2}, ${userData == null ? void 0 : userData.city}, ${userData == null ? void 0 : userData.state} ${userData == null ? void 0 : userData.zipCode}`,
              policyHolderDob: userData == null ? void 0 : userData.dateOfBirth,
              gender: userData == null ? void 0 : userData.gender,
              memberId: userData == null ? void 0 : userData.memberId,
              isPolicyHolderPatient: (userData == null ? void 0 : userData.isPolicyHolderPatient) === "YES",
              dependentDetails: [
                {
                  patientRelationship: userData == null ? void 0 : userData.patientRelationship,
                  patientName: userData == null ? void 0 : userData.patientName,
                  patientDob: userData == null ? void 0 : userData.patientDateOfBirth
                }
              ],
              otherCoverage: {
                hasDentalCoverage: userData == null ? void 0 : userData.hasDentalCoverage,
                hasMedicalCoverage: userData == null ? void 0 : userData.hasMedicalCoverage,
                notApplicable: userData == null ? void 0 : userData.notApplicable
              },
              policyHolderDetails: [
                {
                  primaryInsurance: (userData == null ? void 0 : userData.primaryInsurance) === "Yes",
                  insuranceDetails: [
                    {
                      policyHolderName: userData == null ? void 0 : userData.policyHolderName,
                      policyHolderDob: userData == null ? void 0 : userData.policyHolderDob,
                      policyHolderGender: userData == null ? void 0 : userData.policyHolderGender,
                      policyID: userData == null ? void 0 : userData.policyID,
                      planNumber: userData == null ? void 0 : userData.planNumber,
                      relationshipToPolicyHolder: userData == null ? void 0 : userData.relationshipToPolicyHolder,
                      otherInsuranceCompany: userData == null ? void 0 : userData.otherInsuranceCompany,
                      otherInsuranceAddress: `${userData == null ? void 0 : userData.otherInsuranceAddressLine1}, ${userData.otherInsuranceAddressLine2}, ${userData == null ? void 0 : userData.otherInsuranceAddressCity}, ${userData == null ? void 0 : userData.otherInsuranceAddressState} ${userData == null ? void 0 : userData.otherInsuranceAddressZipCode}`,
                      explanationOfBenefits: (_a = userData == null ? void 0 : userData.eobAttachments) == null ? void 0 : _a.map(
                        (eob, index) => {
                          const eobObj = {
                            attachmentId: index,
                            attachmentPath: eob.attachmentPath,
                            fileName: eob.name,
                            isLoading: false
                          };
                          return eobObj;
                        }
                      )
                    }
                  ]
                }
              ],
              itemizedBill: userData == null ? void 0 : userData.itemizedAttachments.map(
                (item, index) => {
                  const itemObj = {
                    attachmentId: index,
                    attachmentPath: item.attachmentPath,
                    fileName: item.name,
                    isLoading: false
                  };
                  return itemObj;
                }
              ),
              patientConsent: (userData == null ? void 0 : userData.patientConsent) === true,
              paymentAuthorization: (userData == null ? void 0 : userData.paymentAuthorization) === true,
              entityName: userData == null ? void 0 : userData.entityName
            }
          }
        };
        break;
      default:
    }
    const token = yield getPartnerAccessToken("highmark");
    const config = formsLibrary.getConfig();
    const { HIGHMARK_API_URL } = config;
    const url = `${HIGHMARK_API_URL}/members/forms-library/${formName}/submit`;
    const options = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(userData1)
    };
    try {
      const response = yield fetch(url, options);
      const data = yield response.json();
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  });
}
function emptyStorage() {
  sessionStorage.removeItem("formData");
  sessionStorage.removeItem("otherCoverage");
}
function updateFormData(value) {
  const prevData = JSON.parse(sessionStorage.getItem("formData") || "{}");
  Object.keys(value).forEach((val) => {
    prevData[val] = value[val];
  });
  sessionStorage.setItem("formData", JSON.stringify(prevData));
}
function dataURItoBlob(dataURI) {
  const byteString = atob(dataURI);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const int8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([int8Array], { type: "application/pdf" });
  return blob;
}
function openPrefilledPdf(content) {
  const blob = dataURItoBlob(content);
  const link = URL.createObjectURL(blob);
  window.open(link, "_blank");
}

// src/components/forms/hooks/useFetchProfileData.tsx
function useFetchProfileData() {
  const [apiData, setApiData] = useState(null);
  const [errMsg, setErrMsg] = useState(null);
  const config = formsLibrary.getConfig();
  const { HIGHMARK_API_URL } = config;
  const url = `${HIGHMARK_API_URL}/members/demographics/profile`;
  useEffect(() => {
    getAccessToken(url).then((result) => {
      const userData = result == null ? void 0 : result.demographics;
      const errData = result == null ? void 0 : result.errMsg;
      if (userData) {
        setApiData(result);
      } else if (errData) {
        setErrMsg(errData);
      }
    });
  }, [url]);
  return [apiData, errMsg];
}

// src/components/forms/layout/footerMultiStepProgress.tsx
import React3, { useEffect as useEffect2, useState as useState2 } from "react";
import { handleStaticAsset as handleStaticAsset3 } from "@leagueplatform/asset-config";
import {
  Box as Box3,
  UtilityText as UtilityText2,
  StackItem,
  TextAction
} from "@leagueplatform/genesis-core";

// src/components/forms/layout/sucessModal.tsx
import React from "react";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import {
  Box,
  HeadingText,
  StackLayout,
  Button
} from "@leagueplatform/genesis-core";
function SuccessModal(props) {
  const { onClose } = props;
  return /* @__PURE__ */ React.createElement(StackLayout, { css: { textAlign: "center", minHeight: "100vh" } }, /* @__PURE__ */ React.createElement(
    Box,
    {
      css: {
        padding: "$four",
        marginTop: "$three",
        backgroundColor: "White"
      }
    },
    /* @__PURE__ */ React.createElement(
      "img",
      {
        style: { cursor: "pointer" },
        src: handleStaticAsset("SUCCESS_ICON" /* SUCCESS_ICON */),
        alt: "right arrow icon",
        width: "55px"
      }
    ),
    /* @__PURE__ */ React.createElement(
      HeadingText,
      {
        level: "1",
        size: {
          "@initial": "xxl",
          "@mobile": "xl"
        }
      },
      "Your form was submitted successfully!"
    ),
    /* @__PURE__ */ React.createElement(
      HeadingText,
      {
        css: {
          margin: "$two $none"
        },
        level: "3",
        size: {
          "@initial": "lg",
          "@mobile": "lg"
        }
      },
      "You will be contacted by phone after your request is processed."
    ),
    /* @__PURE__ */ React.createElement(Button, { onClick: onClose }, "Close")
  ));
}

// src/components/forms/layout/confirmationModal.tsx
import React2 from "react";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
import {
  Box as Box2,
  StackLayout as StackLayout2,
  Modal,
  ParagraphText,
  UtilityText,
  HeadingText as HeadingText2
} from "@leagueplatform/genesis-core";
function ConfirmationModal(props) {
  const { onClose } = props;
  return /* @__PURE__ */ React2.createElement(Modal.Root, null, /* @__PURE__ */ React2.createElement(Modal.Trigger, null, /* @__PURE__ */ React2.createElement(
    Box2,
    {
      css: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        position: "relative",
        left: "90px",
        marginBottom: "$two"
      }
    },
    /* @__PURE__ */ React2.createElement(
      "img",
      {
        src: handleStaticAsset2("CROSS_ICON" /* CROSS_ICON */),
        alt: "close the online form",
        width: "15px"
      }
    )
  )), /* @__PURE__ */ React2.createElement(
    Modal.Content,
    {
      showCloseButton: false,
      padding: "$none",
      width: { "@initial": 650, "@mobile": "100%" }
    },
    /* @__PURE__ */ React2.createElement(
      StackLayout2,
      {
        css: { textAlign: "center", padding: "$three $three" },
        horizontalAlignment: "stretch"
      },
      /* @__PURE__ */ React2.createElement(
        Box2,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }
        },
        " ",
        /* @__PURE__ */ React2.createElement(
          "img",
          {
            src: handleStaticAsset2(
              "ATTENTION_ICON" /* ATTENTION_ICON */
            ),
            alt: "cross icon",
            width: "40px",
            style: { cursor: "pointer" }
          }
        )
      ),
      /* @__PURE__ */ React2.createElement(Modal.Title, null, /* @__PURE__ */ React2.createElement(
        HeadingText2,
        {
          level: "display",
          size: "sm",
          css: { padding: "$oneAndHalf $none" }
        },
        "Attention"
      )),
      /* @__PURE__ */ React2.createElement(ParagraphText, { emphasis: "subtle" }, "Are you sure you want to exit this form? Your changes will not be saved."),
      /* @__PURE__ */ React2.createElement(
        Box2,
        {
          css: {
            display: "flex",
            flexDirection: "row",
            padding: "$two $four $one $four",
            justifyContent: "space-around"
          }
        },
        /* @__PURE__ */ React2.createElement(Modal.Close, null, /* @__PURE__ */ React2.createElement(
          UtilityText,
          {
            css: {
              color: "#0074C9",
              cursor: "pointer"
            }
          },
          "No"
        )),
        /* @__PURE__ */ React2.createElement(
          UtilityText,
          {
            css: {
              color: "#0074C9",
              cursor: "pointer"
            },
            onClick: onClose
          },
          "Yes"
        )
      )
    )
  ));
}

// src/components/forms/layout/footerMultiStepProgress.tsx
function FooterMultiStepProgress(props) {
  const [selectedIndex, setSelectedIndex] = useState2(0);
  const [isSuccessModal, setIsSuccessModal] = useState2(false);
  const {
    handleFormOrNext,
    isValidateForm,
    list,
    closeForm,
    formName,
    showInstructions,
    closeInstructions,
    showNext
  } = props;
  const [totalPageCount, setTotalPageCount] = useState2(list.length);
  const [compList, setCompList] = useState2([...list]);
  useEffect2(() => {
    setTotalPageCount(list.length);
    setCompList(list);
  }, [showInstructions]);
  useEffect2(() => {
    setTotalPageCount(compList.length);
    setCompList(compList);
  }, [compList]);
  const goNext = () => {
    const oc = sessionStorage.getItem("otherCoverage");
    const compListCopy = [...list];
    let filteredCompList = [];
    if (oc === "NO" && selectedIndex >= 3) {
      compListCopy.splice(4, 2);
      setCompList(compListCopy);
      if (handleFormOrNext) {
        if (selectedIndex !== compListCopy.length - 1) {
          setSelectedIndex(selectedIndex + 1);
          isValidateForm(false);
        }
      } else {
        isValidateForm(true);
      }
    } else {
      filteredCompList = [...compListCopy];
      setCompList(filteredCompList);
      if (handleFormOrNext) {
        if (selectedIndex !== filteredCompList.length - 1) {
          setSelectedIndex(selectedIndex + 1);
          isValidateForm(false);
        }
      } else {
        isValidateForm(true);
      }
    }
  };
  const goPrevious = () => {
    if (selectedIndex !== 0) {
      setSelectedIndex(selectedIndex - 1);
    }
    isValidateForm(false);
  };
  const handleFormSubmit = () => {
    if (handleFormOrNext) {
      submitForm(formName);
      setIsSuccessModal(true);
    } else {
      isValidateForm(true);
    }
  };
  return /* @__PURE__ */ React3.createElement("div", null, isSuccessModal ? /* @__PURE__ */ React3.createElement(SuccessModal, { onClose: closeForm }) : /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(ConfirmationModal, { onClose: closeForm }), /* @__PURE__ */ React3.createElement("div", null, compList[selectedIndex]), !showNext && /* @__PURE__ */ React3.createElement(
    StackItem,
    {
      css: {
        padding: "$none $five",
        flexDirection: "row",
        marginTop: "$oneAndHalf",
        width: "800px",
        marginLeft: "70px"
      }
    },
    [...Array(totalPageCount)].map((i, index) => /* @__PURE__ */ React3.createElement(
      Box3,
      {
        key: i,
        css: {
          backgroundColor: index >= selectedIndex + 1 ? "#D6D6D6" : "#0074C9",
          // width: '150px',
          height: "4px",
          borderRadius: "$medium",
          marginRight: "10px"
        }
      }
    ))
  ), showNext ? /* @__PURE__ */ React3.createElement(
    Box3,
    {
      css: {
        display: "flex",
        flexDirection: "row",
        padding: "$twoAndHalf",
        justifyContent: "end",
        width: "800px",
        marginLeft: "70px"
      }
    },
    /* @__PURE__ */ React3.createElement(
      StackItem,
      {
        css: {
          padding: "$five $none"
        }
      },
      /* @__PURE__ */ React3.createElement(
        TextAction,
        {
          onClick: closeInstructions,
          icon: handleStaticAsset3(
            "RIGHT_ARROW_ICON" /* RIGHT_ARROW_ICON */
          )
        },
        /* @__PURE__ */ React3.createElement(
          "span",
          {
            style: {
              position: "relative",
              right: "95px",
              fontSize: "x-large",
              height: "28px"
            }
          },
          "NEXT"
        )
      )
    )
  ) : /* @__PURE__ */ React3.createElement(
    Box3,
    {
      css: {
        display: "flex",
        flexDirection: "row",
        padding: "$twoAndHalf",
        justifyContent: "space-between",
        width: "800px",
        marginLeft: "70px"
      }
    },
    /* @__PURE__ */ React3.createElement(
      StackItem,
      {
        css: {
          padding: "$none $five"
        }
      },
      /* @__PURE__ */ React3.createElement(
        "img",
        {
          onClick: selectedIndex + 1 > 1 ? goPrevious : closeInstructions,
          style: { cursor: selectedIndex + 1 > 1 ? "pointer" : "" },
          src: handleStaticAsset3(
            selectedIndex + 1 > 0 ? "LEFT_ARROW_ICON" /* LEFT_ARROW_ICON */ : "LEFT_ARROW_DISABLED_ICON" /* LEFT_ARROW_DISABLED_ICON */
          ),
          alt: "left arrow icon",
          width: "24px",
          "aria-hidden": "true"
        }
      )
    ),
    /* @__PURE__ */ React3.createElement(
      StackItem,
      {
        css: {
          padding: "$none $five"
        }
      },
      /* @__PURE__ */ React3.createElement(UtilityText2, null, selectedIndex + 1, " of ", totalPageCount)
    ),
    /* @__PURE__ */ React3.createElement(
      StackItem,
      {
        css: {
          padding: "$none $five"
        }
      },
      selectedIndex + 1 === totalPageCount ? /* @__PURE__ */ React3.createElement(
        UtilityText2,
        {
          css: {
            color: "#0074C9",
            cursor: "pointer"
          },
          onClick: handleFormSubmit
        },
        "Submit"
      ) : /* @__PURE__ */ React3.createElement(
        "img",
        {
          onClick: goNext,
          style: { cursor: "pointer" },
          "aria-hidden": "true",
          src: handleStaticAsset3(
            "RIGHT_ARROW_ICON" /* RIGHT_ARROW_ICON */
          ),
          alt: "right arrow icon",
          width: "24px"
        }
      )
    )
  )));
}

// src/components/forms/forms-type/medication/pages/member-information.component.tsx
import React4, { useEffect as useEffect3, useState as useState3 } from "react";
import { format as format2 } from "date-fns";
import {
  Box as Box4,
  HeadingText as HeadingText3,
  FormField,
  TextInput,
  Select,
  StackLayout as StackLayout3,
  UtilityText as UtilityText3
} from "@leagueplatform/genesis-core";
function MemberInformation(props) {
  var _a, _b, _c, _d, _e;
  const { errorHandling, nextButtonClicked, profileResponseData } = props;
  const [otherPhNumError, setOtherPhNumError] = useState3("");
  const [isOtherPhone, setIsOtherPhone] = useState3(false);
  const [form, setForm] = useState3({
    memberName: "",
    memberId: (_a = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a.memberId,
    dateOfBirth: (_b = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _b.dateOfBirth,
    phoneNumber: "",
    otherPhoneNumber: "",
    dependents: []
  });
  const [errors, setErrors] = useState3({
    otherPhoneNumber: false
  });
  const formField = isEmpty(form.otherPhoneNumber) || isValidatePhoneLength(form.otherPhoneNumber);
  const isValid = isNotEmpty(form.otherPhoneNumber);
  useEffect3(() => {
    if (formField && isOtherPhone) {
      errorHandling(false);
      if (isEmpty(form.otherPhoneNumber)) {
        setOtherPhNumError(
          "Your phone number is required to process this request."
        );
      } else if (isValidatePhoneLength(form.otherPhoneNumber)) {
        setOtherPhNumError("Enter a valid phone number.");
      } else {
        setOtherPhNumError("");
      }
    } else {
      errorHandling(true);
    }
  }, [formField, isOtherPhone, errorHandling, form.otherPhoneNumber]);
  useEffect3(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          otherPhoneNumber: isEmpty(form.otherPhoneNumber)
        });
      }
    }
  }, [nextButtonClicked, isValid, form.otherPhoneNumber]);
  const updateErrorState = (value, id) => {
    if (id === "otherPhoneNumber") {
      if (isEmpty(form.otherPhoneNumber)) {
        setOtherPhNumError(
          "Your phone number is required to process this request."
        );
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          otherPhoneNumber: true
        }));
      } else if (isValidatePhoneLength(value)) {
        setOtherPhNumError("Enter a valid phone number.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          otherPhoneNumber: true
        }));
      } else {
        setOtherPhNumError("");
      }
    }
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    const nextFormState = __spreadProps(__spreadValues({}, form), {
      [id]: value
    });
    setForm(nextFormState);
    updateErrorState(value, id);
    if (id === "otherPhoneNumber") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        otherPhoneNumber: isNoSpace(value) ? "" : formatPhoneNumber(value)
      }));
    }
    if (id === "phoneNumber") {
      setIsOtherPhone(event.target.value === "Other" /* OTHERS */);
      if (event.target.value !== "Other" /* OTHERS */) {
        setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
          otherPhoneNumber: ""
        }));
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          otherPhoneNumber: false
        }));
      }
    }
  };
  useEffect3(() => {
    var _a2, _b2, _c2, _d2, _e2;
    if (form.memberName && ((_a2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a2.dependents) !== null) {
      const dependentsUser = (_b2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _b2.dependents.map(
        (option) => ({
          name: `${option.firstName} ${option.lastName}`,
          dateOfBirth: `${option.dateOfBirth}`
        })
      );
      const mainUser = {
        name: `${(_c2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _c2.firstName} ${(_d2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _d2.lastName}`,
        dateOfBirth: `${(_e2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _e2.dateOfBirth}`
      };
      dependentsUser == null ? void 0 : dependentsUser.unshift(mainUser);
      const selectedUser = dependentsUser == null ? void 0 : dependentsUser.find(
        (o) => o.name === form.memberName
      );
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        dateOfBirth: selectedUser.dateOfBirth,
        dependents: dependentsUser
      }));
    }
  }, [form.memberName, profileResponseData]);
  useEffect3(() => {
    var _a2, _b2, _c2, _d2, _e2;
    const memberInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (memberInfo) {
      setForm({
        memberName: (memberInfo == null ? void 0 : memberInfo.memberName) ? memberInfo == null ? void 0 : memberInfo.memberName : `${(_a2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a2.firstName} ${(_b2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _b2.lastName}`,
        memberId: (memberInfo == null ? void 0 : memberInfo.memberId) ? memberInfo == null ? void 0 : memberInfo.memberId : (_c2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _c2.memberId,
        dateOfBirth: (memberInfo == null ? void 0 : memberInfo.dateOfBirth) ? format2(new Date(memberInfo == null ? void 0 : memberInfo.dateOfBirth), "MM/dd/yyyy") : format2(
          new Date((_d2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _d2.dateOfBirth),
          "MM/dd/yyyy"
        ),
        phoneNumber: (memberInfo == null ? void 0 : memberInfo.phoneNumber) ? memberInfo == null ? void 0 : memberInfo.phoneNumber : (_e2 = phoneNumberOption(profileResponseData)[0]) == null ? void 0 : _e2.value,
        otherPhoneNumber: memberInfo == null ? void 0 : memberInfo.otherPhoneNumber,
        dependents: memberInfo == null ? void 0 : memberInfo.dependents
      });
    }
  }, [profileResponseData]);
  useEffect3(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  useEffect3(() => {
    if (form.phoneNumber === "Other" /* OTHERS */) {
      setIsOtherPhone(true);
    } else {
      setIsOtherPhone(false);
    }
  }, [form]);
  const onBlurField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  const onKeyPressField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  return /* @__PURE__ */ React4.createElement(
    StackLayout3,
    {
      horizontalAlignment: "center",
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      }
    },
    /* @__PURE__ */ React4.createElement(
      Box4,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $four $one $four"
        }
      },
      /* @__PURE__ */ React4.createElement(
        HeadingText3,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Medication Exception Request Form"
      )
    ),
    /* @__PURE__ */ React4.createElement(
      Box4,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$none $two",
          width: "100%"
        }
      },
      /* @__PURE__ */ React4.createElement(
        Box4,
        {
          css: {
            backgroundColor: "#F8F8F8",
            padding: "$one $two"
          }
        },
        /* @__PURE__ */ React4.createElement(
          HeadingText3,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Form Instructions:"
        ),
        /* @__PURE__ */ React4.createElement(
          Box4,
          {
            css: {
              marginTop: "$one",
              paddingLeft: "$one"
            }
          },
          /* @__PURE__ */ React4.createElement(UtilityText3, null, /* @__PURE__ */ React4.createElement("ol", null, /* @__PURE__ */ React4.createElement("li", { key: "1" }, "1. Complete all required fields to submit."), /* @__PURE__ */ React4.createElement("li", { key: "2" }, "2. Enter full name and address (including city, state, and zip code)", /* @__PURE__ */ React4.createElement("br", null), " when a name and address field is required."), /* @__PURE__ */ React4.createElement("li", { key: "3" }, "3. All fields are required unless marked optional.")))
        )
      )
    ),
    /* @__PURE__ */ React4.createElement(
      Box4,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$two $four $three $four",
          width: "100%"
        }
      },
      /* @__PURE__ */ React4.createElement(
        Box4,
        {
          css: {
            display: "flex"
          }
        },
        /* @__PURE__ */ React4.createElement(
          HeadingText3,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 1: Member Information"
        )
      ),
      /* @__PURE__ */ React4.createElement(Box4, null, /* @__PURE__ */ React4.createElement(
        Box4,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        ((_c = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _c.dependents) || form.dependents ? /* @__PURE__ */ React4.createElement(FormField, { id: "memberName", label: "Member Name" }, /* @__PURE__ */ React4.createElement(
          Select,
          {
            options: memberNameOption(profileResponseData),
            onChange: onUpdateField,
            value: form.memberName
          }
        )) : /* @__PURE__ */ React4.createElement(FormField, { id: "memberName", label: "Member Name" }, /* @__PURE__ */ React4.createElement(
          TextInput,
          {
            disabled: true,
            value: `${(_d = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _d.firstName} ${(_e = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _e.lastName}`
          }
        ))
      ), /* @__PURE__ */ React4.createElement(
        Box4,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React4.createElement(FormField, { id: "memberId", label: "Member ID" }, /* @__PURE__ */ React4.createElement(TextInput, { disabled: true, value: form.memberId }))
      ), /* @__PURE__ */ React4.createElement(
        Box4,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React4.createElement(FormField, { id: "dateOfBirth", label: "Date of Birth (MM/DD/YYYY)" }, /* @__PURE__ */ React4.createElement(
          TextInput,
          {
            disabled: true,
            value: form.dateOfBirth ? format2(new Date(form.dateOfBirth), "MM/dd/yyyy") : form.dateOfBirth
          }
        ))
      ), /* @__PURE__ */ React4.createElement(
        Box4,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React4.createElement(FormField, { id: "phoneNumber", label: "Phone Number" }, /* @__PURE__ */ React4.createElement(
          Select,
          {
            options: phoneNumberOption(profileResponseData),
            onChange: onUpdateField,
            value: form.phoneNumber
          }
        ))
      ), isOtherPhone && /* @__PURE__ */ React4.createElement(
        Box4,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React4.createElement(
          FormField,
          {
            id: "otherPhoneNumber",
            label: "Other Phone Number",
            inputStatus: errors.otherPhoneNumber ? "error" : void 0,
            statusIconLabel: errors.otherPhoneNumber ? "Error" : "",
            statusMessage: errors.otherPhoneNumber ? otherPhNumError : ""
          },
          /* @__PURE__ */ React4.createElement(
            TextInput,
            {
              onChange: onUpdateField,
              value: formatPhoneNumber(form.otherPhoneNumber),
              maxLength: 14,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ))
    )
  );
}

// src/components/forms/forms-type/medication/pages/prescriber-information.component.tsx
import React5, { useEffect as useEffect4, useState as useState4 } from "react";
import {
  Box as Box5,
  HeadingText as HeadingText4,
  FormField as FormField2,
  TextInput as TextInput2,
  Select as Select2,
  StackLayout as StackLayout4,
  UtilityText as UtilityText4
} from "@leagueplatform/genesis-core";
function PrescriberInformation(props) {
  const { errorHandling, nextButtonClicked } = props;
  const [phNumError, setPhNumError] = useState4("");
  const [zipCodeError, setZipCodeError] = useState4("");
  const [faxNumberError, setFaxNumberError] = useState4("");
  const [form, setForm] = useState4({
    fullName: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
    prescriberPhoneNumber: "",
    faxNumber: ""
  });
  const [errors, setErrors] = useState4({
    fullName: false,
    addressLine1: false,
    city: false,
    state: false,
    zipCode: false,
    prescriberPhoneNumber: false,
    faxNumber: false
  });
  const formField = isEmpty(form.fullName) || isEmpty(form.addressLine1) || isEmpty(form.city) || isEmpty(form.state) || isEmpty(form.zipCode) || isEmpty(form.prescriberPhoneNumber) || isValidatePhoneLength(form.prescriberPhoneNumber) || isValidZipCodeLength(form.zipCode) || isValidatePhoneLength(form.faxNumber);
  const isValid = isNotEmpty(form.fullName) && isNotEmpty(form.addressLine1) && isNotEmpty(form.city) && isNotEmpty(form.state) && isNotEmpty(form.zipCode) && isNotEmpty(form.prescriberPhoneNumber) && !isValidatePhoneLength(form.prescriberPhoneNumber) && !isValidZipCodeLength(form.zipCode);
  useEffect4(() => {
    if (formField || errors.faxNumber || errors.prescriberPhoneNumber || errors.zipCode) {
      errorHandling(false);
      if (isEmpty(form.zipCode)) {
        setZipCodeError("This field is required.");
      } else if (isValidZipCodeLength(form.zipCode)) {
        setZipCodeError("Enter a valid zip code.");
      } else {
        setZipCodeError("");
      }
      if (isValidatePhoneLength(form.faxNumber)) {
        setFaxNumberError("Enter a valid fax number.");
      } else {
        setFaxNumberError("");
      }
      if (isEmpty(form.prescriberPhoneNumber)) {
        setPhNumError("Your prescriber's phone number is required.");
      } else if (isValidatePhoneLength(form.prescriberPhoneNumber)) {
        setPhNumError("Enter a valid phone number.");
      } else {
        setPhNumError("");
      }
    } else {
      errorHandling(true);
    }
  }, [formField, errors.faxNumber, errorHandling, form, errors]);
  useEffect4(() => {
    if (nextButtonClicked) {
      if (!isValid || isValidatePhoneLength(form.faxNumber)) {
        setErrors({
          fullName: isEmpty(form.fullName),
          addressLine1: isEmpty(form.addressLine1),
          city: isEmpty(form.city),
          state: isEmpty(form.state),
          zipCode: isEmpty(form.zipCode) || isValidZipCodeLength(form.zipCode),
          prescriberPhoneNumber: isEmpty(form.prescriberPhoneNumber) || isValidatePhoneLength(form.prescriberPhoneNumber),
          faxNumber: isValidatePhoneLength(form.faxNumber)
        });
      }
    }
  }, [nextButtonClicked, isValid, form]);
  const updateErrorState = (value, id) => {
    if (id === "prescriberPhoneNumber") {
      if (isEmpty(form.prescriberPhoneNumber)) {
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          prescriberPhoneNumber: true
        }));
      } else if (isValidatePhoneLength(value)) {
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          prescriberPhoneNumber: true
        }));
      } else {
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          prescriberPhoneNumber: false
        }));
      }
    } else if (id === "zipCode") {
      if (isEmpty(value)) {
        setZipCodeError("This field is required.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          zipCode: true
        }));
      } else if (isValidZipCodeLength(value)) {
        setZipCodeError("Enter a valid zip code.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          zipCode: true
        }));
      } else {
        setZipCodeError("");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          zipCode: false
        }));
      }
    } else if (id === "faxNumber") {
      if (isValidatePhoneLength(value)) {
        setFaxNumberError("Enter a valid fax number.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          faxNumber: true
        }));
      } else {
        setFaxNumberError("");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          faxNumber: false
        }));
      }
    } else {
      const nextErrorState = __spreadProps(__spreadValues({}, errors), {
        [id]: isEmpty(value)
      });
      setErrors(nextErrorState);
    }
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    const nextFormState = __spreadProps(__spreadValues({}, form), {
      [event.target.id]: /^\s/.test(event.target.value) ? "" : event.target.value
    });
    setForm(nextFormState);
    updateErrorState(event.target.value, event.target.id);
    if (id === "fullName") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        fullName: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^a-zA-Z0-9 ]+/gi, "")
      }));
    }
    if (id === "city") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        city: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^a-zA-Z ]+/gi, "")
      }));
    }
    if (id === "zipCode") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        zipCode: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^0-9]+/gi, "")
      }));
    }
    if (id === "faxNumber") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        faxNumber: isNoSpace(value) ? "" : formatPhoneNumber(value)
      }));
    }
    if (id === "prescriberPhoneNumber") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        prescriberPhoneNumber: isNoSpace(value) ? "" : formatPhoneNumber(value)
      }));
    }
  };
  useEffect4(() => {
    const pInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (pInfo) {
      setForm({
        fullName: pInfo == null ? void 0 : pInfo.fullName,
        addressLine1: pInfo == null ? void 0 : pInfo.addressLine1,
        addressLine2: pInfo == null ? void 0 : pInfo.addressLine2,
        city: pInfo == null ? void 0 : pInfo.city,
        state: pInfo == null ? void 0 : pInfo.state,
        zipCode: pInfo == null ? void 0 : pInfo.zipCode,
        prescriberPhoneNumber: pInfo == null ? void 0 : pInfo.prescriberPhoneNumber,
        faxNumber: pInfo == null ? void 0 : pInfo.faxNumber
      });
    }
  }, []);
  const onBlurField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  const onKeyPressField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  useEffect4(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React5.createElement(
    StackLayout4,
    {
      horizontalAlignment: "center",
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      }
    },
    /* @__PURE__ */ React5.createElement(
      Box5,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $four $one $four"
        }
      },
      /* @__PURE__ */ React5.createElement(
        HeadingText4,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Medication Exception Request Form"
      ),
      /* @__PURE__ */ React5.createElement(
        Box5,
        {
          css: {
            marginTop: "$two",
            marginBottom: "$one"
          }
        },
        /* @__PURE__ */ React5.createElement(
          HeadingText4,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 2: Prescriber Information"
        )
      ),
      /* @__PURE__ */ React5.createElement(
        Box5,
        {
          css: {
            display: "flex"
          }
        },
        /* @__PURE__ */ React5.createElement(UtilityText4, null, "Enter your doctor", `'`, "s information below.")
      ),
      /* @__PURE__ */ React5.createElement(Box5, null, /* @__PURE__ */ React5.createElement(
        Box5,
        {
          css: {
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React5.createElement(
          FormField2,
          {
            id: "fullName",
            label: "Full Name (First, Last)",
            statusIconLabel: "Error",
            inputStatus: errors.fullName ? "error" : void 0,
            statusMessage: errors.fullName ? "Prescriber's full name is required." : ""
          },
          /* @__PURE__ */ React5.createElement(
            TextInput2,
            {
              name: "fullName",
              value: form.fullName,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React5.createElement(
        Box5,
        {
          css: {
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React5.createElement(
          FormField2,
          {
            id: "addressLine1",
            label: "Address Line 1",
            statusIconLabel: "Error",
            inputStatus: errors.addressLine1 ? "error" : void 0,
            statusMessage: errors.addressLine1 ? "This field is required." : ""
          },
          /* @__PURE__ */ React5.createElement(
            TextInput2,
            {
              name: "addressLine1",
              value: form.addressLine1,
              onChange: onUpdateField,
              maxLength: 50,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React5.createElement(
        Box5,
        {
          css: {
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React5.createElement(FormField2, { id: "addressLine2", label: "Address Line 2 (Optional)" }, /* @__PURE__ */ React5.createElement(
          TextInput2,
          {
            name: "addressLine2",
            value: form.addressLine2,
            onChange: onUpdateField,
            maxLength: 50
          }
        ))
      ), /* @__PURE__ */ React5.createElement(
        Box5,
        {
          css: {
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React5.createElement(
          FormField2,
          {
            id: "city",
            label: "City",
            statusIconLabel: "Error",
            inputStatus: errors.city ? "error" : void 0,
            statusMessage: errors.city ? "This field is required." : ""
          },
          /* @__PURE__ */ React5.createElement(
            TextInput2,
            {
              name: "city",
              value: form.city,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React5.createElement(
        Box5,
        {
          css: {
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React5.createElement(
          FormField2,
          {
            id: "state",
            label: "State",
            statusIconLabel: "Error",
            inputStatus: errors.state ? "error" : void 0,
            statusMessage: errors.state ? "This field is required." : ""
          },
          /* @__PURE__ */ React5.createElement(
            Select2,
            {
              name: "state",
              options: stateOption(),
              placeholder: "Please Select",
              id: "select-error",
              value: form.state,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React5.createElement(
        Box5,
        {
          css: {
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React5.createElement(
          FormField2,
          {
            id: "zipCode",
            label: "Zip Code",
            statusIconLabel: "Error",
            inputStatus: errors.zipCode ? "error" : void 0,
            statusMessage: errors.zipCode ? zipCodeError : ""
          },
          /* @__PURE__ */ React5.createElement(
            TextInput2,
            {
              pattern: "[0-9]*",
              name: "zipCode",
              value: form.zipCode,
              onChange: onUpdateField,
              maxLength: 5,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React5.createElement(
        Box5,
        {
          css: {
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React5.createElement(
          FormField2,
          {
            id: "prescriberPhoneNumber",
            label: "Phone Number",
            statusIconLabel: "Error",
            inputStatus: errors.prescriberPhoneNumber ? "error" : void 0,
            statusMessage: errors.prescriberPhoneNumber ? phNumError : ""
          },
          /* @__PURE__ */ React5.createElement(
            TextInput2,
            {
              name: "prescriberPhoneNumber",
              value: form.prescriberPhoneNumber,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 14
            }
          )
        )
      ), /* @__PURE__ */ React5.createElement(
        Box5,
        {
          css: {
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React5.createElement(
          FormField2,
          {
            id: "faxNumber",
            label: "Fax Number (Optional)",
            statusIconLabel: "Error",
            inputStatus: errors.faxNumber ? "error" : void 0,
            statusMessage: errors.faxNumber ? faxNumberError : ""
          },
          /* @__PURE__ */ React5.createElement(
            TextInput2,
            {
              name: "faxNumber",
              value: form.faxNumber,
              onChange: onUpdateField,
              maxLength: 14
            }
          )
        )
      ))
    )
  );
}

// src/components/forms/forms-type/medication/pages/medication-information.component.tsx
import React6, { useEffect as useEffect5, useState as useState5 } from "react";
import {
  Box as Box6,
  HeadingText as HeadingText5,
  FormField as FormField3,
  TextInput as TextInput3,
  StackLayout as StackLayout5,
  UtilityText as UtilityText5
} from "@leagueplatform/genesis-core";
function MedicationInformation(props) {
  const { errorHandling, nextButtonClicked } = props;
  const [form, setForm] = useState5({
    medicationName: "",
    reasonForMedication: ""
  });
  const [errors, setErrors] = useState5({
    medicationName: false,
    reasonForMedication: false
  });
  const formField = isEmpty(form.medicationName) || isEmpty(form.reasonForMedication);
  const isValid = isNotEmpty(form.medicationName) && isNotEmpty(form.reasonForMedication);
  useEffect5(() => {
    if (formField) {
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  }, [formField, errorHandling]);
  useEffect5(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          medicationName: isEmpty(form.medicationName),
          reasonForMedication: isEmpty(form.reasonForMedication)
        });
      }
    }
  }, [nextButtonClicked, isValid, form]);
  const updateErrorState = (value, id) => {
    const nextErrorState = __spreadProps(__spreadValues({}, errors), {
      [id]: isEmpty(value)
    });
    setErrors(nextErrorState);
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    const nextFormState = __spreadProps(__spreadValues({}, form), {
      [id]: /^\s/.test(value) ? "" : isAlphaNumbericWithSpace(value)
    });
    setForm(nextFormState);
    updateErrorState(event.target.value, event.target.id);
  };
  useEffect5(() => {
    const medicationInfo = JSON.parse(
      sessionStorage.getItem("formData") || "{}"
    );
    if (medicationInfo) {
      setForm({
        medicationName: medicationInfo == null ? void 0 : medicationInfo.medicationName,
        reasonForMedication: medicationInfo == null ? void 0 : medicationInfo.reasonForMedication
      });
    }
  }, []);
  useEffect5(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  const onBlurField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  const onKeyPressField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  return /* @__PURE__ */ React6.createElement(
    StackLayout5,
    {
      horizontalAlignment: "center",
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      }
    },
    /* @__PURE__ */ React6.createElement(
      Box6,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $four $one $four"
        }
      },
      /* @__PURE__ */ React6.createElement(
        HeadingText5,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Medication Exception Request Form"
      ),
      /* @__PURE__ */ React6.createElement(
        Box6,
        {
          css: {
            marginTop: "$two",
            marginBottom: "$one"
          }
        },
        /* @__PURE__ */ React6.createElement(
          HeadingText5,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 3: Medication Information"
        )
      ),
      /* @__PURE__ */ React6.createElement(
        Box6,
        {
          css: {
            display: "flex"
          }
        },
        /* @__PURE__ */ React6.createElement(UtilityText5, null, "Enter the medication name that you are requesting coverage for.")
      ),
      /* @__PURE__ */ React6.createElement(Box6, null, /* @__PURE__ */ React6.createElement(
        Box6,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React6.createElement(
          FormField3,
          {
            id: "medicationName",
            label: "Medication Name",
            statusIconLabel: "Error",
            inputStatus: errors.medicationName ? "error" : void 0,
            statusMessage: errors.medicationName ? "Your medication name is required." : ""
          },
          /* @__PURE__ */ React6.createElement(
            TextInput3,
            {
              name: "medicationName",
              value: form.medicationName,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React6.createElement(
        Box6,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $five $one"
          }
        },
        /* @__PURE__ */ React6.createElement(
          FormField3,
          {
            id: "reasonForMedication",
            label: "Diagnosis/Reason for Medication",
            statusIconLabel: "Error",
            inputStatus: errors.reasonForMedication ? "error" : void 0,
            statusMessage: errors.reasonForMedication ? "Diagnosis/reason for medication is required." : ""
          },
          /* @__PURE__ */ React6.createElement(
            "textarea",
            {
              rows: 10,
              cols: 62,
              maxLength: 550,
              name: "reasonForMedication",
              value: form.reasonForMedication,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              placeholder: "Diagnosis/reason for Medication",
              style: {
                borderColor: errors.reasonForMedication ? "#A12127" : "",
                resize: "none",
                fontSize: "14px",
                fontWeight: "400px",
                fontFamily: "BlinkMacSystemFont,-apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
                lineHeight: "20px",
                letterSpacing: 0,
                borderRadius: "6px",
                padding: "12px 16px",
                color: "#2C3135",
                border: "1px solid #949494"
              }
            }
          ),
          /* @__PURE__ */ React6.createElement("br", null),
          /* @__PURE__ */ React6.createElement(
            UtilityText5,
            {
              css: {
                fontStyle: "italic",
                fontSize: "14px",
                float: "right",
                fontFamily: "BlinkMacSystemFont,-apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
                color: "#2C3135"
              }
            },
            form.reasonForMedication ? form.reasonForMedication.length : 0,
            "/550"
          )
        )
      ))
    )
  );
}

// src/components/forms/layout/errorModal.tsx
import React7, { useEffect as useEffect6 } from "react";
import { handleStaticAsset as handleStaticAsset4 } from "@leagueplatform/asset-config";
import {
  Box as Box7,
  StackLayout as StackLayout6,
  Modal as Modal2,
  ParagraphText as ParagraphText2,
  UtilityText as UtilityText6,
  HeadingText as HeadingText6,
  Button as Button2
} from "@leagueplatform/genesis-core";
function ErrorModal(props) {
  const { onClose } = props;
  useEffect6(() => {
    var _a;
    (_a = document.getElementById("errorBtn")) == null ? void 0 : _a.click();
  }, []);
  return /* @__PURE__ */ React7.createElement(Modal2.Root, null, /* @__PURE__ */ React7.createElement(Modal2.Trigger, null, /* @__PURE__ */ React7.createElement(Modal2.Trigger, null, /* @__PURE__ */ React7.createElement(
    Button2,
    {
      id: "errorBtn",
      css: {
        visibility: "hidden"
      }
    },
    "Open Error Modal"
  ))), /* @__PURE__ */ React7.createElement(
    Modal2.Content,
    {
      showCloseButton: false,
      padding: "$none",
      width: { "@initial": 650, "@mobile": "100%" },
      onInteractOutside: (e) => e.preventDefault()
    },
    /* @__PURE__ */ React7.createElement(
      StackLayout6,
      {
        css: { textAlign: "center", padding: "$three $three" },
        horizontalAlignment: "stretch"
      },
      /* @__PURE__ */ React7.createElement(
        Box7,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }
        },
        " ",
        /* @__PURE__ */ React7.createElement(
          "img",
          {
            src: handleStaticAsset4(
              "ATTENTION_ICON" /* ATTENTION_ICON */
            ),
            alt: "right arrow icon",
            width: "40px"
          }
        )
      ),
      /* @__PURE__ */ React7.createElement(Modal2.Title, null, /* @__PURE__ */ React7.createElement(
        HeadingText6,
        {
          level: "display",
          size: "sm",
          css: { padding: "$oneAndHalf $none" }
        },
        "Oops! Something went wrong."
      )),
      /* @__PURE__ */ React7.createElement(ParagraphText2, { emphasis: "subtle" }, "We\u2019re sorry, but an unexpected error has occured"),
      /* @__PURE__ */ React7.createElement(ParagraphText2, { emphasis: "subtle" }, "Please try again"),
      /* @__PURE__ */ React7.createElement(
        Box7,
        {
          css: {
            display: "flex",
            flexDirection: "row",
            padding: "$two $four $one $four",
            justifyContent: "space-around"
          }
        },
        /* @__PURE__ */ React7.createElement(
          UtilityText6,
          {
            css: {
              color: "#0074C9",
              cursor: "pointer"
            },
            onClick: onClose
          },
          "OK"
        )
      )
    )
  ));
}

// src/components/forms/forms-type/medication/medication-forms.component.tsx
function MedicationForm(props) {
  const { closeForm } = props;
  const apiData = useFetchProfileData()[0];
  const errMsg = useFetchProfileData()[1];
  const [isErrorHandling, setErrorHandling] = useState6(false);
  const [isValidateForm, setIsValidateForm] = useState6(false);
  useEffect7(() => {
    emptyStorage();
  }, []);
  const componentList = [
    /* @__PURE__ */ React8.createElement(
      MemberInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData
      }
    ),
    /* @__PURE__ */ React8.createElement(
      PrescriberInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val)
      }
    ),
    /* @__PURE__ */ React8.createElement(
      MedicationInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val)
      }
    )
  ];
  return /* @__PURE__ */ React8.createElement(
    StackLayout7,
    {
      horizontalAlignment: "center",
      css: { position: "relative", minHeight: "100vh" }
    },
    apiData && /* @__PURE__ */ React8.createElement(
      FooterMultiStepProgress,
      {
        list: componentList,
        handleFormOrNext: isErrorHandling,
        isValidateForm: (val) => setIsValidateForm(val),
        closeForm,
        formName: "medicationexception" /* MEDICATION_EXCEPTION */
      }
    ),
    errMsg && /* @__PURE__ */ React8.createElement(ErrorModal, { onClose: closeForm }),
    !apiData && !errMsg && /* @__PURE__ */ React8.createElement(
      Spinner,
      {
        loading: !apiData,
        loadingText: "Fetching the online form data!",
        size: "40px"
      }
    )
  );
}

// src/components/forms/forms-type/steptherapy/step-therapy-forms.component.tsx
import React12, { useEffect as useEffect11, useState as useState10 } from "react";
import { StackLayout as StackLayout11, Spinner as Spinner2 } from "@leagueplatform/genesis-core";

// src/components/forms/forms-type/steptherapy/pages/member-information.component.tsx
import React9, { useEffect as useEffect8, useState as useState7 } from "react";
import { format as format3 } from "date-fns";
import {
  Box as Box8,
  HeadingText as HeadingText7,
  FormField as FormField4,
  TextInput as TextInput4,
  Select as Select3,
  StackLayout as StackLayout8,
  UtilityText as UtilityText7
} from "@leagueplatform/genesis-core";
function MemberInformation2(props) {
  var _a, _b, _c, _d, _e;
  const { errorHandling, nextButtonClicked, profileResponseData } = props;
  const [otherPhNumError, setOtherPhNumError] = useState7("");
  const [isOtherPhone, setIsOtherPhone] = useState7(false);
  const [form, setForm] = useState7({
    memberName: "",
    memberId: (_a = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a.memberId,
    dateOfBirth: (_b = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _b.dateOfBirth,
    phoneNumber: "",
    otherPhoneNumber: "",
    dependents: []
  });
  const [errors, setErrors] = useState7({
    otherPhoneNumber: false
  });
  const formField = isEmpty(form.otherPhoneNumber) || isValidatePhoneLength(form.otherPhoneNumber);
  const isValid = isNotEmpty(form.otherPhoneNumber);
  useEffect8(() => {
    if (formField && isOtherPhone) {
      errorHandling(false);
      if (isEmpty(form.otherPhoneNumber)) {
        setOtherPhNumError(
          "Your phone number is required to process this request."
        );
      } else if (isValidatePhoneLength(form.otherPhoneNumber)) {
        setOtherPhNumError("Enter a valid phone number.");
      } else {
        setOtherPhNumError("");
      }
    } else {
      errorHandling(true);
    }
  }, [formField, isOtherPhone, errorHandling, form.otherPhoneNumber]);
  useEffect8(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          otherPhoneNumber: isEmpty(form.otherPhoneNumber) || isValidatePhoneLength(form.otherPhoneNumber)
        });
      }
    }
  }, [nextButtonClicked, isValid, form.otherPhoneNumber]);
  const updateErrorState = (value, id) => {
    if (id === "otherPhoneNumber") {
      if (isEmpty(form.otherPhoneNumber)) {
        setOtherPhNumError(
          "Your phone number is required to process this request."
        );
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          otherPhoneNumber: true
        }));
      } else if (isValidatePhoneLength(value)) {
        setOtherPhNumError("Enter a valid phone number.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          otherPhoneNumber: true
        }));
      } else {
        setOtherPhNumError("");
      }
    }
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    const nextFormState = __spreadProps(__spreadValues({}, form), {
      [id]: value
    });
    setForm(nextFormState);
    updateErrorState(value, id);
    if (id === "otherPhoneNumber") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        otherPhoneNumber: isNoSpace(value) ? "" : formatPhoneNumber(value)
      }));
    }
    if (id === "phoneNumber") {
      setIsOtherPhone(event.target.value === "Other" /* OTHERS */);
      if (event.target.value !== "Other" /* OTHERS */) {
        setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
          otherPhoneNumber: ""
        }));
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          otherPhoneNumber: false
        }));
      }
    }
  };
  useEffect8(() => {
    var _a2, _b2, _c2, _d2, _e2;
    if (form.memberName && ((_a2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a2.dependents) !== null) {
      const dependentsUser = (_b2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _b2.dependents.map(
        (option) => ({
          name: `${option.firstName} ${option.lastName}`,
          dateOfBirth: `${option.dateOfBirth}`
        })
      );
      const mainUser = {
        name: `${(_c2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _c2.firstName} ${(_d2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _d2.lastName}`,
        dateOfBirth: `${(_e2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _e2.dateOfBirth}`
      };
      dependentsUser == null ? void 0 : dependentsUser.unshift(mainUser);
      const selectedUser = dependentsUser == null ? void 0 : dependentsUser.find(
        (o) => o.name === form.memberName
      );
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        dateOfBirth: selectedUser.dateOfBirth,
        dependents: dependentsUser
      }));
    }
  }, [form.memberName, profileResponseData]);
  useEffect8(() => {
    var _a2, _b2, _c2, _d2, _e2;
    const memberInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (memberInfo) {
      setForm({
        memberName: (memberInfo == null ? void 0 : memberInfo.memberName) ? memberInfo == null ? void 0 : memberInfo.memberName : `${(_a2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a2.firstName} ${(_b2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _b2.lastName}`,
        memberId: (memberInfo == null ? void 0 : memberInfo.memberId) ? memberInfo == null ? void 0 : memberInfo.memberId : (_c2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _c2.memberId,
        dateOfBirth: (memberInfo == null ? void 0 : memberInfo.dateOfBirth) ? format3(new Date(memberInfo == null ? void 0 : memberInfo.dateOfBirth), "MM/dd/yyyy") : format3(
          new Date((_d2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _d2.dateOfBirth),
          "MM/dd/yyyy"
        ),
        phoneNumber: (memberInfo == null ? void 0 : memberInfo.phoneNumber) ? memberInfo == null ? void 0 : memberInfo.phoneNumber : (_e2 = phoneNumberOption(profileResponseData)[0]) == null ? void 0 : _e2.value,
        otherPhoneNumber: memberInfo == null ? void 0 : memberInfo.otherPhoneNumber,
        dependents: memberInfo == null ? void 0 : memberInfo.dependents
      });
    }
  }, [profileResponseData]);
  useEffect8(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  useEffect8(() => {
    if (form.phoneNumber === "Other" /* OTHERS */) {
      setIsOtherPhone(true);
    } else {
      setIsOtherPhone(false);
    }
  }, [form]);
  const onBlurField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  const onKeyPressField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  return /* @__PURE__ */ React9.createElement(
    StackLayout8,
    {
      horizontalAlignment: "center",
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      }
    },
    /* @__PURE__ */ React9.createElement(
      Box8,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $four $one $four"
        }
      },
      /* @__PURE__ */ React9.createElement(
        HeadingText7,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Step Therapy Exception Request Form"
      )
    ),
    /* @__PURE__ */ React9.createElement(
      Box8,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$none $two",
          width: "100%"
        }
      },
      /* @__PURE__ */ React9.createElement(
        Box8,
        {
          css: {
            backgroundColor: "#F8F8F8",
            padding: "$one $two"
          }
        },
        /* @__PURE__ */ React9.createElement(
          HeadingText7,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Form Instructions:"
        ),
        /* @__PURE__ */ React9.createElement(
          Box8,
          {
            css: {
              marginTop: "$one",
              paddingLeft: "$one"
            }
          },
          /* @__PURE__ */ React9.createElement(UtilityText7, null, /* @__PURE__ */ React9.createElement("ol", null, /* @__PURE__ */ React9.createElement("li", { key: "1" }, "1. Complete all the required fields to submit."), /* @__PURE__ */ React9.createElement("li", { key: "2" }, "2. All fields are required unless listed as optional.")))
        )
      )
    ),
    /* @__PURE__ */ React9.createElement(
      Box8,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$two $four $three $four",
          width: "100%"
        }
      },
      /* @__PURE__ */ React9.createElement(
        Box8,
        {
          css: {
            display: "flex"
          }
        },
        /* @__PURE__ */ React9.createElement(
          HeadingText7,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 1: Member Information"
        )
      ),
      /* @__PURE__ */ React9.createElement(Box8, null, /* @__PURE__ */ React9.createElement(
        Box8,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        ((_c = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _c.dependents) || form.dependents ? /* @__PURE__ */ React9.createElement(FormField4, { id: "memberName", label: "Member Name" }, /* @__PURE__ */ React9.createElement(
          Select3,
          {
            options: memberNameOption(profileResponseData),
            onChange: onUpdateField,
            value: form.memberName
          }
        )) : /* @__PURE__ */ React9.createElement(FormField4, { id: "memberName", label: "Member Name" }, /* @__PURE__ */ React9.createElement(
          TextInput4,
          {
            disabled: true,
            value: `${(_d = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _d.firstName} ${(_e = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _e.lastName}`
          }
        ))
      ), /* @__PURE__ */ React9.createElement(
        Box8,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React9.createElement(FormField4, { id: "memberId", label: "Member ID" }, /* @__PURE__ */ React9.createElement(TextInput4, { disabled: true, value: form.memberId }))
      ), /* @__PURE__ */ React9.createElement(
        Box8,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React9.createElement(FormField4, { id: "dateOfBirth", label: "Date of Birth (MM/DD/YYYY)" }, /* @__PURE__ */ React9.createElement(
          TextInput4,
          {
            disabled: true,
            value: form.dateOfBirth ? format3(new Date(form.dateOfBirth), "MM/dd/yyyy") : form.dateOfBirth
          }
        ))
      ), /* @__PURE__ */ React9.createElement(
        Box8,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React9.createElement(FormField4, { id: "phoneNumber", label: "Phone Number" }, /* @__PURE__ */ React9.createElement(
          Select3,
          {
            options: phoneNumberOption(profileResponseData),
            onChange: onUpdateField,
            value: form.phoneNumber
          }
        ))
      ), isOtherPhone && /* @__PURE__ */ React9.createElement(
        Box8,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React9.createElement(
          FormField4,
          {
            id: "otherPhoneNumber",
            label: "Other Phone Number",
            inputStatus: errors.otherPhoneNumber ? "error" : void 0,
            statusIconLabel: errors.otherPhoneNumber ? "Error" : "",
            statusMessage: errors.otherPhoneNumber ? otherPhNumError : ""
          },
          /* @__PURE__ */ React9.createElement(
            TextInput4,
            {
              onChange: onUpdateField,
              value: form.otherPhoneNumber,
              maxLength: 14,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ))
    )
  );
}

// src/components/forms/forms-type/steptherapy/pages/prescriber-information.component.tsx
import React10, { useEffect as useEffect9, useState as useState8 } from "react";
import {
  Box as Box9,
  HeadingText as HeadingText8,
  FormField as FormField5,
  TextInput as TextInput5,
  StackLayout as StackLayout9,
  UtilityText as UtilityText8
} from "@leagueplatform/genesis-core";
function PrescriberInformation2(props) {
  const intialValue = {
    prescriberName: "",
    prescriberPhoneNumber: ""
  };
  const { errorHandling, nextButtonClicked } = props;
  const [phNumError, setPhNumError] = useState8("");
  const [form, setForm] = useState8(intialValue);
  const [errors, setErrors] = useState8({
    prescriberName: false,
    prescriberPhoneNumber: false
  });
  const formField = isEmpty(form.prescriberName) || isEmpty(form.prescriberPhoneNumber) || isValidatePhoneLength(form.prescriberPhoneNumber);
  const isValid = isNotEmpty(form.prescriberName) && isNotEmpty(form.prescriberPhoneNumber) && !isValidatePhoneLength(form.prescriberPhoneNumber);
  useEffect9(() => {
    if (formField) {
      errorHandling(false);
      if (isEmpty(form.prescriberPhoneNumber)) {
        setPhNumError("Your prescriber's phone number is required.");
      } else if (isValidatePhoneLength(form.prescriberPhoneNumber)) {
        setPhNumError("Enter a valid phone number.");
      } else {
        setPhNumError("");
      }
    } else {
      errorHandling(true);
    }
  }, [formField, errorHandling, form]);
  useEffect9(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          prescriberName: isEmpty(form.prescriberName),
          prescriberPhoneNumber: isEmpty(form.prescriberPhoneNumber) || isValidatePhoneLength(form.prescriberPhoneNumber)
        });
      }
    }
  }, [nextButtonClicked, form, isValid]);
  const updateErrorState = (value, id) => {
    if (id === "prescriberPhoneNumber") {
      if (isValidatePhoneLength(value)) {
        setPhNumError("Enter a valid phone number.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          prescriberPhoneNumber: true
        }));
      } else if (isEmpty(value)) {
        setPhNumError("Your prescriber's phone number is required.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          prescriberPhoneNumber: true
        }));
      } else {
        setPhNumError("");
      }
    } else if (id === "prescriberName") {
      setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
        prescriberName: isEmpty(value)
      }));
    }
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    if (id === "prescriberName") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        prescriberName: isNoSpace(value) ? "" : isAlphaNumbericWithSpace(value)
      }));
    }
    if (id === "prescriberPhoneNumber") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        prescriberPhoneNumber: isNoSpace(value) ? "" : formatPhoneNumber(value)
      }));
    }
    updateErrorState(value, id);
  };
  useEffect9(() => {
    const prescriberInfo = JSON.parse(
      sessionStorage.getItem("formData") || "{}"
    );
    if (prescriberInfo) {
      setForm({
        prescriberName: prescriberInfo == null ? void 0 : prescriberInfo.prescriberName,
        prescriberPhoneNumber: prescriberInfo == null ? void 0 : prescriberInfo.prescriberPhoneNumber
      });
    }
  }, []);
  useEffect9(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  const onBlurField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  const onKeyPressField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  return /* @__PURE__ */ React10.createElement(
    StackLayout9,
    {
      horizontalAlignment: "center",
      css: {
        backgroundColor: "White",
        width: "800px",
        height: "75vh",
        marginLeft: "70px"
      }
    },
    /* @__PURE__ */ React10.createElement(
      Box9,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $four $one $four"
        }
      },
      /* @__PURE__ */ React10.createElement(
        HeadingText8,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Step Therapy Exception Request Form"
      ),
      /* @__PURE__ */ React10.createElement(
        Box9,
        {
          css: {
            marginTop: "$two",
            marginBottom: "$one"
          }
        },
        /* @__PURE__ */ React10.createElement(
          HeadingText8,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 2: Prescriber Information"
        )
      ),
      /* @__PURE__ */ React10.createElement(
        Box9,
        {
          css: {
            display: "flex"
          }
        },
        /* @__PURE__ */ React10.createElement(UtilityText8, null, "Enter your doctor", `'`, "s information below.")
      ),
      /* @__PURE__ */ React10.createElement(Box9, null, /* @__PURE__ */ React10.createElement(
        Box9,
        {
          css: {
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React10.createElement(
          FormField5,
          {
            id: "prescriberName",
            label: "Prescriber Name",
            statusIconLabel: "Error",
            inputStatus: errors.prescriberName ? "error" : void 0,
            statusMessage: errors.prescriberName ? "Your prescriber's name is required." : ""
          },
          /* @__PURE__ */ React10.createElement(
            TextInput5,
            {
              name: "prescriberName",
              value: form.prescriberName,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React10.createElement(
        Box9,
        {
          css: {
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React10.createElement(
          FormField5,
          {
            id: "prescriberPhoneNumber",
            label: "Phone Number",
            statusIconLabel: "Error",
            inputStatus: errors.prescriberPhoneNumber ? "error" : void 0,
            statusMessage: errors.prescriberPhoneNumber ? phNumError : ""
          },
          /* @__PURE__ */ React10.createElement(
            TextInput5,
            {
              name: "prescriberPhoneNumber",
              value: form.prescriberPhoneNumber,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 14
            }
          )
        )
      ))
    )
  );
}

// src/components/forms/forms-type/steptherapy/pages/requested-drug.component.tsx
import React11, { useEffect as useEffect10, useState as useState9 } from "react";
import {
  Box as Box10,
  HeadingText as HeadingText9,
  FormField as FormField6,
  TextInput as TextInput6,
  StackLayout as StackLayout10,
  UtilityText as UtilityText9
} from "@leagueplatform/genesis-core";
function RequestedDrug(props) {
  const { errorHandling, nextButtonClicked } = props;
  const [form, setForm] = useState9({
    drugName: "",
    strength: "",
    quantity: "",
    explainYourRequest: ""
  });
  const [errors, setErrors] = useState9({
    drugName: false
  });
  const formField = isEmpty(form.drugName) || !isAlphaNumbericWithSpace(form.drugName);
  const isValid = isNotEmpty(form.drugName);
  useEffect10(() => {
    if (formField) {
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  }, [formField, errorHandling]);
  useEffect10(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          drugName: isEmpty(form.drugName) || !isAlphaNumbericWithSpace(form.drugName)
        });
      }
    }
  }, [nextButtonClicked, isValid, form]);
  const updateErrorState = (value, id) => {
    const nextErrorState = __spreadProps(__spreadValues({}, errors), {
      [id]: isEmpty(value)
    });
    setErrors(nextErrorState);
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    if (id === "quantity") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        quantity: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^0-9]+/gi, "")
      }));
    } else {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        [id]: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^a-zA-Z0-9 ]+/gi, "")
      }));
    }
    updateErrorState(value, id);
  };
  useEffect10(() => {
    const drugInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (drugInfo) {
      setForm({
        drugName: drugInfo == null ? void 0 : drugInfo.drugName,
        strength: drugInfo == null ? void 0 : drugInfo.strength,
        quantity: drugInfo == null ? void 0 : drugInfo.quantity,
        explainYourRequest: drugInfo == null ? void 0 : drugInfo.explainYourRequest
      });
    }
  }, []);
  useEffect10(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  const onBlurField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  const onKeyPressField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  return /* @__PURE__ */ React11.createElement(
    StackLayout10,
    {
      horizontalAlignment: "center",
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      }
    },
    /* @__PURE__ */ React11.createElement(
      Box10,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $four $one $four"
        }
      },
      /* @__PURE__ */ React11.createElement(
        HeadingText9,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Step Therapy Exception Request Form"
      ),
      /* @__PURE__ */ React11.createElement(
        Box10,
        {
          css: {
            marginTop: "$two",
            marginBottom: "$one"
          }
        },
        /* @__PURE__ */ React11.createElement(
          HeadingText9,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 3: Requested Drug"
        )
      ),
      /* @__PURE__ */ React11.createElement(Box10, null, /* @__PURE__ */ React11.createElement(
        Box10,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React11.createElement(
          FormField6,
          {
            id: "drugName",
            label: "Drug Name",
            statusIconLabel: "Error",
            inputStatus: errors.drugName ? "error" : void 0,
            statusMessage: errors.drugName ? "Drug name is required." : ""
          },
          /* @__PURE__ */ React11.createElement(
            TextInput6,
            {
              name: "drugName",
              value: form.drugName,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 100
            }
          )
        )
      ), /* @__PURE__ */ React11.createElement(
        Box10,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React11.createElement(FormField6, { id: "strength", label: "Strength (Optional)" }, /* @__PURE__ */ React11.createElement(
          TextInput6,
          {
            name: "strength",
            value: form.strength,
            onChange: onUpdateField,
            onBlur: onBlurField,
            onKeyPress: onKeyPressField,
            maxLength: 25
          }
        ))
      ), /* @__PURE__ */ React11.createElement(
        Box10,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one $none $none $one"
          }
        },
        /* @__PURE__ */ React11.createElement(FormField6, { id: "quantity", label: "Quantity (Optional)" }, /* @__PURE__ */ React11.createElement(
          TextInput6,
          {
            name: "quantity",
            value: form.quantity,
            onChange: onUpdateField,
            onBlur: onBlurField,
            onKeyPress: onKeyPressField,
            maxLength: 5
          }
        ))
      ), /* @__PURE__ */ React11.createElement(
        Box10,
        {
          css: {
            padding: "$one $none $five $one"
          }
        },
        /* @__PURE__ */ React11.createElement(
          FormField6,
          {
            id: "explainYourRequest",
            label: "Explain Your Request (Optional)"
          },
          /* @__PURE__ */ React11.createElement(
            "textarea",
            {
              rows: 10,
              cols: 65,
              maxLength: 250,
              name: "explainYourRequest",
              value: form.explainYourRequest,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              style: {
                resize: "none",
                fontSize: "14px",
                fontWeight: "400px",
                fontFamily: "BlinkMacSystemFont,-apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
                lineHeight: "20px",
                letterSpacing: 0,
                borderRadius: "6px",
                padding: "12px 16px",
                color: "#2C3135",
                border: "1px solid #949494"
              }
            }
          )
        ),
        /* @__PURE__ */ React11.createElement(
          UtilityText9,
          {
            css: {
              fontStyle: "italic",
              fontSize: "14px",
              float: "right",
              fontFamily: "BlinkMacSystemFont,-apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
              color: "#2C3135"
            }
          },
          form.explainYourRequest ? form.explainYourRequest.length : 0,
          "/250"
        )
      ))
    )
  );
}

// src/components/forms/forms-type/steptherapy/step-therapy-forms.component.tsx
function StepTherapyForm(props) {
  const { closeForm } = props;
  const apiData = useFetchProfileData()[0];
  const errMsg = useFetchProfileData()[1];
  const [isErrorHandling, setErrorHandling] = useState10(false);
  const [isValidateForm, setIsValidateForm] = useState10(false);
  useEffect11(() => {
    emptyStorage();
  }, []);
  const componentList = [
    /* @__PURE__ */ React12.createElement(
      MemberInformation2,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData
      }
    ),
    /* @__PURE__ */ React12.createElement(
      PrescriberInformation2,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val)
      }
    ),
    /* @__PURE__ */ React12.createElement(
      RequestedDrug,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val)
      }
    )
  ];
  return /* @__PURE__ */ React12.createElement(
    StackLayout11,
    {
      horizontalAlignment: "center",
      css: { position: "relative", minHeight: "100vh" }
    },
    apiData && /* @__PURE__ */ React12.createElement(
      FooterMultiStepProgress,
      {
        list: componentList,
        handleFormOrNext: isErrorHandling,
        isValidateForm: (val) => setIsValidateForm(val),
        closeForm,
        formName: "steptherapy" /* STEP_THERAPY */
      }
    ),
    errMsg && /* @__PURE__ */ React12.createElement(ErrorModal, { onClose: closeForm }),
    !apiData && !errMsg && /* @__PURE__ */ React12.createElement(
      Spinner2,
      {
        loading: !apiData,
        loadingText: "Fetching the online form data!",
        size: "40px"
      }
    )
  );
}

// src/components/forms/forms-type/dental/dentalClaim-forms.component.tsx
import React27, { useEffect as useEffect25, useState as useState21 } from "react";
import { StackLayout as StackLayout26, Spinner as Spinner4 } from "@leagueplatform/genesis-core";

// src/components/forms/hooks/useFetchPlanDetailsData.tsx
import { useEffect as useEffect12, useState as useState11 } from "react";
function useFetchPlanDetailsData(planType) {
  const [apiData, setApiData] = useState11(null);
  const [errMsg, setErrMsg] = useState11(null);
  const planDetailsKeys = JSON.parse(
    sessionStorage.getItem("planDetailsKeys") || "{}"
  );
  const planInfo = planDetailsKeys == null ? void 0 : planDetailsKeys.filter(
    (plan) => plan.planType === planType
  )[0];
  const { planYear, groupNumber, productNumber } = planInfo;
  const config = formsLibrary.getConfig();
  const { HIGHMARK_API_URL } = config;
  const url = `${HIGHMARK_API_URL}/members/benefits/plan/detail?planYear=${planYear}&groupNumber=${groupNumber}&planType=${planType}&productNumber=${productNumber}`;
  useEffect12(() => {
    getAccessToken(url).then((result) => {
      const planDetailsData = result == null ? void 0 : result.plan;
      const errData = result == null ? void 0 : result.errMsg;
      if (planDetailsData) {
        setApiData(result);
      } else if (errData) {
        setErrMsg(errData);
      }
    });
  }, [url]);
  return [apiData, errMsg];
}

// src/components/forms/forms-type/dental/pages/form-instructions.component.tsx
import React13 from "react";
import {
  Box as Box11,
  HeadingText as HeadingText10,
  StackLayout as StackLayout12,
  UtilityText as UtilityText10
} from "@leagueplatform/genesis-core";
function FormInstructions() {
  const instructionsList = [
    "1. Use a separate claim form for each patient.",
    "2. Enter full name, address and zip code when a name and address field is required.",
    "3. Attach any receipts, bills or supporting claim documentation you may have received from your dentist. You will not be able to submit the form without these attachments.",
    "4. All fields are required unless listed as optional."
  ];
  return /* @__PURE__ */ React13.createElement(
    StackLayout12,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React13.createElement(
      Box11,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $five $one $none",
          position: "relative",
          right: "60px"
        }
      },
      /* @__PURE__ */ React13.createElement(
        HeadingText10,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Member Dental Claim Form"
      )
    ),
    /* @__PURE__ */ React13.createElement(
      Box11,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$none $two $two $none"
          // width: '100%',
        }
      },
      /* @__PURE__ */ React13.createElement(
        Box11,
        {
          css: {
            backgroundColor: "#F8F8F8",
            padding: "$one $two $one $three"
          }
        },
        /* @__PURE__ */ React13.createElement(
          HeadingText10,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Form Instructions:"
        ),
        /* @__PURE__ */ React13.createElement(
          Box11,
          {
            css: {
              marginTop: "$one",
              paddingLeft: "$one",
              width: "600px"
            }
          },
          /* @__PURE__ */ React13.createElement(UtilityText10, null, /* @__PURE__ */ React13.createElement("ol", null, instructionsList.map((inst) => /* @__PURE__ */ React13.createElement("li", { key: inst }, inst))))
        ),
        /* @__PURE__ */ React13.createElement(
          Box11,
          {
            css: {
              marginTop: "$one",
              paddingLeft: "$one",
              width: "600px"
            }
          },
          /* @__PURE__ */ React13.createElement(UtilityText10, null, /* @__PURE__ */ React13.createElement("ul", { style: { listStyle: "disc" } }, "Itemized bill must include:", /* @__PURE__ */ React13.createElement("li", null, "Provider\u2019s name and address (on provider\u2019s stationary)"), /* @__PURE__ */ React13.createElement("li", null, "Patient\u2019s full name (no nicknames)"), /* @__PURE__ */ React13.createElement("li", null, "Type of service(s)"), /* @__PURE__ */ React13.createElement("li", null, "Date of each service, supply or purchase"), /* @__PURE__ */ React13.createElement("li", null, "Charge")))
        ),
        /* @__PURE__ */ React13.createElement(
          Box11,
          {
            css: {
              marginTop: "$one",
              paddingLeft: "$one",
              width: "600px"
            }
          },
          /* @__PURE__ */ React13.createElement(UtilityText10, null, "Note: Cancelled checks, cash register receipts and personal itemizations are not acceptable as itemized bills.")
        )
      )
    )
  );
}

// src/components/forms/forms-type/dental/pages/transactionType-information.component.tsx
import React14, { useEffect as useEffect13, useState as useState12 } from "react";
import {
  Box as Box12,
  HeadingText as HeadingText11,
  FormField as FormField7,
  TextInput as TextInput7,
  Select as Select4,
  StackLayout as StackLayout13,
  ParagraphText as ParagraphText3,
  Checkbox,
  Fieldset
} from "@leagueplatform/genesis-core";
function TransactionTypeInformation(props) {
  const { errorHandling } = props;
  const [form, setForm] = useState12({
    dentalPlanName: "United Concordia Dental",
    dentalPlanAddress1: "PO Box 69421",
    dentalPlanAddress2: "4401 Deer Path Road",
    dentalPlanCity: "Harrisburg",
    dentalPlanState: "PA",
    dentalPlanZipCode: "17110",
    statementOfServices: false,
    requestForPredetermination: false,
    earlyAndPeriodicScreening: false
  });
  const [isTransactionTypeError, setIsTransactionTypeError] = useState12(false);
  const [transactionTypeError, setTransactionTypeError] = useState12("");
  useEffect13(() => {
    if (form.statementOfServices || form.requestForPredetermination || form.earlyAndPeriodicScreening) {
      errorHandling(true);
      setIsTransactionTypeError(false);
      setTransactionTypeError("");
    } else {
      errorHandling(false);
      setIsTransactionTypeError(true);
      setTransactionTypeError("This selection is required.");
    }
  }, [errorHandling, form]);
  const onUpdate = (e) => {
    const { checked, id } = e.target;
    const nextFormState = __spreadProps(__spreadValues({}, form), {
      [id]: checked
    });
    setForm(nextFormState);
    setIsTransactionTypeError(false);
    setTransactionTypeError("");
  };
  useEffect13(() => {
    const pInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (pInfo) {
      setForm({
        dentalPlanName: (pInfo == null ? void 0 : pInfo.dentalPlanName) || "United Concordia Dental",
        dentalPlanAddress1: (pInfo == null ? void 0 : pInfo.dentalPlanAddress1) || "PO Box 69421",
        dentalPlanAddress2: (pInfo == null ? void 0 : pInfo.dentalPlanAddress2) || "4401 Deer Path Road",
        dentalPlanCity: (pInfo == null ? void 0 : pInfo.dentalPlanCity) || "Harrisburg",
        dentalPlanState: (pInfo == null ? void 0 : pInfo.dentalPlanState) || "PA",
        dentalPlanZipCode: (pInfo == null ? void 0 : pInfo.dentalPlanZipCode) || "17110",
        statementOfServices: (pInfo == null ? void 0 : pInfo.statementOfServices) || false,
        requestForPredetermination: (pInfo == null ? void 0 : pInfo.requestForPredetermination) || false,
        earlyAndPeriodicScreening: (pInfo == null ? void 0 : pInfo.earlyAndPeriodicScreening) || false
      });
    }
  }, []);
  useEffect13(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React14.createElement(
    StackLayout13,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React14.createElement(
      Box12,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $five $one $none",
          position: "relative",
          right: "48px"
        }
      },
      /* @__PURE__ */ React14.createElement(
        HeadingText11,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Member Dental Claim Form"
      )
    ),
    /* @__PURE__ */ React14.createElement(
      Box12,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$two $four $three $five"
        }
      },
      /* @__PURE__ */ React14.createElement(Box12, null, /* @__PURE__ */ React14.createElement(
        HeadingText11,
        {
          level: "3",
          size: {
            "@initial": "xl",
            "@mobile": "lg"
          }
        },
        "Step 1: Transaction Type"
      ), /* @__PURE__ */ React14.createElement(
        ParagraphText3,
        {
          css: {
            marginTop: "$one",
            width: "600px"
          }
        },
        /* @__PURE__ */ React14.createElement("p", null, "Please select the appropriate claim form.")
      )),
      /* @__PURE__ */ React14.createElement(
        Box12,
        {
          css: {
            marginBottom: "$one"
          }
        },
        /* @__PURE__ */ React14.createElement(
          Fieldset,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              width: "600px",
              padding: "$one $none"
            },
            legend: void 0,
            inputStatus: isTransactionTypeError ? "error" : void 0,
            statusMessage: transactionTypeError,
            id: "transactionType"
          },
          /* @__PURE__ */ React14.createElement(
            Checkbox,
            {
              id: "statementOfServices",
              name: "statementOfServcies",
              label: "Statement of actual services",
              checked: form.statementOfServices,
              onChange: (e) => onUpdate(e),
              hint: "If services have been performed, mark this box."
            }
          ),
          /* @__PURE__ */ React14.createElement(
            Checkbox,
            {
              id: "requestForPredetermination",
              name: "predeterminationRequest",
              label: "Request for Predetermination/Preauthorization",
              checked: form.requestForPredetermination,
              onChange: (e) => onUpdate(e),
              hint: "If there are no dates of service on receipts, mark this box."
            }
          ),
          /* @__PURE__ */ React14.createElement(
            Checkbox,
            {
              id: "earlyAndPeriodicScreening",
              name: "earlyAndPeriodicScreening",
              label: "Early and Periodic Screening, Diagnosis and Treatment Program/Title XIX",
              checked: form.earlyAndPeriodicScreening,
              onChange: (e) => onUpdate(e),
              hint: "If the claim is through EPSDT, mark this box."
            }
          )
        )
      ),
      /* @__PURE__ */ React14.createElement(Box12, null, /* @__PURE__ */ React14.createElement(
        HeadingText11,
        {
          level: "3",
          size: {
            "@initial": "xl",
            "@mobile": "lg"
          }
        },
        "Insurance Company/Dental Plan Information"
      ), /* @__PURE__ */ React14.createElement(
        Box12,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React14.createElement(FormField7, { id: "dentalPlanName", label: "Comapny/Plan Name" }, /* @__PURE__ */ React14.createElement(TextInput7, { disabled: true, value: form.dentalPlanName }))
      ), /* @__PURE__ */ React14.createElement(
        Box12,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React14.createElement(FormField7, { id: "dentalPlanAddress1", label: "Company Address Line 1" }, /* @__PURE__ */ React14.createElement(TextInput7, { disabled: true, value: form.dentalPlanAddress1 }))
      ), /* @__PURE__ */ React14.createElement(
        Box12,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React14.createElement(
          FormField7,
          {
            id: "dentalPlanAddress2",
            label: "Company Address Line 2 (Optional)"
          },
          /* @__PURE__ */ React14.createElement(TextInput7, { disabled: true, value: form.dentalPlanAddress2 })
        )
      ), /* @__PURE__ */ React14.createElement(
        Box12,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React14.createElement(FormField7, { id: "dentalPlanCity", label: "City" }, /* @__PURE__ */ React14.createElement(TextInput7, { disabled: true, value: form.dentalPlanCity }))
      ), /* @__PURE__ */ React14.createElement(
        Box12,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React14.createElement(FormField7, { id: "dentalPlanState", label: "State" }, /* @__PURE__ */ React14.createElement(
          Select4,
          {
            name: "dentalPlanState",
            options: stateOption(),
            placeholder: "Please Select",
            id: "dentalPlanState",
            value: form.dentalPlanState,
            disabled: true
          }
        ))
      ), /* @__PURE__ */ React14.createElement(
        Box12,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React14.createElement(FormField7, { id: "dentalPlanZipCode", label: "Zip Code" }, /* @__PURE__ */ React14.createElement(TextInput7, { disabled: true, value: form.dentalPlanZipCode }))
      ))
    )
  );
}

// src/components/forms/forms-type/dental/pages/policyholder-information.component.tsx
import React15, { useEffect as useEffect14, useState as useState13 } from "react";
import {
  Box as Box13,
  HeadingText as HeadingText12,
  FormField as FormField8,
  TextInput as TextInput8,
  Select as Select5,
  StackLayout as StackLayout14,
  ParagraphText as ParagraphText4,
  Fieldset as Fieldset2,
  Radio
} from "@leagueplatform/genesis-core";
import { format as format4 } from "date-fns";
function PolicyHolderInformation(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const { errorHandling, profileResponseData, planDetailsResponseData } = props;
  const [form, setForm] = useState13({
    memberName: `${(_a = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a.firstName} ${(_b = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _b.lastName}`,
    memberId: (_c = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _c.memberId,
    addressLine1: (_d = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _d.address.line1,
    addressLine2: (_e = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _e.address.line2,
    city: (_f = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _f.address.city,
    state: (_g = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _g.address.state,
    zipCode: (_h = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _h.address.postalCode,
    dateOfBirth: format4(
      new Date((_i = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _i.dateOfBirth),
      "MM/dd/yyyy"
    ),
    gender: (_j = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _j.gender,
    dependents: [],
    relationship: (_k = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _k.relationship
  });
  useEffect14(() => {
    errorHandling(true);
  }, [errorHandling]);
  useEffect14(() => {
    var _a2, _b2, _c2;
    if (((_a2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a2.dependents) !== null) {
      const dependents = (_b2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _b2.dependents;
      const members = (_c2 = planDetailsResponseData == null ? void 0 : planDetailsResponseData.plan) == null ? void 0 : _c2.members;
      const memberNames = members.map(
        (mem) => `${mem.firstName} ${mem.lastName}`
      );
      const dependentsData = dependents.filter(
        (dep) => memberNames.indexOf(`${dep.firstName} ${dep.lastName}`) > -1
      );
      const dependentsUser = dependentsData.map((option) => {
        var _a3, _b3, _c3, _d2, _e2;
        return {
          name: `${option.firstName} ${option.lastName}`,
          dateOfBirth: `${option.dateOfBirth}`,
          relationship: `${option.relationship}`,
          gender: `${option.gender}`,
          addressLine1: (_a3 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a3.address.line1,
          addressLine2: (_b3 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _b3.address.line2,
          city: (_c3 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _c3.address.city,
          state: (_d2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _d2.address.state,
          zipCode: (_e2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _e2.address.postalCode
        };
      });
      if (dependentsUser.length > 0) {
        setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
          dependents: dependentsUser,
          isPolicyHolderPatient: ""
        }));
      } else {
        setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
          dependents: dependentsUser,
          isPolicyHolderPatient: "YES"
        }));
      }
    }
  }, [planDetailsResponseData, profileResponseData]);
  useEffect14(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React15.createElement(
    StackLayout14,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React15.createElement(
      Box13,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $five $one $none",
          position: "relative",
          right: "48px"
        }
      },
      /* @__PURE__ */ React15.createElement(
        HeadingText12,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Member Dental Claim Form"
      )
    ),
    /* @__PURE__ */ React15.createElement(
      Box13,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$two $four $three $five"
        }
      },
      /* @__PURE__ */ React15.createElement(Box13, null, /* @__PURE__ */ React15.createElement(
        HeadingText12,
        {
          level: "3",
          size: {
            "@initial": "xl",
            "@mobile": "lg"
          }
        },
        "Step 2: Policy Holder Information"
      ), /* @__PURE__ */ React15.createElement(
        ParagraphText4,
        {
          css: {
            marginTop: "$one",
            width: "600px"
          }
        },
        /* @__PURE__ */ React15.createElement("p", null, "This is the policy holder's information on file. If you need to make updates, you can change your contact information in Account Settings. The information here will not affect your claims submission.")
      )),
      /* @__PURE__ */ React15.createElement(Box13, null, /* @__PURE__ */ React15.createElement(
        Box13,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React15.createElement(FormField8, { id: "memberName", label: "Member Name" }, /* @__PURE__ */ React15.createElement(TextInput8, { disabled: true, value: form.memberName }))
      ), /* @__PURE__ */ React15.createElement(
        Box13,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React15.createElement(FormField8, { id: "addressLine1", label: "Address Line 1" }, /* @__PURE__ */ React15.createElement(TextInput8, { disabled: true, value: form.addressLine1 }))
      ), /* @__PURE__ */ React15.createElement(
        Box13,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React15.createElement(FormField8, { id: "addressLine2", label: "Address Line 2 (Optional)" }, /* @__PURE__ */ React15.createElement(TextInput8, { disabled: true, value: form.addressLine2 }))
      ), /* @__PURE__ */ React15.createElement(
        Box13,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React15.createElement(FormField8, { id: "city", label: "City" }, /* @__PURE__ */ React15.createElement(TextInput8, { disabled: true, value: form.city }))
      ), /* @__PURE__ */ React15.createElement(
        Box13,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React15.createElement(FormField8, { id: "state", label: "State" }, /* @__PURE__ */ React15.createElement(
          Select5,
          {
            name: "state",
            options: stateOption(),
            placeholder: "Please Select",
            id: "state",
            value: form.state,
            disabled: true
          }
        ))
      ), /* @__PURE__ */ React15.createElement(
        Box13,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React15.createElement(FormField8, { id: "zipCode", label: "Zip Code" }, /* @__PURE__ */ React15.createElement(TextInput8, { disabled: true, value: form.zipCode }))
      ), /* @__PURE__ */ React15.createElement(
        Box13,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React15.createElement(FormField8, { id: "dateOfBirth", label: "Date of Birth (MM/DD/YYYY)" }, /* @__PURE__ */ React15.createElement(
          TextInput8,
          {
            disabled: true,
            value: format4(new Date(form.dateOfBirth), "MM/dd/yyyy")
          }
        ))
      ), /* @__PURE__ */ React15.createElement(
        Box13,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React15.createElement(FormField8, { id: "gender", label: "Gender" }, /* @__PURE__ */ React15.createElement(
          Fieldset2,
          {
            legend: "",
            css: {
              display: "flex",
              width: "436px",
              height: "24px"
            }
          },
          /* @__PURE__ */ React15.createElement(
            Radio,
            {
              id: "policyHolder-gender-1",
              name: form.gender,
              checked: form.gender === "M",
              disabled: true,
              value: "M",
              label: "MALE"
            }
          ),
          /* @__PURE__ */ React15.createElement(
            Radio,
            {
              id: "policyHolder-gender-2",
              name: form.gender,
              checked: form.gender === "F",
              disabled: true,
              value: "F",
              label: "FEMALE"
            }
          )
        ))
      ), /* @__PURE__ */ React15.createElement(
        Box13,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React15.createElement(FormField8, { id: "memberId", label: "Member ID" }, /* @__PURE__ */ React15.createElement(TextInput8, { disabled: true, value: form.memberId }))
      ))
    )
  );
}

// src/components/forms/forms-type/dental/pages/patient-information.component.tsx
import React16, { useEffect as useEffect15, useState as useState14 } from "react";
import {
  Box as Box14,
  HeadingText as HeadingText13,
  StackLayout as StackLayout15,
  ParagraphText as ParagraphText5,
  Radio as Radio2,
  Fieldset as Fieldset3,
  FormField as FormField9,
  TextInput as TextInput9,
  Select as Select6
} from "@leagueplatform/genesis-core";
import { format as format5 } from "date-fns";
function PatientInformation(props) {
  var _a;
  const { errorHandling, nextButtonClicked, profileResponseData } = props;
  const [policyHolderRelationship] = useState14(
    (_a = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a.relationship
  );
  const [isPolicyHolderPatient, setIsPolicyHolderPatient] = useState14("");
  const [form, setForm] = useState14({
    isPolicyHolderPatient: "",
    patientRelationship: "",
    patientName: "",
    patientAddressLine1: "",
    patientAddressLine2: "",
    patientCity: "",
    patientState: "",
    patientZipCode: "",
    patientDateOfBirth: "",
    patientGender: ""
  });
  const [planDetailsData, setPlanDetailsData] = useState14([]);
  const [isPolicyHolderError, setIsPolicyHolderError] = useState14(false);
  const [zipCodeError, setZipCodeError] = useState14("");
  const [errors, setErrors] = useState14({
    patientRelationship: false,
    patientName: false,
    patientAddressLine1: false,
    patientCity: false,
    patientState: false,
    patientZipCode: false,
    patientDateOfBirth: false,
    patientGender: false
  });
  const formField = isEmpty(form.patientRelationship) || isEmpty(form.patientName) || isEmpty(form.patientAddressLine1) || isEmpty(form.patientCity) || isEmpty(form.patientState) || isEmpty(form.patientZipCode) || isValidZipCodeLength(form.patientZipCode) || isEmpty(form.patientGender);
  const isValid = isNotEmpty(form.patientRelationship) && isNotEmpty(form.patientName) && isNotEmpty(form.patientAddressLine1) && isNotEmpty(form.patientCity) && isNotEmpty(form.patientState) && isNotEmpty(form.patientZipCode) && !isValidZipCodeLength(form.patientZipCode) && isNotEmpty(form.patientGender);
  useEffect15(() => {
    if (isPolicyHolderPatient === "YES") {
      errorHandling(true);
      setIsPolicyHolderError(false);
    } else if (isPolicyHolderPatient === "") {
      errorHandling(false);
      setIsPolicyHolderError(true);
    } else if (formField || errors.patientZipCode) {
      errorHandling(false);
      if (isEmpty(form.patientZipCode)) {
        setZipCodeError("This field is required.");
      } else if (isValidZipCodeLength(form.patientZipCode)) {
        setZipCodeError("Enter a valid zip code.");
      } else {
        setZipCodeError("");
      }
    } else {
      errorHandling(true);
    }
  }, [
    formField,
    errorHandling,
    form,
    isPolicyHolderPatient,
    errors.patientZipCode
  ]);
  useEffect15(() => {
    setErrors({
      patientRelationship: isEmpty(form.patientRelationship),
      patientName: isEmpty(form.patientName),
      patientAddressLine1: isEmpty(form.patientAddressLine1),
      patientCity: isEmpty(form.patientCity),
      patientState: isEmpty(form.patientState),
      patientZipCode: isEmpty(form.patientZipCode) || isValidZipCodeLength(form.patientZipCode),
      patientDateOfBirth: isEmpty(form.patientDateOfBirth),
      patientGender: isEmpty(form.patientGender)
    });
    setIsPolicyHolderError(isEmpty(isPolicyHolderPatient));
  }, [nextButtonClicked, isValid, form, isPolicyHolderPatient]);
  useEffect15(() => {
    const pInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (pInfo) {
      setForm({
        isPolicyHolderPatient: pInfo == null ? void 0 : pInfo.isPolicyHolderPatient,
        patientRelationship: pInfo == null ? void 0 : pInfo.patientRelationship,
        patientName: pInfo == null ? void 0 : pInfo.patientName,
        patientAddressLine1: pInfo == null ? void 0 : pInfo.patientAddressLine1,
        patientAddressLine2: pInfo == null ? void 0 : pInfo.patientAddressLine2,
        patientCity: pInfo == null ? void 0 : pInfo.patientCity,
        patientState: pInfo == null ? void 0 : pInfo.patientState,
        patientZipCode: pInfo == null ? void 0 : pInfo.patientZipCode,
        patientDateOfBirth: pInfo == null ? void 0 : pInfo.patientDateOfBirth,
        patientGender: pInfo == null ? void 0 : pInfo.patientGender
      });
      setPlanDetailsData(pInfo == null ? void 0 : pInfo.dependents);
      setIsPolicyHolderPatient(pInfo == null ? void 0 : pInfo.isPolicyHolderPatient);
    }
  }, []);
  const updateErrorState = (value, id) => {
    if (id === "patientZipCode") {
      if (isEmpty(value)) {
        setZipCodeError("This field is required.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          patientZipCode: true
        }));
      } else if (isValidZipCodeLength(value)) {
        setZipCodeError("Enter a valid zip code.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          patientZipCode: true
        }));
      } else {
        setZipCodeError("");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          patientZipCode: false
        }));
      }
    } else {
      const nextErrorState = __spreadProps(__spreadValues({}, errors), {
        [id]: isEmpty(value)
      });
      setErrors(nextErrorState);
    }
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    if (id === "patientRelationship") {
      const newFormState = __spreadProps(__spreadValues({}, form), {
        [id]: value,
        patientName: "",
        patientAddressLine1: "",
        patientAddressLine2: "",
        patientCity: "",
        patientState: "",
        patientZipCode: "",
        patientDateOfBirth: "",
        patientGender: ""
      });
      setForm(newFormState);
      updateErrorState(value, id);
    } else if (id === "patientName") {
      const selectedPatientObj = planDetailsData.filter(
        (patient) => patient.name === value
      )[0];
      const newFormState = __spreadProps(__spreadValues({}, form), {
        [id]: value,
        patientAddressLine1: selectedPatientObj.addressLine1,
        patientAddressLine2: selectedPatientObj.addressLine2,
        patientCity: selectedPatientObj.city,
        patientState: selectedPatientObj.state,
        patientZipCode: selectedPatientObj.zipCode,
        patientDateOfBirth: format5(
          new Date(selectedPatientObj.dateOfBirth),
          "MM/dd/yyyy"
        ),
        patientGender: selectedPatientObj.gender
      });
      setForm(newFormState);
      updateErrorState(value, id);
    } else {
      const nextFormState = __spreadProps(__spreadValues({}, form), {
        [id]: value
      });
      setForm(nextFormState);
      if (id !== "patientAddressLine12") {
        updateErrorState(value, id);
      }
    }
    if (id === "patientName") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        fullName: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^a-zA-Z0-9 ]+/gi, "")
      }));
    }
    if (id === "patientCity") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        patientCity: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^a-zA-Z ]+/gi, "")
      }));
    }
    if (id === "patientZipCode") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        patientZipCode: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^0-9]+/gi, "")
      }));
    }
  };
  const updateIsPolicyHolderPatient = (e) => {
    const { value, id } = e.target;
    if (value === "Yes") {
      setIsPolicyHolderPatient("YES");
      setIsPolicyHolderError(false);
      const nextFormState = {
        isPolicyHolderPatient: "YES",
        patientRelationship: "",
        patientName: "",
        patientAddressLine1: "",
        patientAddressLine2: "",
        patientCity: "",
        patientState: "",
        patientZipCode: "",
        patientDateOfBirth: "",
        patientGender: ""
      };
      setForm(nextFormState);
    } else {
      setIsPolicyHolderPatient("NO");
      setIsPolicyHolderError(false);
      const nextFormState = {
        isPolicyHolderPatient: "NO",
        patientRelationship: "",
        patientName: "",
        patientAddressLine1: "",
        patientAddressLine2: "",
        patientCity: "",
        patientState: "",
        patientZipCode: "",
        patientDateOfBirth: "",
        patientGender: ""
      };
      setForm(nextFormState);
    }
    updateErrorState(value, id);
  };
  const patientRelationshipOption = (patientData) => {
    const patientObj = {
      value: "",
      label: ""
    };
    const relationshipArrData = patientData.map((pat) => pat.relationship).filter((rel) => rel !== "Subscriber");
    const filteredRelationshipArrData = [...new Set(relationshipArrData)];
    const patientRelationshipData = filteredRelationshipArrData.map(
      (rel) => ({
        value: rel,
        label: rel
      })
    );
    patientRelationshipData == null ? void 0 : patientRelationshipData.unshift(patientObj);
    return patientRelationshipData;
  };
  const patientNameOption = (patientRelationship, patientData) => {
    const patientNames = patientData.filter((patient) => patient.relationship === patientRelationship).map((patient) => patient.name);
    const patientNameData = patientNames.map((patient) => ({
      value: patient,
      label: patient
    }));
    const patientObj = {
      value: "",
      label: ""
    };
    patientNameData.unshift(patientObj);
    return patientNameData;
  };
  const onBlurField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  const onKeyPressField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  useEffect15(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React16.createElement(
    StackLayout15,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React16.createElement(
      Box14,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $five $one $none",
          position: "relative",
          right: "48px"
        }
      },
      /* @__PURE__ */ React16.createElement(
        HeadingText13,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Member Dental Claim Form"
      )
    ),
    /* @__PURE__ */ React16.createElement(
      Box14,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$two $four $three $five"
        }
      },
      /* @__PURE__ */ React16.createElement(Box14, null, /* @__PURE__ */ React16.createElement(
        HeadingText13,
        {
          level: "3",
          size: {
            "@initial": "xl",
            "@mobile": "lg"
          }
        },
        "Step 3: Patient Information"
      ), /* @__PURE__ */ React16.createElement(
        ParagraphText5,
        {
          css: {
            marginTop: "$one",
            width: "600px"
          }
        },
        "Is the policy holder the patient?"
      ), /* @__PURE__ */ React16.createElement(
        Fieldset3,
        {
          css: {
            display: "flex",
            width: "436px",
            height: "24px"
          },
          legend: void 0
        },
        /* @__PURE__ */ React16.createElement(
          Radio2,
          {
            id: "isPolicyHolderPatient-1",
            name: "isPolicyHolderPatient",
            checked: policyHolderRelationship === "Subscriber" && planDetailsData.length === 0 || isPolicyHolderPatient === "YES",
            disabled: policyHolderRelationship !== "Subscriber",
            value: "Yes" /* YES */,
            label: "Yes" /* YES */,
            onChange: (e) => updateIsPolicyHolderPatient(e)
          }
        ),
        /* @__PURE__ */ React16.createElement(
          Radio2,
          {
            id: "isPolicyHolderPatient-2",
            name: "isPolicyHolderPatient",
            checked: policyHolderRelationship !== "Subscriber" || isPolicyHolderPatient === "NO",
            disabled: policyHolderRelationship === "Subscriber" && planDetailsData.length === 0,
            value: "No" /* NO */,
            label: "No" /* NO */,
            onChange: (e) => updateIsPolicyHolderPatient(e)
          }
        )
      ), isPolicyHolderError && /* @__PURE__ */ React16.createElement(
        "p",
        {
          style: {
            color: "red",
            paddingTop: "10px",
            fontSize: "12px",
            margin: "0"
          }
        },
        "This field is required."
      )),
      (policyHolderRelationship !== "Subscriber" || isPolicyHolderPatient === "NO") && /* @__PURE__ */ React16.createElement(
        Box14,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            padding: "$two $none"
          }
        },
        /* @__PURE__ */ React16.createElement(
          Box14,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "$one"
            }
          },
          /* @__PURE__ */ React16.createElement(
            FormField9,
            {
              id: "patientRelationship",
              label: "Patient's Relationship to Policy Holder",
              statusIconLabel: "Error",
              inputStatus: errors.patientRelationship ? "error" : void 0,
              statusMessage: errors.patientRelationship ? "This field is required." : ""
            },
            /* @__PURE__ */ React16.createElement(
              Select6,
              {
                options: patientRelationshipOption(planDetailsData),
                onChange: onUpdateField,
                value: form.patientRelationship
              }
            )
          )
        ),
        /* @__PURE__ */ React16.createElement(
          Box14,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "$one"
            }
          },
          /* @__PURE__ */ React16.createElement(
            FormField9,
            {
              id: "patientName",
              label: "Patient Name",
              statusIconLabel: "Error",
              inputStatus: errors.patientName ? "error" : void 0,
              statusMessage: errors.patientName ? "This field is required." : ""
            },
            /* @__PURE__ */ React16.createElement(
              Select6,
              {
                options: patientNameOption(
                  form.patientRelationship,
                  planDetailsData
                ),
                onChange: onUpdateField,
                value: form.patientName
              }
            )
          )
        ),
        /* @__PURE__ */ React16.createElement(
          Box14,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "$one"
            }
          },
          /* @__PURE__ */ React16.createElement(
            FormField9,
            {
              id: "patientAddressLine1",
              label: "Address Line 1",
              statusIconLabel: "Error",
              inputStatus: errors.patientAddressLine1 ? "error" : void 0,
              statusMessage: errors.patientAddressLine1 ? "This field is required." : ""
            },
            /* @__PURE__ */ React16.createElement(
              TextInput9,
              {
                name: "patientAddressLine1",
                value: form.patientAddressLine1,
                onChange: onUpdateField,
                maxLength: 50,
                onBlur: onBlurField,
                onKeyPress: onKeyPressField
              }
            )
          )
        ),
        /* @__PURE__ */ React16.createElement(
          Box14,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "$one"
            }
          },
          /* @__PURE__ */ React16.createElement(
            FormField9,
            {
              id: "patientAddressLine2",
              label: "Address Line 2 (Optional)"
            },
            /* @__PURE__ */ React16.createElement(
              TextInput9,
              {
                name: "patientAddressLine2",
                value: form.patientAddressLine2,
                onChange: onUpdateField,
                maxLength: 50,
                onBlur: onBlurField,
                onKeyPress: onKeyPressField
              }
            )
          )
        ),
        /* @__PURE__ */ React16.createElement(
          Box14,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "$one"
            }
          },
          /* @__PURE__ */ React16.createElement(
            FormField9,
            {
              id: "patientCity",
              label: "City",
              statusIconLabel: "Error",
              inputStatus: errors.patientCity ? "error" : void 0,
              statusMessage: errors.patientCity ? "This field is required." : ""
            },
            /* @__PURE__ */ React16.createElement(
              TextInput9,
              {
                name: "patientCity",
                value: form.patientCity,
                onChange: onUpdateField,
                maxLength: 50,
                onBlur: onBlurField,
                onKeyPress: onKeyPressField
              }
            )
          )
        ),
        /* @__PURE__ */ React16.createElement(
          Box14,
          {
            css: {
              padding: "$one"
            }
          },
          /* @__PURE__ */ React16.createElement(
            FormField9,
            {
              id: "patientState",
              label: "State",
              statusIconLabel: "Error",
              inputStatus: errors.patientState ? "error" : void 0,
              statusMessage: errors.patientState ? "This field is required." : ""
            },
            /* @__PURE__ */ React16.createElement(
              Select6,
              {
                name: "patientState",
                options: stateOption(),
                placeholder: "Please Select",
                id: "select-error",
                value: form.patientState,
                onChange: onUpdateField,
                onBlur: onBlurField,
                onKeyPress: onKeyPressField
              }
            )
          )
        ),
        /* @__PURE__ */ React16.createElement(
          Box14,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "$one"
            }
          },
          /* @__PURE__ */ React16.createElement(
            FormField9,
            {
              id: "patientZipCode",
              label: "Zip Code",
              statusIconLabel: "Error",
              inputStatus: errors.patientZipCode ? "error" : void 0,
              statusMessage: errors.patientZipCode ? zipCodeError : ""
            },
            /* @__PURE__ */ React16.createElement(
              TextInput9,
              {
                pattern: "[0-9]*",
                name: "patientZipCode",
                value: form.patientZipCode,
                onChange: onUpdateField,
                maxLength: 5,
                onBlur: onBlurField,
                onKeyPress: onKeyPressField
              }
            )
          )
        ),
        /* @__PURE__ */ React16.createElement(
          Box14,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "$one"
            }
          },
          /* @__PURE__ */ React16.createElement(
            FormField9,
            {
              id: "patientDateOfBirth",
              label: "Date of Birth (MM/DD/YYYY)"
            },
            /* @__PURE__ */ React16.createElement(TextInput9, { disabled: true, value: form.patientDateOfBirth })
          )
        ),
        /* @__PURE__ */ React16.createElement(
          Box14,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "$one"
            }
          },
          /* @__PURE__ */ React16.createElement(FormField9, { id: "patientGender", label: "Gender" }, /* @__PURE__ */ React16.createElement(
            Fieldset3,
            {
              legend: "",
              css: {
                display: "flex",
                width: "436px",
                height: "24px"
              }
            },
            /* @__PURE__ */ React16.createElement(
              Radio2,
              {
                id: "patientGender",
                name: form.patientGender,
                checked: form.patientGender === "M",
                value: "M",
                label: "MALE",
                onChange: onUpdateField
              }
            ),
            /* @__PURE__ */ React16.createElement(
              Radio2,
              {
                id: "patientGender",
                name: form.patientGender,
                checked: form.patientGender === "F",
                value: "F",
                label: "FEMALE",
                onChange: onUpdateField
              }
            )
          ))
        )
      )
    )
  );
}

// src/components/forms/forms-type/dental/pages/otherCoverage-information.component.tsx
import React17, { useEffect as useEffect16, useState as useState15 } from "react";
import {
  Box as Box15,
  HeadingText as HeadingText14,
  StackLayout as StackLayout16,
  ParagraphText as ParagraphText6,
  Checkbox as Checkbox2,
  Fieldset as Fieldset4,
  Radio as Radio3
} from "@leagueplatform/genesis-core";
function OtherCoverageInformation(props) {
  const { errorHandling } = props;
  const [form, setForm] = useState15({
    hasDentalCoverage: false,
    hasMedicalCoverage: false,
    notApplicable: false,
    primaryInsurance: ""
  });
  const [isOtherCoverageError, setIsOtherCoverageError] = useState15(false);
  const [otherCoverageError, setOtherCoverageError] = useState15("");
  const [isPrimaryInsuranceError, setIsPrimaryInsuranceError] = useState15(false);
  const [primaryInsuranceError, setPrimaryInsuranceError] = useState15("");
  useEffect16(() => {
    if (form.notApplicable) {
      errorHandling(true);
      setIsOtherCoverageError(false);
      setOtherCoverageError("");
      setIsPrimaryInsuranceError(false);
      setPrimaryInsuranceError("");
    } else if (form.hasDentalCoverage || form.hasMedicalCoverage) {
      if (form.primaryInsurance) {
        errorHandling(true);
        errorHandling(true);
        setIsOtherCoverageError(false);
        setOtherCoverageError("");
        setIsPrimaryInsuranceError(false);
        setPrimaryInsuranceError("");
      } else {
        errorHandling(false);
        setIsOtherCoverageError(false);
        setOtherCoverageError("");
        setIsPrimaryInsuranceError(true);
        setPrimaryInsuranceError("This selection is required.");
      }
    } else {
      errorHandling(false);
      setIsOtherCoverageError(true);
      setOtherCoverageError("This selection is required.");
    }
  }, [errorHandling, form, isOtherCoverageError, isPrimaryInsuranceError]);
  const onUpdate = (e) => {
    const { checked, id, value } = e.target;
    if (id === "hasDentalCoverage" || id === "hasMedicalCoverage") {
      const nextFormState = __spreadProps(__spreadValues({}, form), {
        [id]: checked,
        notApplicable: false
      });
      setForm(nextFormState);
      setIsOtherCoverageError(false);
      setOtherCoverageError("");
    } else if (id === "notApplicable") {
      const nextFormState = __spreadProps(__spreadValues({}, form), {
        [id]: checked,
        hasDentalCoverage: false,
        hasMedicalCoverage: false
      });
      setForm(nextFormState);
      setIsOtherCoverageError(false);
      setOtherCoverageError("");
    }
    if (id === "primaryInsurance") {
      const nextFormState = __spreadProps(__spreadValues({}, form), {
        [id]: value
      });
      setForm(nextFormState);
      setIsPrimaryInsuranceError(false);
      setPrimaryInsuranceError("");
    }
  };
  useEffect16(() => {
    const pInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (pInfo) {
      setForm({
        hasDentalCoverage: (pInfo == null ? void 0 : pInfo.hasDentalCoverage) || false,
        hasMedicalCoverage: (pInfo == null ? void 0 : pInfo.hasMedicalCoverage) || false,
        notApplicable: (pInfo == null ? void 0 : pInfo.notApplicable) || false,
        primaryInsurance: (pInfo == null ? void 0 : pInfo.primaryInsurance) || ""
      });
    }
  }, []);
  useEffect16(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React17.createElement(
    StackLayout16,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React17.createElement(
      Box15,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $five $one $none",
          position: "relative",
          right: "48px"
        }
      },
      /* @__PURE__ */ React17.createElement(
        HeadingText14,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Member Dental Claim Form"
      )
    ),
    /* @__PURE__ */ React17.createElement(
      Box15,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$two $four $three $five"
        }
      },
      /* @__PURE__ */ React17.createElement(
        Box15,
        {
          css: {
            paddingLeft: "$oneAndHalf"
          }
        },
        /* @__PURE__ */ React17.createElement(
          HeadingText14,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 4: Other Coverage"
        ),
        /* @__PURE__ */ React17.createElement(
          ParagraphText6,
          {
            css: {
              marginTop: "$one",
              width: "600px"
            }
          },
          /* @__PURE__ */ React17.createElement("p", null, "If the patient has other coverage through a spouse or domestic partner, or if the patient is a minor dependent, list the primary policy holder\u2019s details from the other coverage.")
        )
      ),
      /* @__PURE__ */ React17.createElement(
        Box15,
        {
          css: {
            marginBottom: "$one",
            paddingLeft: "$oneAndHalf"
          }
        },
        /* @__PURE__ */ React17.createElement(
          HeadingText14,
          {
            level: "5",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Do you have any other insurance coverage? Select all that apply."
        ),
        /* @__PURE__ */ React17.createElement(
          Box15,
          {
            css: {
              paddingTop: "$threeQuarters"
            }
          },
          /* @__PURE__ */ React17.createElement(
            Fieldset4,
            {
              css: {
                display: "flex",
                flexDirection: "column",
                width: "600px",
                padding: "$one $none"
              },
              legend: void 0,
              inputStatus: isOtherCoverageError ? "error" : void 0,
              statusMessage: otherCoverageError,
              id: "otherCoverage"
            },
            /* @__PURE__ */ React17.createElement(
              Checkbox2,
              {
                id: "hasDentalCoverage",
                name: "hasDentalCoverage",
                label: "Dental",
                checked: form.hasDentalCoverage,
                onChange: (e) => {
                  onUpdate(e);
                  sessionStorage.setItem("otherCoverage", "");
                }
              }
            ),
            /* @__PURE__ */ React17.createElement(
              Checkbox2,
              {
                id: "hasMedicalCoverage",
                name: "hasMedicalCoverage",
                label: "Medical",
                checked: form.hasMedicalCoverage,
                onChange: (e) => {
                  onUpdate(e);
                  sessionStorage.setItem("otherCoverage", "");
                }
              }
            ),
            /* @__PURE__ */ React17.createElement(
              Checkbox2,
              {
                id: "notApplicable",
                name: "notApplicable",
                label: "N/A",
                checked: form.notApplicable,
                onChange: (e) => {
                  onUpdate(e);
                  sessionStorage.setItem("otherCoverage", "NO");
                }
              }
            )
          )
        )
      ),
      (form.hasDentalCoverage || form.hasMedicalCoverage) && /* @__PURE__ */ React17.createElement(React17.Fragment, null, /* @__PURE__ */ React17.createElement(
        Box15,
        {
          css: {
            paddingLeft: "$two"
          }
        },
        /* @__PURE__ */ React17.createElement(
          HeadingText14,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Is this the primary insurance for the patient?"
        ),
        /* @__PURE__ */ React17.createElement(
          Fieldset4,
          {
            legend: "",
            css: {
              display: "flex",
              width: "436px",
              height: "24px",
              paddingTop: "$half"
            },
            id: "primaryInsurance"
          },
          /* @__PURE__ */ React17.createElement(
            Radio3,
            {
              id: "primaryInsurance",
              name: "primaryInsurance",
              checked: form.primaryInsurance === "Yes",
              value: "Yes" /* YES */,
              label: "Yes" /* YES */,
              onChange: (e) => {
                onUpdate(e);
                sessionStorage.setItem("otherCoverage", "YES");
              }
            }
          ),
          /* @__PURE__ */ React17.createElement(
            Radio3,
            {
              id: "primaryInsurance",
              name: "primaryInsurance",
              checked: form.primaryInsurance === "No",
              value: "No" /* NO */,
              label: "No" /* NO */,
              onChange: (e) => {
                onUpdate(e);
                sessionStorage.setItem("otherCoverage", "NO");
              }
            }
          )
        ),
        isPrimaryInsuranceError && /* @__PURE__ */ React17.createElement("p", { style: { color: "red", paddingTop: "5px" } }, primaryInsuranceError)
      ), form.primaryInsurance === "Yes" && /* @__PURE__ */ React17.createElement(
        Box15,
        {
          css: {
            paddingLeft: "$two"
          }
        },
        /* @__PURE__ */ React17.createElement(
          ParagraphText6,
          {
            css: {
              marginTop: "$two",
              width: "600px"
            }
          },
          /* @__PURE__ */ React17.createElement("p", null, "If you have marked both Dental and Medical, please fill out the details on the next few pages for other dental insurance only. When prompted, please attach the Explanation of Benefits documentation from any other insurance policy.")
        )
      ))
    )
  );
}

// src/components/forms/forms-type/dental/pages/otherCoverage-policyHolder-information.component.tsx
import React18, { useEffect as useEffect17, useState as useState16 } from "react";
import {
  Box as Box16,
  HeadingText as HeadingText15,
  FormField as FormField10,
  TextInput as TextInput10,
  Select as Select7,
  StackLayout as StackLayout17,
  Fieldset as Fieldset5,
  Radio as Radio4
} from "@leagueplatform/genesis-core";
import { CalendarView } from "@leagueplatform/web-common-components";
function OtherCoveragePolicyHolderInformation(props) {
  const { errorHandling, nextButtonClicked } = props;
  const [isCalendarVisible, setIsCalendarVisible] = useState16(false);
  const [form, setForm] = useState16({
    policyHolderName: "",
    policyHolderDob: "",
    policyHolderGender: "",
    policyID: "",
    planNumber: "",
    relationshipToPolicyHolder: ""
  });
  const [errors, setErrors] = useState16({
    policyHolderName: false,
    policyHolderDob: false,
    policyHolderGender: false,
    policyID: false,
    relationshipToPolicyHolder: false
  });
  const formField = isEmpty(form.policyHolderName) || isEmpty(form.policyHolderDob) || isEmpty(form.policyHolderGender) || isEmpty(form.policyID) || isEmpty(form.relationshipToPolicyHolder);
  const isValid = isNotEmpty(form.policyHolderName) && isNotEmpty(form.policyHolderDob) && isNotEmpty(form.policyHolderGender) && isNotEmpty(form.policyID) && isNotEmpty(form.relationshipToPolicyHolder);
  useEffect17(() => {
    if (formField) {
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  }, [formField, errorHandling, form]);
  useEffect17(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          policyHolderName: isEmpty(form.policyHolderName),
          policyHolderDob: isEmpty(form.policyHolderDob),
          policyHolderGender: isEmpty(form.policyHolderGender),
          policyID: isEmpty(form.policyID),
          relationshipToPolicyHolder: isEmpty(form.relationshipToPolicyHolder)
        });
      }
    }
  }, [nextButtonClicked, isValid, form]);
  const updateErrorState = (value, id) => {
    const nextErrorState = __spreadProps(__spreadValues({}, errors), {
      [id]: isEmpty(value)
    });
    setErrors(nextErrorState);
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    const nextFormState = __spreadProps(__spreadValues({}, form), {
      [event.target.id]: /^\s/.test(event.target.value) ? "" : event.target.value
    });
    setForm(nextFormState);
    updateErrorState(event.target.value, event.target.id);
    if (id === "policyHolderName") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        fullName: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^a-zA-Z0-9 ]+/gi, "")
      }));
    }
  };
  const dateSelected = (e) => {
    const day = e.day.toString().padStart(2, "0");
    const month = e.month.toString().padStart(2, "0");
    setIsCalendarVisible(false);
    const datePicked = {
      target: {
        id: "policyHolderDob",
        value: `${month}/${day}/${e.year}`
      }
    };
    onUpdateField(datePicked);
  };
  console.log("Form data -> ", form);
  useEffect17(() => {
    const pInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (pInfo) {
      setForm({
        policyHolderName: pInfo == null ? void 0 : pInfo.policyHolderName,
        policyHolderDob: pInfo == null ? void 0 : pInfo.policyHolderDob,
        policyHolderGender: pInfo == null ? void 0 : pInfo.policyHolderGender,
        policyID: pInfo == null ? void 0 : pInfo.policyID,
        planNumber: pInfo == null ? void 0 : pInfo.planNumber,
        relationshipToPolicyHolder: pInfo == null ? void 0 : pInfo.relationshipToPolicyHolder
      });
    }
  }, []);
  const relationshipOption = () => {
    const relationshipArr = ["Self", "Spouse/Partner", "Child", "Other"];
    const relation = relationshipArr == null ? void 0 : relationshipArr.map((option) => ({
      value: option,
      label: option
    }));
    return relation;
  };
  const onBlurField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  const onKeyPressField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  useEffect17(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React18.createElement(
    StackLayout17,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React18.createElement(
      Box16,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $four $one $four"
        }
      },
      /* @__PURE__ */ React18.createElement(
        HeadingText15,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Member Dental Claim Form"
      ),
      /* @__PURE__ */ React18.createElement(
        Box16,
        {
          css: {
            marginTop: "$two",
            marginBottom: "$one"
          }
        },
        /* @__PURE__ */ React18.createElement(
          HeadingText15,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 4: Other Coverage"
        )
      ),
      /* @__PURE__ */ React18.createElement(Box16, null, /* @__PURE__ */ React18.createElement(
        Box16,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React18.createElement(
          FormField10,
          {
            id: "policyHolderName",
            label: "Name of Policy Holder (Last, First, MI, Suffix)",
            statusIconLabel: "Error",
            inputStatus: errors.policyHolderName ? "error" : void 0,
            statusMessage: errors.policyHolderName ? "This field is required." : ""
          },
          /* @__PURE__ */ React18.createElement(
            TextInput10,
            {
              name: "policyHolderName",
              value: form.policyHolderName,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React18.createElement(
        Box16,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React18.createElement(
          FormField10,
          {
            id: "policyHolderDob",
            label: "Date of Birth (MM/DD/YYYY)",
            statusIconLabel: "Error",
            inputStatus: errors.policyHolderDob ? "error" : void 0,
            statusMessage: errors.policyHolderDob ? "This field is required." : ""
          },
          /* @__PURE__ */ React18.createElement(
            TextInput10,
            {
              name: "policyHolderDob",
              value: form.policyHolderDob,
              onClick: () => setIsCalendarVisible(true)
            }
          )
        )
      ), isCalendarVisible && /* @__PURE__ */ React18.createElement(
        Box16,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$oneAndHalf $twoAndHalf $none $none"
          }
        },
        /* @__PURE__ */ React18.createElement(
          FormField10,
          {
            id: "calendarDate",
            label: "Date of Service (MM/DD/YYYY)",
            css: {
              width: "550px"
            }
          },
          /* @__PURE__ */ React18.createElement(
            CalendarView,
            {
              onChange: (e) => dateSelected(e),
              css: {
                width: "fit-content"
              }
            }
          )
        )
      ), /* @__PURE__ */ React18.createElement(
        Box16,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React18.createElement(FormField10, { id: "policyHolderGender", label: "Gender" }, /* @__PURE__ */ React18.createElement(
          Fieldset5,
          {
            legend: "",
            css: {
              display: "flex",
              width: "436px",
              height: "24px"
            }
          },
          /* @__PURE__ */ React18.createElement(
            Radio4,
            {
              id: "policyHolderGender",
              name: form.policyHolderGender,
              checked: form.policyHolderGender === "M",
              onChange: onUpdateField,
              value: "M",
              label: "MALE"
            }
          ),
          /* @__PURE__ */ React18.createElement(
            Radio4,
            {
              id: "policyHolderGender",
              name: form.policyHolderGender,
              checked: form.policyHolderGender === "F",
              onChange: onUpdateField,
              value: "F",
              label: "FEMALE"
            }
          )
        ), errors.policyHolderGender && /* @__PURE__ */ React18.createElement(
          "p",
          {
            style: {
              color: "red",
              paddingTop: "10px",
              fontSize: "12px",
              margin: "0"
            }
          },
          "This field is required."
        ))
      ), /* @__PURE__ */ React18.createElement(
        Box16,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React18.createElement(
          FormField10,
          {
            id: "policyID",
            label: "Policy Holder/Subscriber ID (SSN or ID#)",
            statusIconLabel: "Error",
            inputStatus: errors.policyID ? "error" : void 0,
            statusMessage: errors.policyID ? "This field is required." : ""
          },
          /* @__PURE__ */ React18.createElement(
            TextInput10,
            {
              name: "policyID",
              value: form.policyID,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 13
            }
          )
        )
      ), /* @__PURE__ */ React18.createElement(
        Box16,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React18.createElement(FormField10, { id: "planNumber", label: "Plan/Group Number (Optional)" }, /* @__PURE__ */ React18.createElement(
          TextInput10,
          {
            pattern: "[0-9]*",
            name: "planNumber",
            value: form.planNumber,
            onChange: onUpdateField,
            onBlur: onBlurField,
            onKeyPress: onKeyPressField,
            maxLength: 50
          }
        ))
      ), /* @__PURE__ */ React18.createElement(
        Box16,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React18.createElement(
          FormField10,
          {
            id: "relationshipToPolicyHolder",
            label: "Patient\u2019s Relationship to Policy Holder",
            statusIconLabel: "Error",
            inputStatus: errors.relationshipToPolicyHolder ? "error" : void 0,
            statusMessage: errors.relationshipToPolicyHolder ? "This field is required." : ""
          },
          /* @__PURE__ */ React18.createElement(
            Select7,
            {
              name: "relationshipToPolicyHolder",
              options: relationshipOption(),
              placeholder: "Please Select",
              id: "relationshipToPolicyHolder",
              value: form.relationshipToPolicyHolder,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ))
    )
  );
}

// src/components/forms/forms-type/dental/pages/otherCoverage-insuranceCompany-information.component.tsx
import React23, { useEffect as useEffect22, useState as useState18 } from "react";
import {
  Box as Box20,
  HeadingText as HeadingText19,
  FormField as FormField11,
  TextInput as TextInput11,
  Select as Select8,
  StackLayout as StackLayout22
} from "@leagueplatform/genesis-core";

// src/components/reusable-components/attachment.component.tsx
import React22, { useEffect as useEffect21, useState as useState17 } from "react";
import {
  Icon as Icon4,
  ParagraphText as ParagraphText10,
  Spinner as Spinner3,
  StackLayout as StackLayout21,
  TextAction as TextAction5
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset8 } from "@leagueplatform/asset-config";
import { getPartnerAccessToken as getPartnerAccessToken2 } from "@leagueplatform/sso-util";

// src/components/forms/layout/removeAttachmentWarningModal.tsx
import React19, { useEffect as useEffect18 } from "react";
import {
  Box as Box17,
  StackLayout as StackLayout18,
  Modal as Modal3,
  ParagraphText as ParagraphText7,
  UtilityText as UtilityText11,
  HeadingText as HeadingText16,
  TextAction as TextAction2,
  Icon
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset5 } from "@leagueplatform/asset-config";
function RemoveAttachmentWarningModal(props) {
  const { onClose, openWarningModal } = props;
  useEffect18(() => {
    const modalBtn = document.getElementById("warningModalTrigger");
    modalBtn == null ? void 0 : modalBtn.click();
  }, [openWarningModal]);
  return /* @__PURE__ */ React19.createElement(Modal3.Root, null, /* @__PURE__ */ React19.createElement(Modal3.Trigger, null, /* @__PURE__ */ React19.createElement(
    Box17,
    {
      css: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        position: "relative",
        marginBottom: "$two"
      }
    },
    /* @__PURE__ */ React19.createElement(
      TextAction2,
      {
        id: "warningModalTrigger",
        as: "button",
        size: {
          "@initial": "large",
          "@mobile": "medium",
          "@tablet": "large"
        }
      },
      /* @__PURE__ */ React19.createElement(
        Icon,
        {
          icon: handleStaticAsset5("CROSS_ICON" /* CROSS_ICON */),
          size: "17px"
        }
      )
    )
  )), /* @__PURE__ */ React19.createElement(
    Modal3.Content,
    {
      showCloseButton: false,
      padding: "$none",
      width: { "@initial": 650, "@mobile": "100%" }
    },
    /* @__PURE__ */ React19.createElement(
      StackLayout18,
      {
        css: { textAlign: "center", padding: "$three $three" },
        horizontalAlignment: "stretch"
      },
      /* @__PURE__ */ React19.createElement(Modal3.Title, null, /* @__PURE__ */ React19.createElement(
        HeadingText16,
        {
          level: "display",
          size: "sm",
          css: { padding: "$oneAndHalf $none" }
        },
        "Are you sure you want to delete this attachment?"
      )),
      /* @__PURE__ */ React19.createElement(ParagraphText7, { emphasis: "subtle" }, "The selected attachment will be deleted and will no longer be available for viewing."),
      /* @__PURE__ */ React19.createElement(
        Box17,
        {
          css: {
            display: "flex",
            flexDirection: "row",
            padding: "$two $four $one $four",
            justifyContent: "space-around"
          }
        },
        /* @__PURE__ */ React19.createElement(Modal3.Close, null, /* @__PURE__ */ React19.createElement(
          UtilityText11,
          {
            css: {
              color: "#0074C9",
              cursor: "pointer"
            }
          },
          "No"
        )),
        /* @__PURE__ */ React19.createElement(
          UtilityText11,
          {
            css: {
              color: "#0074C9",
              cursor: "pointer"
            },
            onClick: onClose
          },
          "Yes"
        )
      )
    )
  ));
}

// src/components/forms/layout/removeAttachmentSuccessModal.tsx
import React20, { useEffect as useEffect19 } from "react";
import {
  Box as Box18,
  HeadingText as HeadingText17,
  StackLayout as StackLayout19,
  Modal as Modal4,
  TextAction as TextAction3,
  ParagraphText as ParagraphText8,
  Icon as Icon2
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset6 } from "@leagueplatform/asset-config";
function RemoveAttachmentSuccessModal(props) {
  const { onClose, openSuccessModal } = props;
  useEffect19(() => {
    const modalBtn = document.getElementById("successModalTrigger");
    modalBtn == null ? void 0 : modalBtn.click();
  }, [openSuccessModal]);
  return /* @__PURE__ */ React20.createElement(Modal4.Root, null, /* @__PURE__ */ React20.createElement(Modal4.Trigger, null, /* @__PURE__ */ React20.createElement(
    Box18,
    {
      css: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        position: "relative",
        left: "90px",
        marginBottom: "$two"
      }
    },
    /* @__PURE__ */ React20.createElement(
      TextAction3,
      {
        id: "successModalTrigger",
        as: "button",
        size: {
          "@initial": "large",
          "@mobile": "medium",
          "@tablet": "large"
        }
      },
      /* @__PURE__ */ React20.createElement(
        Icon2,
        {
          icon: handleStaticAsset6("CROSS_ICON" /* CROSS_ICON */),
          size: "17px"
        }
      )
    )
  )), /* @__PURE__ */ React20.createElement(
    Modal4.Content,
    {
      showCloseButton: false,
      padding: "$none",
      width: { "@initial": 650, "@mobile": "100%" }
    },
    /* @__PURE__ */ React20.createElement(
      StackLayout19,
      {
        css: { textAlign: "center", padding: "$three $three" },
        horizontalAlignment: "stretch"
      },
      /* @__PURE__ */ React20.createElement(
        Box18,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }
        },
        " ",
        /* @__PURE__ */ React20.createElement(
          "img",
          {
            src: handleStaticAsset6("CHECK_ICON" /* CHECK_ICON */),
            alt: "cross icon",
            width: "40px",
            style: { cursor: "pointer" }
          }
        )
      ),
      /* @__PURE__ */ React20.createElement(Modal4.Title, null, /* @__PURE__ */ React20.createElement(
        HeadingText17,
        {
          level: "display",
          size: "sm",
          css: { padding: "$oneAndHalf $none" }
        },
        "Success"
      )),
      /* @__PURE__ */ React20.createElement(ParagraphText8, { emphasis: "subtle" }, "You have successfully deleted the attachment."),
      /* @__PURE__ */ React20.createElement(
        TextAction3,
        {
          css: {
            flexDirection: "column",
            width: "100%"
          },
          as: "button",
          onClick: onClose
        },
        "Close"
      )
    )
  ));
}

// src/components/forms/layout/attachmentLimitExceededModal.tsx
import React21, { useEffect as useEffect20 } from "react";
import {
  Box as Box19,
  HeadingText as HeadingText18,
  StackLayout as StackLayout20,
  Modal as Modal5,
  TextAction as TextAction4,
  ParagraphText as ParagraphText9,
  Icon as Icon3
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset7 } from "@leagueplatform/asset-config";
function AttachmentLimitExceededModal(props) {
  const { onClose, openExceededModal } = props;
  useEffect20(() => {
    const modalBtn = document.getElementById("exceededModalTrigger");
    modalBtn == null ? void 0 : modalBtn.click();
  }, [openExceededModal]);
  return /* @__PURE__ */ React21.createElement(Modal5.Root, null, /* @__PURE__ */ React21.createElement(Modal5.Trigger, null, /* @__PURE__ */ React21.createElement(
    Box19,
    {
      css: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        position: "relative",
        left: "90px",
        marginBottom: "$two"
      }
    },
    /* @__PURE__ */ React21.createElement(
      TextAction4,
      {
        id: "exceededModalTrigger",
        as: "button",
        size: {
          "@initial": "large",
          "@mobile": "medium",
          "@tablet": "large"
        },
        css: {
          width: "0"
        }
      },
      /* @__PURE__ */ React21.createElement(
        Icon3,
        {
          icon: handleStaticAsset7("CROSS_ICON" /* CROSS_ICON */),
          size: "17px"
        }
      )
    )
  )), /* @__PURE__ */ React21.createElement(
    Modal5.Content,
    {
      showCloseButton: false,
      padding: "$none",
      width: { "@initial": 650, "@mobile": "100%" }
    },
    /* @__PURE__ */ React21.createElement(
      StackLayout20,
      {
        css: { textAlign: "center", padding: "$three $three" },
        horizontalAlignment: "stretch"
      },
      /* @__PURE__ */ React21.createElement(
        Box19,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }
        },
        " ",
        /* @__PURE__ */ React21.createElement(
          "img",
          {
            src: handleStaticAsset7(
              "ATTENTION_ICON" /* ATTENTION_ICON */
            ),
            alt: "cross icon",
            width: "40px",
            style: { cursor: "pointer" }
          }
        )
      ),
      /* @__PURE__ */ React21.createElement(Modal5.Title, null, /* @__PURE__ */ React21.createElement(
        HeadingText18,
        {
          level: "display",
          size: "sm",
          css: { padding: "$oneAndHalf $none" }
        },
        "Attention"
      )),
      /* @__PURE__ */ React21.createElement(ParagraphText9, { emphasis: "subtle" }, "Your attachments have exceeded the maximum number of megabytes permitted. Please try again."),
      /* @__PURE__ */ React21.createElement(
        TextAction4,
        {
          css: {
            flexDirection: "column",
            width: "100%"
          },
          as: "button",
          onClick: onClose
        },
        "Close"
      )
    )
  ));
}

// src/components/reusable-components/attachment.component.tsx
function AttachmentReusableComponent(props) {
  const { displayText, acceptTypes, onUpdate, attachments, serviceIndex } = props;
  const [fileData, setFileData] = useState17([]);
  const [filesCount, setFilesCount] = useState17(0);
  const [filesTotalSize, setFilesTotalSize] = useState17(0);
  const [filesSizeArray, setFilesSizeArray] = useState17([]);
  const [isLoading, setIsLoading] = useState17(false);
  const [errMsg, setErrMsg] = useState17(null);
  const [indexToRemove, setIndexToRemove] = useState17(0);
  const [isLimitExceededModal, setIsLimitExceededModal] = useState17(false);
  const [isRemoveAttachmentWarningModal, setIsRemoveAttachmentWarningModal] = useState17(false);
  const [isRemoveAttachmentSuccessModal, setIsRemoveAttachmentSuccessModal] = useState17(false);
  useEffect21(() => {
    if (attachments.length === 0) {
      setFileData([]);
      setFilesCount(0);
      setFilesSizeArray([]);
      setFilesTotalSize(0);
    }
    if (attachments.length > 0) {
      setFileData(attachments);
      setFilesCount(attachments.length);
      const attachmentSize = attachments.map((att) => att.size);
      setFilesSizeArray(attachmentSize);
      const totalSize = attachmentSize.reduce(
        (att1, att2) => att1 + att2
      );
      setFilesTotalSize(totalSize);
    }
  }, [attachments]);
  const testFileApi = (file) => __async(this, null, function* () {
    setIsLoading(true);
    const form = new FormData();
    form.append("file", file);
    const token = yield getPartnerAccessToken2("highmark");
    const config = formsLibrary.getConfig();
    const highmarkUrl = config.HIGHMARK_API_URL;
    const url = `${highmarkUrl}/members/messages/attachment`;
    const options = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: form
    };
    try {
      return yield fetch(url, options).then((response) => {
        setIsLoading(false);
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`
          );
        }
        return response.json();
      }).then((data) => data);
    } catch (error) {
      const errObj = {
        errMsg: error
      };
      return errObj;
    }
  });
  const fileChanged = (e) => {
    const file = e.target.files[0];
    const fileDataCopy = [...fileData];
    const sizeCopy = [...filesSizeArray];
    if (e.target.value) {
      const newFileSize = file.size;
      const newTotalSize = filesTotalSize + newFileSize;
      if (newFileSize > 10485760) {
        setIsLimitExceededModal(true);
        e.target.value = "";
      } else if (newTotalSize > 10485760) {
        setIsLimitExceededModal(true);
        e.target.value = "";
      } else {
        testFileApi(file).then((result) => {
          const fileApiData = result == null ? void 0 : result.attachmentPath;
          const fileErrorData = result == null ? void 0 : result.errMsg;
          if (fileApiData) {
            const fileObj = {
              name: file.name,
              attachmentPath: fileApiData,
              size: file.size
            };
            fileDataCopy.push(fileObj);
            setFilesCount(filesCount + 1);
            setFilesTotalSize(newTotalSize);
            sizeCopy.push(newFileSize);
            setFilesSizeArray(sizeCopy);
            setFileData(fileDataCopy);
            onUpdate(fileDataCopy);
          }
          if (fileErrorData) {
            setErrMsg(fileErrorData);
          }
        });
      }
    }
  };
  const triggerToSelectFile = () => {
    const fileBtn = document.getElementById(`attachment${serviceIndex}`);
    fileBtn == null ? void 0 : fileBtn.click();
  };
  const deleteAttachment = (index) => {
    setIndexToRemove(index);
    setIsRemoveAttachmentWarningModal(true);
  };
  const removeFile = () => {
    const fileDataCopy = [...fileData];
    const sizeCopy = [...filesSizeArray];
    fileDataCopy.splice(indexToRemove, 1);
    const fileSizeToRemove = sizeCopy.splice(indexToRemove, 1);
    const newFileSize = filesTotalSize - fileSizeToRemove[0];
    setFilesTotalSize(newFileSize);
    setFileData(fileDataCopy);
    onUpdate(fileDataCopy);
    setFilesCount(filesCount - 1);
    setFilesSizeArray(sizeCopy);
    setIsRemoveAttachmentWarningModal(false);
    setIsRemoveAttachmentSuccessModal(true);
  };
  return /* @__PURE__ */ React22.createElement(
    StackLayout21,
    {
      css: {
        backgroundColor: "White",
        width: "590px",
        padding: "$two $none $none $none"
      }
    },
    isLimitExceededModal && /* @__PURE__ */ React22.createElement(
      AttachmentLimitExceededModal,
      {
        onClose: () => setIsLimitExceededModal(false),
        openExceededModal: isLimitExceededModal
      }
    ),
    isRemoveAttachmentWarningModal && /* @__PURE__ */ React22.createElement(
      RemoveAttachmentWarningModal,
      {
        onClose: removeFile,
        openWarningModal: isRemoveAttachmentWarningModal
      }
    ),
    isRemoveAttachmentSuccessModal && /* @__PURE__ */ React22.createElement(
      RemoveAttachmentSuccessModal,
      {
        onClose: () => setIsRemoveAttachmentSuccessModal(false),
        openSuccessModal: isRemoveAttachmentSuccessModal
      }
    ),
    isLoading ? /* @__PURE__ */ React22.createElement(
      Spinner3,
      {
        loading: isLoading,
        loadingText: "Fetching the online form data!",
        size: "40px"
      }
    ) : /* @__PURE__ */ React22.createElement(
      ParagraphText10,
      {
        css: {
          width: "590px"
        }
      },
      filesTotalSize < 10485760 && fileData.length < 10 && /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement(
        "input",
        {
          type: "file",
          accept: acceptTypes.join(", "),
          id: `attachment${serviceIndex}`,
          onChange: fileChanged,
          style: { width: "0" }
        }
      ), /* @__PURE__ */ React22.createElement(
        TextAction5,
        {
          icon: handleStaticAsset8(
            "ATTACHMENT_ICON" /* ATTACHMENT_ICON */
          ),
          size: {
            "@initial": "large",
            "@mobile": "medium",
            "@tablet": "large"
          },
          css: {
            width: "590px"
          },
          as: "button",
          onClick: triggerToSelectFile
        },
        displayText
      ), /* @__PURE__ */ React22.createElement("p", null, "You may attach a file up to 10 MB. The accepted file types are .pdf, .doc, .png, .gif, or .jpg.")),
      fileData.length > 0 && fileData.map((file, index) => /* @__PURE__ */ React22.createElement(
        TextAction5,
        {
          css: {
            width: "590px"
          }
        },
        /* @__PURE__ */ React22.createElement(
          TextAction5,
          {
            css: {
              width: "510px",
              paddingBottom: "15px"
            }
          },
          file.name
        ),
        /* @__PURE__ */ React22.createElement(
          TextAction5,
          {
            onClick: () => deleteAttachment(index),
            size: {
              "@initial": "large",
              "@mobile": "medium",
              "@tablet": "large"
            }
          },
          /* @__PURE__ */ React22.createElement(
            Icon4,
            {
              icon: handleStaticAsset8(
                "CROSS_ICON" /* CROSS_ICON */
              ),
              size: "17px"
            }
          )
        )
      ))
    ),
    errMsg && /* @__PURE__ */ React22.createElement(ErrorModal, { onClose: () => setErrMsg(null) })
  );
}

// src/components/forms/forms-type/dental/pages/otherCoverage-insuranceCompany-information.component.tsx
function OtherCoverageInsuranceCompanyInformation(props) {
  const { errorHandling, nextButtonClicked } = props;
  const [form, setForm] = useState18({
    otherInsuranceCompany: "",
    otherInsuranceAddressLine1: "",
    otherInsuranceAddressLine2: "",
    otherInsuranceAddressCity: "",
    otherInsuranceAddressState: "",
    otherInsuranceAddressZipCode: "",
    eobAttachments: []
  });
  const [errors, setErrors] = useState18({
    otherInsuranceCompany: false
  });
  const [isAttachmentError, setIsAttachmentError] = useState18(false);
  const [attachmentError, setAttachmentError] = useState18("");
  const formField = isEmpty(form.otherInsuranceCompany);
  const isValid = isNotEmpty(form.otherInsuranceCompany);
  useEffect22(() => {
    if (formField || form.eobAttachments.length === 0) {
      errorHandling(false);
      if (form.eobAttachments.length === 0) {
        setIsAttachmentError(true);
        setAttachmentError("This field is required.");
      } else {
        setIsAttachmentError(false);
        setAttachmentError("");
      }
    } else {
      errorHandling(true);
    }
  }, [formField, errorHandling, isAttachmentError, form]);
  useEffect22(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          otherInsuranceCompany: isEmpty(form.otherInsuranceCompany)
        });
      }
    }
  }, [nextButtonClicked, isValid, form]);
  const updateErrorState = (value, id) => {
    const nextErrorState = __spreadProps(__spreadValues({}, errors), {
      [id]: isEmpty(value)
    });
    setErrors(nextErrorState);
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    const nextFormState = __spreadProps(__spreadValues({}, form), {
      [event.target.id]: /^\s/.test(event.target.value) ? "" : event.target.value
    });
    setForm(nextFormState);
    if (id === "otherInsuranceCompany") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        otherInsuranceCompany: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^a-zA-Z0-9 ]+/gi, "")
      }));
      updateErrorState(event.target.value, event.target.id);
    }
  };
  const attachmentsAdded = (attachmentsObj) => {
    const nextFormState = __spreadProps(__spreadValues({}, form), {
      eobAttachments: attachmentsObj
    });
    setForm(nextFormState);
    setIsAttachmentError(false);
    setAttachmentError("");
  };
  useEffect22(() => {
    const pInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (pInfo) {
      setForm({
        otherInsuranceCompany: pInfo == null ? void 0 : pInfo.otherInsuranceCompany,
        otherInsuranceAddressLine1: pInfo == null ? void 0 : pInfo.otherInsuranceAddressLine1,
        otherInsuranceAddressLine2: pInfo == null ? void 0 : pInfo.otherInsuranceAddressLine2,
        otherInsuranceAddressCity: pInfo == null ? void 0 : pInfo.otherInsuranceAddressCity,
        otherInsuranceAddressState: pInfo == null ? void 0 : pInfo.otherInsuranceAddressState,
        otherInsuranceAddressZipCode: pInfo == null ? void 0 : pInfo.otherInsuranceAddressZipCode,
        eobAttachments: (pInfo == null ? void 0 : pInfo.eobAttachments) || []
      });
    }
  }, []);
  const onBlurField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  const onKeyPressField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  useEffect22(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React23.createElement(
    StackLayout22,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React23.createElement(
      Box20,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $four $one $four"
        }
      },
      /* @__PURE__ */ React23.createElement(
        HeadingText19,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Member Dental Claim Form"
      ),
      /* @__PURE__ */ React23.createElement(
        Box20,
        {
          css: {
            marginTop: "$two",
            marginBottom: "$one"
          }
        },
        /* @__PURE__ */ React23.createElement(
          HeadingText19,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 4: Other Coverage"
        )
      ),
      /* @__PURE__ */ React23.createElement(Box20, null, /* @__PURE__ */ React23.createElement(
        Box20,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React23.createElement(
          FormField11,
          {
            id: "otherInsuranceCompany",
            label: "Name of Other Insurance Company",
            statusIconLabel: "Error",
            inputStatus: errors.otherInsuranceCompany ? "error" : void 0,
            statusMessage: errors.otherInsuranceCompany ? "This field is required." : ""
          },
          /* @__PURE__ */ React23.createElement(
            TextInput11,
            {
              name: "otherInsuranceCompany",
              value: form.otherInsuranceCompany,
              onChange: onUpdateField,
              maxLength: 50,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React23.createElement(
        Box20,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React23.createElement(
          FormField11,
          {
            id: "otherInsuranceAddressLine1",
            label: "Company Address Line 1 (Optional)"
          },
          /* @__PURE__ */ React23.createElement(
            TextInput11,
            {
              name: "otherInsuranceAddressLine1",
              value: form.otherInsuranceAddressLine1,
              onChange: onUpdateField,
              maxLength: 50,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React23.createElement(
        Box20,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React23.createElement(
          FormField11,
          {
            id: "otherInsuranceAddressLine2",
            label: "Company Address Line 2 (Optional)"
          },
          /* @__PURE__ */ React23.createElement(
            TextInput11,
            {
              name: "otherInsuranceAddressLine2",
              value: form.otherInsuranceAddressLine2,
              onChange: onUpdateField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React23.createElement(
        Box20,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React23.createElement(FormField11, { id: "otherInsuranceAddressCity", label: "City (Optional)" }, /* @__PURE__ */ React23.createElement(
          TextInput11,
          {
            name: "otherInsuranceAddressCity",
            value: form.otherInsuranceAddressCity,
            onChange: onUpdateField,
            onBlur: onBlurField,
            onKeyPress: onKeyPressField,
            maxLength: 50
          }
        ))
      ), /* @__PURE__ */ React23.createElement(
        Box20,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React23.createElement(FormField11, { id: "otherInsuranceAddressState", label: "State (Optional)" }, /* @__PURE__ */ React23.createElement(
          Select8,
          {
            name: "otherInsuranceAddressState",
            options: stateOption(),
            placeholder: "Please Select",
            id: "otherInsuranceAddressState",
            value: form.otherInsuranceAddressState,
            onChange: onUpdateField,
            onBlur: onBlurField,
            onKeyPress: onKeyPressField
          }
        ))
      ), /* @__PURE__ */ React23.createElement(
        Box20,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React23.createElement(
          FormField11,
          {
            id: "otherInsuranceAddressZipCode",
            label: "Zip Code (Optional)"
          },
          /* @__PURE__ */ React23.createElement(
            TextInput11,
            {
              pattern: "[0-9]*",
              name: "otherInsuranceAddressZipCode",
              value: form.otherInsuranceAddressZipCode,
              onChange: onUpdateField,
              maxLength: 5,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React23.createElement(
        Box20,
        {
          css: {
            paddingLeft: "$one"
          }
        },
        /* @__PURE__ */ React23.createElement(
          AttachmentReusableComponent,
          {
            displayText: "Attach Itemized Bill or Receipt",
            acceptTypes: [".pdf", ".doc", ".png", ".gif", ".jpg"],
            onUpdate: attachmentsAdded,
            attachments: form.eobAttachments,
            serviceIndex: "dental-itemized-bill"
          }
        ),
        isAttachmentError && /* @__PURE__ */ React23.createElement(
          "p",
          {
            style: {
              color: "red",
              paddingTop: "10px",
              fontSize: "12px",
              margin: "0"
            }
          },
          attachmentError
        )
      ))
    )
  );
}

// src/components/forms/forms-type/dental/pages/receipts-information.component.tsx
import React24, { useEffect as useEffect23, useState as useState19 } from "react";
import {
  Box as Box21,
  HeadingText as HeadingText20,
  StackLayout as StackLayout23,
  UtilityText as UtilityText12,
  ParagraphText as ParagraphText11
} from "@leagueplatform/genesis-core";
function ReceiptsInformation(props) {
  const { errorHandling } = props;
  const [form, setForm] = useState19({
    itemizedAttachments: []
  });
  const [isAttachmentError, setIsAttachmentError] = useState19(false);
  const [attachmentError, setAttachmentError] = useState19("");
  useEffect23(() => {
    if (form.itemizedAttachments.length > 0) {
      setIsAttachmentError(false);
      setAttachmentError("");
      errorHandling(true);
    } else {
      setIsAttachmentError(true);
      setAttachmentError("This selection is required.");
      errorHandling(false);
    }
  }, [form, isAttachmentError, attachmentError, errorHandling]);
  const attachmentsAdded = (attachmentsObj) => {
    const nextFormState = __spreadProps(__spreadValues({}, form), {
      itemizedAttachments: attachmentsObj
    });
    setForm(nextFormState);
    setIsAttachmentError(false);
    setAttachmentError("");
  };
  useEffect23(() => {
    const pInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (pInfo) {
      setForm({
        itemizedAttachments: (pInfo == null ? void 0 : pInfo.itemizedAttachments) || []
      });
    }
  }, []);
  useEffect23(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React24.createElement(
    StackLayout23,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React24.createElement(
      Box21,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $five $one $none",
          position: "relative",
          right: "48px"
        }
      },
      /* @__PURE__ */ React24.createElement(
        HeadingText20,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Member Dental Claim Form"
      )
    ),
    /* @__PURE__ */ React24.createElement(
      Box21,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$two $four $two $none",
          position: "relative",
          right: "50px"
        }
      },
      /* @__PURE__ */ React24.createElement(
        HeadingText20,
        {
          level: "3",
          size: {
            "@initial": "xl",
            "@mobile": "lg"
          }
        },
        "Step 5: Receipts for Services Provided"
      )
    ),
    /* @__PURE__ */ React24.createElement(
      Box21,
      {
        css: {
          display: "flex",
          width: "600px",
          paddingLeft: "$one"
        }
      },
      /* @__PURE__ */ React24.createElement(UtilityText12, null, "Attach any receipts, bills, or supporting claim documentation you may have received from your dentist. You will not be able to submit the form without required attachments.")
    ),
    /* @__PURE__ */ React24.createElement(
      Box21,
      {
        css: {
          paddingLeft: "$one"
        }
      },
      /* @__PURE__ */ React24.createElement(
        AttachmentReusableComponent,
        {
          displayText: "Attach Itemized Bill or Receipt",
          acceptTypes: [".pdf", ".doc", ".png", ".gif", ".jpg"],
          onUpdate: attachmentsAdded,
          attachments: form.itemizedAttachments,
          serviceIndex: "dental-receipt"
        }
      ),
      /* @__PURE__ */ React24.createElement(
        ParagraphText11,
        {
          css: {
            color: "Red"
          }
        },
        isAttachmentError && /* @__PURE__ */ React24.createElement(
          "p",
          {
            style: {
              color: "red",
              paddingTop: "10px",
              fontSize: "12px",
              margin: "0"
            }
          },
          attachmentError
        )
      )
    )
  );
}

// src/components/forms/forms-type/dental/pages/consent-information.component.tsx
import React26, { useEffect as useEffect24, useState as useState20 } from "react";
import {
  Box as Box23,
  HeadingText as HeadingText22,
  StackLayout as StackLayout25,
  UtilityText as UtilityText14,
  Checkbox as Checkbox3,
  FormField as FormField12,
  TextInput as TextInput12,
  Fieldset as Fieldset6
} from "@leagueplatform/genesis-core";

// src/components/forms/layout/fraudModal.tsx
import React25 from "react";
import {
  Box as Box22,
  HeadingText as HeadingText21,
  StackLayout as StackLayout24,
  UtilityText as UtilityText13,
  TextAction as TextAction6,
  Modal as Modal6
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset9 } from "@leagueplatform/asset-config";
function FraudModal(props) {
  const { fraudLabel } = props;
  return /* @__PURE__ */ React25.createElement(Modal6.Root, null, /* @__PURE__ */ React25.createElement(Modal6.Trigger, null, /* @__PURE__ */ React25.createElement(
    Box22,
    {
      css: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        position: "relative"
      }
    },
    /* @__PURE__ */ React25.createElement(
      TextAction6,
      {
        css: {
          padding: "$two $none"
        },
        icon: handleStaticAsset9("FRAUD_ICON" /* FRAUD_ICON */),
        size: {
          "@initial": "large",
          "@mobile": "medium",
          "@tablet": "large"
        },
        as: "button"
      },
      fraudLabel
    )
  )), /* @__PURE__ */ React25.createElement(
    Modal6.Content,
    {
      showCloseButton: false,
      padding: "$none",
      width: { "@initial": 800, "@mobile": "100%" }
    },
    /* @__PURE__ */ React25.createElement(
      StackLayout24,
      {
        css: { alignItems: "center", padding: "$three $three" },
        horizontalAlignment: "stretch"
      },
      /* @__PURE__ */ React25.createElement(Modal6.Title, null, /* @__PURE__ */ React25.createElement(
        HeadingText21,
        {
          level: "display",
          size: "sm",
          css: { padding: "$oneAndHalf $none" }
        },
        "Fraud and Discrimination Disclaimers"
      )),
      /* @__PURE__ */ React25.createElement(UtilityText13, { css: { width: "600px", height: "500px" } }, /* @__PURE__ */ React25.createElement("p", null, "Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto, commits a fraudulent insurance act which is a crime and subjects such person to criminal and civil penalties."), /* @__PURE__ */ React25.createElement("p", null, "CA: For your protection California law requires that the following appear on the form: Any person who knowingly presents a false claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in state prison."), /* @__PURE__ */ React25.createElement("p", null, "DC & RI: Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison."), /* @__PURE__ */ React25.createElement("p", null, "FL: Any person who knowingly, and with intent to injure, defraud, or deceive any insurer files a statement of claim or an application containing any false, incomplete or misleading information is guilty of a felony in the third degree."), /* @__PURE__ */ React25.createElement("p", null, "IN & OK: WARNING: Any person who knowingly, and with intent to injure, defraud or deceive an insurer, makes any claim for the proceeds of an insurance policy containing any false, incomplete or misleading information is guilty of a felony."), /* @__PURE__ */ React25.createElement("p", null, "KY: Any person who knowingly and with intent to defraud any insurance company or other person files a statement of claim containing any materially false information or conceals, for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime."), /* @__PURE__ */ React25.createElement("p", null, "LA: Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison."), /* @__PURE__ */ React25.createElement("p", null, "NJ: Any person who knowingly files a statement of claim containing any false or misleading information is subject to criminal and civil penalties."), /* @__PURE__ */ React25.createElement("p", null, "NY: Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information, or conceals for the purpose of misleading, information concerning any fact material thereto, commits a fraudulent insurance act, which is a crime, and shall also be subject to a civil penalty not to exceed five thousand dollars and the stated value of the claim for each such violation."), /* @__PURE__ */ React25.createElement("p", null, "VA: Any person who within the intent to defraud or knowing that he is facilitating a fraud against an insurer, submits an application or files a claim containing a false or deceptive statement may have violated the state law."), /* @__PURE__ */ React25.createElement("p", null, "TN & WA: It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties include imprisonment, fines and denial of insurance benefits."), /* @__PURE__ */ React25.createElement("p", null, "MD: Any person who knowingly or willfully presents a false or fraudulent claim for payment of a loss or benefit or who knowingly or willfully presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.")),
      /* @__PURE__ */ React25.createElement(Modal6.Close, null, /* @__PURE__ */ React25.createElement(
        TextAction6,
        {
          css: {
            flexDirection: "column",
            width: "100%",
            top: "780px",
            padding: "$none $none $oneAndHalf $none"
          },
          as: "button"
        },
        "Close"
      ))
    )
  ));
}

// src/components/forms/forms-type/dental/pages/consent-information.component.tsx
function ConsentInformation(props) {
  const { errorHandling } = props;
  const [form, setForm] = useState20({
    patientConsent: false,
    paymentAuthorization: false,
    entityName: ""
  });
  const [isFraudError, setIsFraudError] = useState20(false);
  const [fraudError, setFraudError] = useState20("");
  const [state, setState] = useState20("");
  useEffect24(() => {
    if (form.patientConsent) {
      errorHandling(true);
      setIsFraudError(false);
      setFraudError("");
    } else {
      errorHandling(false);
      setIsFraudError(true);
      setFraudError("This selection is required.");
    }
  }, [errorHandling, form]);
  const onUpdate = (e) => {
    const { id, value, checked } = e.target;
    if (id === "entityName") {
      const nextFormState = __spreadProps(__spreadValues({}, form), {
        [id]: value
      });
      setForm(nextFormState);
    } else {
      const nextFormState = __spreadProps(__spreadValues({}, form), {
        [id]: checked
      });
      setForm(nextFormState);
      if (id === "patientConsent") {
        setIsFraudError(false);
        setFraudError("");
      }
    }
  };
  useEffect24(() => {
    const pInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (pInfo) {
      setForm({
        patientConsent: pInfo == null ? void 0 : pInfo.patientConsent,
        paymentAuthorization: pInfo == null ? void 0 : pInfo.paymentAuthorization,
        entityName: (pInfo == null ? void 0 : pInfo.entityName) || ""
      });
      setState(pInfo == null ? void 0 : pInfo.state);
    }
  }, []);
  useEffect24(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React26.createElement(
    StackLayout25,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React26.createElement(
      Box23,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $four $one $four"
        }
      },
      /* @__PURE__ */ React26.createElement(
        HeadingText22,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Member Dental Claim Form"
      ),
      /* @__PURE__ */ React26.createElement(
        Box23,
        {
          css: {
            marginTop: "$two",
            marginBottom: "$one"
          }
        },
        /* @__PURE__ */ React26.createElement(
          HeadingText22,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 6: Patient Consent"
        )
      ),
      /* @__PURE__ */ React26.createElement(
        Box23,
        {
          css: {
            display: "flex",
            width: "600px",
            paddingBottom: "$two"
          }
        },
        /* @__PURE__ */ React26.createElement(UtilityText14, null, "I have been informed of the treatment plan and associated fees. I agree to be responsible for all charges for dental services and materials not paid by my dental benefit plan, unless prohibited by law, or the treating dentist or dental practice has a contractual agreement with my plan prohibiting all or a portion of such charges.")
      ),
      /* @__PURE__ */ React26.createElement(
        Box23,
        {
          css: {
            display: "flex",
            width: "600px"
          }
        },
        /* @__PURE__ */ React26.createElement(UtilityText14, null, "To the extent permitted by law, I consent to your use and disclosure of my protected health information to carry out payment activities in connection with this claim.")
      ),
      /* @__PURE__ */ React26.createElement(Box23, null, /* @__PURE__ */ React26.createElement(FraudModal, { fraudLabel: "Fraud and discrimination disclaimers" })),
      state !== "PA" && /* @__PURE__ */ React26.createElement(Box23, null, /* @__PURE__ */ React26.createElement(
        HeadingText22,
        {
          level: "3",
          size: {
            "@initial": "xl",
            "@mobile": "lg"
          }
        },
        "Payment Authorization (Optional)"
      ), /* @__PURE__ */ React26.createElement(
        UtilityText14,
        {
          css: {
            display: "flex",
            width: "600px",
            paddingTop: "$one"
          }
        },
        /* @__PURE__ */ React26.createElement(
          Checkbox3,
          {
            id: "paymentAuthorization",
            name: "payment-authorization",
            label: "",
            checked: form.paymentAuthorization,
            onChange: (e) => onUpdate(e)
          }
        ),
        "I hereby authorize and direct payment of the dental benefits otherwise payable to me, directly to the below named dentist or dental entity."
      ), /* @__PURE__ */ React26.createElement(
        Box23,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React26.createElement(FormField12, { id: "entityName", label: "Dentist/Dental Entity\u2019s Name" }, /* @__PURE__ */ React26.createElement(
          TextInput12,
          {
            value: form.entityName,
            onChange: (e) => onUpdate(e)
          }
        ))
      )),
      /* @__PURE__ */ React26.createElement(Box23, null, /* @__PURE__ */ React26.createElement(
        Fieldset6,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            width: "600px",
            padding: "$one $none"
          },
          legend: void 0,
          inputStatus: isFraudError ? "error" : void 0,
          statusMessage: fraudError,
          id: "fraudAcknowledgement"
        },
        /* @__PURE__ */ React26.createElement(
          Checkbox3,
          {
            id: "patientConsent",
            name: "patient-consent",
            label: "By checking this box and clicking \u201CSubmit\u201D below, I am\n              electronically signing this Dental Claim Form. I am in agreement\n              with the above and certify that the information provided on this\n              claim form is correct and complete.",
            checked: form.patientConsent,
            onChange: (e) => onUpdate(e)
          }
        )
      ))
    )
  );
}

// src/components/forms/forms-type/dental/dentalClaim-forms.component.tsx
function DentalClaimForm(props) {
  const { closeForm } = props;
  const apiResponse1 = useFetchProfileData();
  const apiResponse2 = useFetchPlanDetailsData("dental");
  const apiData1 = apiResponse1[0];
  const apiData2 = apiResponse2[0];
  const errMsg1 = apiResponse1[1];
  const errMsg2 = apiResponse2[1];
  const [isErrorHandling, setErrorHandling] = useState21(false);
  const [isValidateForm, setIsValidateForm] = useState21(false);
  const [showInstructions, setShowInstructions] = useState21(true);
  const [showOcComps, setShowOcComps] = useState21(true);
  useEffect25(() => {
    emptyStorage();
  }, []);
  const componentList = showInstructions ? [/* @__PURE__ */ React27.createElement(FormInstructions, null)] : [
    /* @__PURE__ */ React27.createElement(
      TransactionTypeInformation,
      {
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData1
      }
    ),
    /* @__PURE__ */ React27.createElement(
      PolicyHolderInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData1,
        planDetailsResponseData: apiData2
      }
    ),
    /* @__PURE__ */ React27.createElement(
      PatientInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData1
      }
    ),
    /* @__PURE__ */ React27.createElement(
      OtherCoverageInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData1
      }
    ),
    /* @__PURE__ */ React27.createElement(
      OtherCoveragePolicyHolderInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData1
      }
    ),
    /* @__PURE__ */ React27.createElement(
      OtherCoverageInsuranceCompanyInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData1
      }
    ),
    /* @__PURE__ */ React27.createElement(
      ReceiptsInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData1
      }
    ),
    /* @__PURE__ */ React27.createElement(
      ConsentInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData1
      }
    )
  ];
  return /* @__PURE__ */ React27.createElement(
    StackLayout26,
    {
      horizontalAlignment: "center",
      css: { position: "relative", minHeight: "100vh" }
    },
    apiData1 && apiData2 && /* @__PURE__ */ React27.createElement(
      FooterMultiStepProgress,
      {
        list: componentList,
        handleFormOrNext: isErrorHandling,
        isValidateForm: (val) => setIsValidateForm(val),
        closeForm,
        formName: "dental-claim" /* DENTAL_CLAIM */,
        showNext: showInstructions,
        showInstructions,
        closeInstructions: () => setShowInstructions(!showInstructions),
        showOtherCoverage: showOcComps,
        changeOtherCoverage: (val) => setShowOcComps(val)
      }
    ),
    (errMsg1 || errMsg2) && /* @__PURE__ */ React27.createElement(ErrorModal, { onClose: closeForm }),
    (!apiData1 || !apiData2) && (!errMsg1 || !errMsg2) && /* @__PURE__ */ React27.createElement(
      Spinner4,
      {
        loading: !apiData1,
        loadingText: "Fetching the online form data!",
        size: "40px"
      }
    )
  );
}

// src/components/forms/forms-type/directreimbursement/directreimbursement-forms.component.tsx
import React36, { useEffect as useEffect34, useState as useState28 } from "react";
import { StackLayout as StackLayout35, Spinner as Spinner5 } from "@leagueplatform/genesis-core";

// src/components/forms/forms-type/directreimbursement/pages/policyholder-information.component.tsx
import React28, { useEffect as useEffect26, useState as useState22 } from "react";
import {
  Box as Box24,
  HeadingText as HeadingText23,
  FormField as FormField13,
  TextInput as TextInput13,
  Select as Select9,
  StackLayout as StackLayout27,
  UtilityText as UtilityText15,
  ParagraphText as ParagraphText12
} from "@leagueplatform/genesis-core";
function PolicyHolderInformation2(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const { errorHandling, profileResponseData, planDetailsResponseData } = props;
  const [form, setForm] = useState22({
    memberName: `${(_a = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a.firstName} ${(_b = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _b.lastName}`,
    memberId: (_c = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _c.memberId,
    addressLine1: (_d = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _d.address.line1,
    addressLine2: (_e = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _e.address.line2,
    city: (_f = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _f.address.city,
    state: (_g = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _g.address.state,
    zipCode: (_h = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _h.address.postalCode,
    businessPhoneNumber: formatPhoneNumber(
      (_i = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _i.csPhoneNumber
    ),
    homePhoneNumber: (_j = phoneNumberOption(profileResponseData)[0]) == null ? void 0 : _j.value,
    dependents: [],
    relationship: (_k = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _k.relationship
  });
  useEffect26(() => {
    errorHandling(true);
  });
  useEffect26(() => {
    var _a2, _b2, _c2;
    if (((_a2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a2.dependents) !== null) {
      const dependents = (_b2 = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _b2.dependents;
      const members = (_c2 = planDetailsResponseData == null ? void 0 : planDetailsResponseData.plan) == null ? void 0 : _c2.members;
      const memberNames = members.map(
        (mem) => `${mem.firstName} ${mem.lastName}`
      );
      const dependentsData = dependents.filter(
        (dep) => memberNames.indexOf(`${dep.firstName} ${dep.lastName}`) > -1
      );
      const dependentsUser = dependentsData.map((option) => ({
        name: `${option.firstName} ${option.lastName}`,
        dateOfBirth: `${option.dateOfBirth}`,
        relationship: `${option.relationship}`
      }));
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        dependents: dependentsUser
      }));
    }
  }, [(_l = planDetailsResponseData == null ? void 0 : planDetailsResponseData.plan) == null ? void 0 : _l.members, profileResponseData]);
  useEffect26(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React28.createElement(
    StackLayout27,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React28.createElement(
      Box24,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $five $one $none"
        }
      },
      /* @__PURE__ */ React28.createElement(
        HeadingText23,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Direct Reimbursement Claim Form"
      )
    ),
    /* @__PURE__ */ React28.createElement(
      Box24,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$none $two"
          // width: '100%',
        }
      },
      /* @__PURE__ */ React28.createElement(
        Box24,
        {
          css: {
            backgroundColor: "#F8F8F8",
            padding: "$one $two $one $three"
          }
        },
        /* @__PURE__ */ React28.createElement(
          HeadingText23,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Form Instructions:"
        ),
        /* @__PURE__ */ React28.createElement(
          Box24,
          {
            css: {
              marginTop: "$one",
              paddingLeft: "$one",
              width: "600px"
            }
          },
          /* @__PURE__ */ React28.createElement(UtilityText15, null, /* @__PURE__ */ React28.createElement("ol", null, /* @__PURE__ */ React28.createElement("li", { key: "1" }, "1. Use a separate claim form for each patient."), /* @__PURE__ */ React28.createElement("li", { key: "2" }, "2. Expenses for both examinations and eyewear can be claimed on this form. Only services listed on this form will be considered for reimbursement."), /* @__PURE__ */ React28.createElement("li", { key: "3" }, "3. Attach the receipts or bills for the services claimed."), /* @__PURE__ */ React28.createElement("li", { key: "4" }, "4. Enter the full name, address and zip code when a name and address field is required."), /* @__PURE__ */ React28.createElement("li", { key: "5" }, "5. All fields are required unless listed as optional.")))
        )
      )
    ),
    /* @__PURE__ */ React28.createElement(
      Box24,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$two $four $three $five"
        }
      },
      /* @__PURE__ */ React28.createElement(Box24, null, /* @__PURE__ */ React28.createElement(
        HeadingText23,
        {
          level: "3",
          size: {
            "@initial": "xl",
            "@mobile": "lg"
          }
        },
        "Step 1: Policy Holder Information"
      ), /* @__PURE__ */ React28.createElement(
        ParagraphText12,
        {
          css: {
            marginTop: "$one",
            paddingLeft: "$one",
            width: "600px"
          }
        },
        /* @__PURE__ */ React28.createElement("p", null, "This is the policy holder's information on file. If you need to make updates, you can change your contact information in Account Settings. The information here will not affect your claims submission.")
      )),
      /* @__PURE__ */ React28.createElement(Box24, null, /* @__PURE__ */ React28.createElement(
        Box24,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React28.createElement(FormField13, { id: "memberName", label: "Member Name" }, /* @__PURE__ */ React28.createElement(
          TextInput13,
          {
            disabled: true,
            value: `${(_m = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _m.firstName} ${(_n = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _n.lastName}`
          }
        ))
      ), /* @__PURE__ */ React28.createElement(
        Box24,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React28.createElement(FormField13, { id: "memberId", label: "Member ID" }, /* @__PURE__ */ React28.createElement(TextInput13, { disabled: true, value: form.memberId }))
      ), /* @__PURE__ */ React28.createElement(
        Box24,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React28.createElement(FormField13, { id: "addressLine1", label: "Address Line 1" }, /* @__PURE__ */ React28.createElement(TextInput13, { disabled: true, value: form.addressLine1 }))
      ), /* @__PURE__ */ React28.createElement(
        Box24,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React28.createElement(FormField13, { id: "addressLine2", label: "Address Line 2 (Optional)" }, /* @__PURE__ */ React28.createElement(TextInput13, { disabled: true, value: form.addressLine2 }))
      ), /* @__PURE__ */ React28.createElement(
        Box24,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React28.createElement(FormField13, { id: "city", label: "City" }, /* @__PURE__ */ React28.createElement(TextInput13, { disabled: true, value: form.city }))
      ), /* @__PURE__ */ React28.createElement(
        Box24,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React28.createElement(FormField13, { id: "state", label: "State" }, /* @__PURE__ */ React28.createElement(
          Select9,
          {
            name: "state",
            options: stateOption(),
            placeholder: "Please Select",
            id: "state",
            value: form.state,
            disabled: true
          }
        ))
      ), /* @__PURE__ */ React28.createElement(
        Box24,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React28.createElement(FormField13, { id: "zipCode", label: "Zip Code" }, /* @__PURE__ */ React28.createElement(TextInput13, { disabled: true, value: form.zipCode }))
      ), /* @__PURE__ */ React28.createElement(
        Box24,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React28.createElement(
          FormField13,
          {
            id: "businessPhoneNumber",
            label: "Business Phone Number (Optional)"
          },
          /* @__PURE__ */ React28.createElement(TextInput13, { disabled: true, value: form.businessPhoneNumber })
        )
      ), /* @__PURE__ */ React28.createElement(
        Box24,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React28.createElement(FormField13, { id: "homePhoneNumber", label: "Home Phone Number" }, /* @__PURE__ */ React28.createElement(TextInput13, { disabled: true, value: form.homePhoneNumber }))
      ))
    )
  );
}

// src/components/forms/forms-type/directreimbursement/pages/patient-information.component.tsx
import React29, { useEffect as useEffect27, useState as useState23 } from "react";
import {
  Box as Box25,
  HeadingText as HeadingText24,
  StackLayout as StackLayout28,
  ParagraphText as ParagraphText13,
  Radio as Radio5,
  Fieldset as Fieldset7,
  FormField as FormField14,
  TextInput as TextInput14,
  Select as Select10
} from "@leagueplatform/genesis-core";
import { format as format6 } from "date-fns";
function PatientInformation2(props) {
  var _a;
  const { errorHandling, nextButtonClicked, profileResponseData } = props;
  const [policyHolderRelationship] = useState23(
    (_a = profileResponseData == null ? void 0 : profileResponseData.demographics) == null ? void 0 : _a.relationship
  );
  const [isPolicyHolderPatient, setIsPolicyHolderPatient] = useState23("");
  const [form, setForm] = useState23({
    isPolicyHolderPatient: "",
    patientRelationship: "",
    patientName: "",
    patientDateOfBirth: ""
  });
  const [planDetailsData, setPlanDetailsData] = useState23([]);
  const [isPolicyHolderError, setIsPolicyHolderError] = useState23(false);
  const [errors, setErrors] = useState23({
    patientRelationship: false,
    patientName: false,
    patientDateOfBirth: false
  });
  const formField = isEmpty(form.patientRelationship) || isEmpty(form.patientName) || isEmpty(form.patientDateOfBirth);
  const isValid = isNotEmpty(form.patientRelationship) && isNotEmpty(form.patientName) && isNotEmpty(form.patientDateOfBirth);
  useEffect27(() => {
    if (isPolicyHolderPatient === "YES") {
      errorHandling(true);
      setIsPolicyHolderError(false);
    } else if (isPolicyHolderPatient === "") {
      errorHandling(false);
      setIsPolicyHolderError(true);
    } else if (formField) {
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  }, [formField, errorHandling, form, isPolicyHolderPatient]);
  useEffect27(() => {
    setErrors({
      patientRelationship: isEmpty(form.patientRelationship),
      patientName: isEmpty(form.patientName),
      patientDateOfBirth: isEmpty(form.patientDateOfBirth)
    });
    setIsPolicyHolderError(isEmpty(isPolicyHolderPatient));
  }, [nextButtonClicked, isValid, form, isPolicyHolderPatient]);
  useEffect27(() => {
    const pInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (pInfo) {
      setForm({
        isPolicyHolderPatient: pInfo == null ? void 0 : pInfo.isPolicyHolderPatient,
        patientRelationship: pInfo == null ? void 0 : pInfo.patientRelationship,
        patientName: pInfo == null ? void 0 : pInfo.patientName,
        patientDateOfBirth: pInfo == null ? void 0 : pInfo.patientDateOfBirth
      });
    }
    setPlanDetailsData(pInfo == null ? void 0 : pInfo.dependents);
    setIsPolicyHolderPatient(pInfo == null ? void 0 : pInfo.isPolicyHolderPatient);
  }, []);
  const updateErrorState = (value, id) => {
    const nextErrorState = __spreadProps(__spreadValues({}, errors), {
      [id]: isEmpty(value)
    });
    setErrors(nextErrorState);
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    if (id === "patientRelationship") {
      const newFormState = __spreadProps(__spreadValues({}, form), {
        [id]: value,
        patientName: "",
        patientDateOfBirth: ""
      });
      setForm(newFormState);
    } else if (id === "patientName") {
      const dob = planDetailsData.filter((patient) => patient.name === value).map((patient) => patient.dateOfBirth)[0];
      console.log(dob);
      const newFormState = __spreadProps(__spreadValues({}, form), {
        [id]: value,
        patientDateOfBirth: format6(new Date(dob), "MM/dd/yyyy")
      });
      setForm(newFormState);
    } else {
      const nextFormState = __spreadProps(__spreadValues({}, form), {
        [id]: value
      });
      setForm(nextFormState);
    }
    updateErrorState(value, id);
  };
  const updateIsPolicyHolderPatient = (e) => {
    const { value, id } = e.target;
    if (value === "Yes") {
      setIsPolicyHolderPatient("YES");
      setIsPolicyHolderError(false);
      const nextFormState = {
        isPolicyHolderPatient: "YES",
        patientRelationship: "",
        patientName: "",
        patientDateOfBirth: ""
      };
      setForm(nextFormState);
    } else {
      setIsPolicyHolderPatient("NO");
      setIsPolicyHolderError(false);
      const nextFormState = {
        isPolicyHolderPatient: "NO",
        patientRelationship: "",
        patientName: "",
        patientDateOfBirth: ""
      };
      setForm(nextFormState);
    }
    updateErrorState(value, id);
  };
  const patientRelationshipOption = (patientData) => {
    const patientObj = {
      value: "",
      label: ""
    };
    const relationshipArrData = patientData.map((pat) => pat.relationship).filter((rel) => rel !== "Subscriber");
    const filteredRelationshipArrData = [...new Set(relationshipArrData)];
    const patientRelationshipData = filteredRelationshipArrData.map(
      (rel) => ({
        value: rel,
        label: rel
      })
    );
    patientRelationshipData == null ? void 0 : patientRelationshipData.unshift(patientObj);
    return patientRelationshipData;
  };
  const patientNameOption = (patientRelationship, patientData) => {
    const patientNames = patientData.filter((patient) => patient.relationship === patientRelationship).map((patient) => patient.name);
    const patientNameData = patientNames.map((patient) => ({
      value: patient,
      label: patient
    }));
    const patientObj = {
      value: "",
      label: ""
    };
    patientNameData.unshift(patientObj);
    return patientNameData;
  };
  useEffect27(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React29.createElement(
    StackLayout28,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React29.createElement(
      Box25,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $five $one $none"
        }
      },
      /* @__PURE__ */ React29.createElement(
        HeadingText24,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Direct Reimbursement Claim Form"
      )
    ),
    /* @__PURE__ */ React29.createElement(
      Box25,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$two $four $three $five"
        }
      },
      /* @__PURE__ */ React29.createElement(Box25, null, /* @__PURE__ */ React29.createElement(
        HeadingText24,
        {
          level: "3",
          size: {
            "@initial": "xl",
            "@mobile": "lg"
          }
        },
        "Step 2: Patient Information"
      ), /* @__PURE__ */ React29.createElement(
        ParagraphText13,
        {
          css: {
            marginTop: "$one",
            width: "600px"
          }
        },
        "Is the policy holder the patient?"
      ), /* @__PURE__ */ React29.createElement(
        Fieldset7,
        {
          legend: "",
          css: {
            display: "flex",
            width: "436px",
            height: "24px"
          }
        },
        /* @__PURE__ */ React29.createElement(
          Radio5,
          {
            id: "isPolicyHolderPatient-1",
            name: "isPolicyHolderPatient",
            checked: policyHolderRelationship === "Subscriber" && planDetailsData.length === 0 || isPolicyHolderPatient === "YES",
            disabled: policyHolderRelationship !== "Subscriber",
            value: "Yes" /* YES */,
            label: "Yes" /* YES */,
            onChange: updateIsPolicyHolderPatient
          }
        ),
        /* @__PURE__ */ React29.createElement(
          Radio5,
          {
            id: "isPolicyHolderPatient-2",
            name: "isPolicyHolderPatient",
            checked: policyHolderRelationship !== "Subscriber" || isPolicyHolderPatient === "NO",
            disabled: policyHolderRelationship === "Subscriber" && planDetailsData.length === 0,
            value: "No" /* NO */,
            label: "No" /* NO */,
            onChange: updateIsPolicyHolderPatient
          }
        )
      ), isPolicyHolderError && /* @__PURE__ */ React29.createElement(
        "p",
        {
          style: {
            color: "red",
            paddingTop: "10px",
            fontSize: "12px",
            margin: "0"
          }
        },
        "This field is required."
      )),
      (policyHolderRelationship !== "Subscriber" || isPolicyHolderPatient === "NO") && /* @__PURE__ */ React29.createElement(
        Box25,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            padding: "$two $none"
          }
        },
        /* @__PURE__ */ React29.createElement(
          Box25,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "$oneAndHalf $four $none $none"
            }
          },
          /* @__PURE__ */ React29.createElement(
            FormField14,
            {
              id: "patientRelationship",
              label: "Patient's Relationship to Policy Holder",
              statusIconLabel: "Error",
              inputStatus: errors.patientRelationship ? "error" : void 0,
              statusMessage: errors.patientRelationship ? "This field is required." : ""
            },
            /* @__PURE__ */ React29.createElement(
              Select10,
              {
                options: patientRelationshipOption(planDetailsData),
                onChange: onUpdateField,
                value: form.patientRelationship
              }
            )
          )
        ),
        /* @__PURE__ */ React29.createElement(
          Box25,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "$oneAndHalf $four $none $none"
            }
          },
          /* @__PURE__ */ React29.createElement(
            FormField14,
            {
              id: "patientName",
              label: "Patient Name",
              statusIconLabel: "Error",
              inputStatus: errors.patientName ? "error" : void 0,
              statusMessage: errors.patientName ? "This field is required." : ""
            },
            /* @__PURE__ */ React29.createElement(
              Select10,
              {
                options: patientNameOption(
                  form.patientRelationship,
                  planDetailsData
                ),
                onChange: onUpdateField,
                value: form.patientName
              }
            )
          )
        ),
        /* @__PURE__ */ React29.createElement(
          Box25,
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "$oneAndHalf $four $none $none"
            }
          },
          /* @__PURE__ */ React29.createElement(
            FormField14,
            {
              id: "patientDateOfBirth",
              label: "Date of Birth (MM/DD/YYYY)"
            },
            /* @__PURE__ */ React29.createElement(TextInput14, { disabled: true, value: form.patientDateOfBirth })
          )
        )
      )
    )
  );
}

// src/components/forms/forms-type/directreimbursement/pages/service-information.component.tsx
import React33, { useEffect as useEffect31, useState as useState25 } from "react";
import {
  Box as Box29,
  HeadingText as HeadingText27,
  StackLayout as StackLayout32,
  Divider,
  TextAction as TextAction9,
  FormField as FormField16,
  TextInput as TextInput16
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset11 } from "@leagueplatform/asset-config";

// src/components/forms/layout/removeServiceWarningModal.tsx
import React30, { useEffect as useEffect28 } from "react";
import {
  Box as Box26,
  StackLayout as StackLayout29,
  Modal as Modal7,
  ParagraphText as ParagraphText14,
  UtilityText as UtilityText16,
  HeadingText as HeadingText25,
  TextAction as TextAction7
} from "@leagueplatform/genesis-core";
function RemoveServiceWarningModal(props) {
  const { onClose, indexSelected, setIndexToRemove } = props;
  useEffect28(() => {
    setIndexToRemove(indexSelected);
  }, [indexSelected, setIndexToRemove]);
  return /* @__PURE__ */ React30.createElement(Modal7.Root, null, /* @__PURE__ */ React30.createElement(Modal7.Trigger, null, /* @__PURE__ */ React30.createElement(
    Box26,
    {
      css: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        position: "relative",
        marginBottom: "$two"
      }
    },
    /* @__PURE__ */ React30.createElement(
      TextAction7,
      {
        size: {
          "@initial": "large",
          "@mobile": "medium",
          "@tablet": "large"
        },
        as: "button"
      },
      "Remove This Service"
    )
  )), /* @__PURE__ */ React30.createElement(
    Modal7.Content,
    {
      showCloseButton: false,
      padding: "$none",
      width: { "@initial": 650, "@mobile": "100%" }
    },
    /* @__PURE__ */ React30.createElement(
      StackLayout29,
      {
        css: { textAlign: "center", padding: "$three $three" },
        horizontalAlignment: "stretch"
      },
      /* @__PURE__ */ React30.createElement(Modal7.Title, null, /* @__PURE__ */ React30.createElement(
        HeadingText25,
        {
          level: "display",
          size: "sm",
          css: { padding: "$oneAndHalf $none" }
        },
        "Are you sure you want to remove this service?"
      )),
      /* @__PURE__ */ React30.createElement(ParagraphText14, { emphasis: "subtle" }, "The selected service will be removed and will no longer be available for viewing."),
      /* @__PURE__ */ React30.createElement(
        Box26,
        {
          css: {
            display: "flex",
            flexDirection: "row",
            padding: "$two $four $one $four",
            justifyContent: "space-around"
          }
        },
        /* @__PURE__ */ React30.createElement(Modal7.Close, null, /* @__PURE__ */ React30.createElement(
          UtilityText16,
          {
            css: {
              color: "#0074C9",
              cursor: "pointer"
            }
          },
          "No"
        )),
        /* @__PURE__ */ React30.createElement(
          UtilityText16,
          {
            css: {
              color: "#0074C9",
              cursor: "pointer"
            },
            onClick: onClose
          },
          "Yes"
        )
      )
    )
  ));
}

// src/components/forms/layout/removeServiceSuccessModal.tsx
import React31, { useEffect as useEffect29 } from "react";
import {
  Box as Box27,
  HeadingText as HeadingText26,
  StackLayout as StackLayout30,
  Modal as Modal8,
  TextAction as TextAction8,
  ParagraphText as ParagraphText15
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset10 } from "@leagueplatform/asset-config";
function RemoveServiceSuccessModal(props) {
  const { onClose, openSuccessModal } = props;
  useEffect29(() => {
    const modalBtn = document.getElementById("successModalTrigger");
    modalBtn == null ? void 0 : modalBtn.click();
  }, [openSuccessModal]);
  return /* @__PURE__ */ React31.createElement(Modal8.Root, null, /* @__PURE__ */ React31.createElement(Modal8.Trigger, null, /* @__PURE__ */ React31.createElement(
    Box27,
    {
      css: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        position: "relative",
        left: "90px",
        marginBottom: "$two"
      }
    },
    /* @__PURE__ */ React31.createElement(
      TextAction8,
      {
        id: "successModalTrigger",
        size: {
          "@initial": "large",
          "@mobile": "medium",
          "@tablet": "large"
        },
        as: "button"
      },
      "Remove This Service"
    )
  )), /* @__PURE__ */ React31.createElement(
    Modal8.Content,
    {
      showCloseButton: false,
      padding: "$none",
      width: { "@initial": 650, "@mobile": "100%" }
    },
    /* @__PURE__ */ React31.createElement(
      StackLayout30,
      {
        css: { textAlign: "center", padding: "$three $three" },
        horizontalAlignment: "stretch"
      },
      /* @__PURE__ */ React31.createElement(
        Box27,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }
        },
        " ",
        /* @__PURE__ */ React31.createElement(
          "img",
          {
            src: handleStaticAsset10("CHECK_ICON" /* CHECK_ICON */),
            alt: "cross icon",
            width: "40px",
            style: { cursor: "pointer" }
          }
        )
      ),
      /* @__PURE__ */ React31.createElement(Modal8.Title, null, /* @__PURE__ */ React31.createElement(
        HeadingText26,
        {
          level: "display",
          size: "sm",
          css: { padding: "$oneAndHalf $none" }
        },
        "Success"
      )),
      /* @__PURE__ */ React31.createElement(ParagraphText15, { emphasis: "subtle" }, "You have successfully removed this service."),
      /* @__PURE__ */ React31.createElement(
        TextAction8,
        {
          css: {
            flexDirection: "column",
            width: "100%"
          },
          as: "button",
          onClick: onClose
        },
        "Close"
      )
    )
  ));
}

// src/components/forms/forms-type/directreimbursement/pages/service-details-information.component.tsx
import React32, { useState as useState24, useEffect as useEffect30 } from "react";
import {
  Box as Box28,
  FormField as FormField15,
  TextInput as TextInput15,
  Select as Select11,
  StackLayout as StackLayout31
} from "@leagueplatform/genesis-core";
import { CalendarView as CalendarView2 } from "@leagueplatform/web-common-components";
function ServiceDetailsInformation(props) {
  const { serviceDetails, index, updateService, updateTotalExpenses } = props;
  const [form, setForm] = useState24({
    serviceType: "",
    dateOfService: "",
    expenseIncurred: "",
    expenseValue: 0,
    attachments: []
  });
  const [errors, setErrors] = useState24({
    serviceType: "",
    dateOfService: "",
    expenseIncurred: "",
    attachments: []
  });
  const [isCalendarVisible, setIsCalendarVisible] = useState24(false);
  useEffect30(() => {
    const nextFormState = __spreadValues({}, serviceDetails);
    setForm(nextFormState);
  }, [serviceDetails]);
  const updateErrorState = (value, id) => {
    setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
      [id]: isEmpty(value)
    }));
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    let expense = "";
    let expenseValue = 0;
    if (id === "expenseIncurred") {
      if (value === "$") {
        expense = "";
        expenseValue = 0;
      } else if (value.indexOf("$") === -1) {
        expense = `$${value}`;
        expenseValue = Number(value);
      } else {
        expense = value;
        expenseValue = Number(value.substring(1, value.length));
      }
      const nextFormState = __spreadProps(__spreadValues({}, form), {
        [id]: expense,
        expenseValue
      });
      setForm(nextFormState);
      updateService(nextFormState, index);
    } else {
      const nextFormState = __spreadProps(__spreadValues({}, form), {
        [id]: value
      });
      setForm(nextFormState);
      updateService(nextFormState, index);
    }
    updateErrorState(value, id);
  };
  const attachmentsAdded = (attachmentsObj) => {
    const nextFormState = __spreadProps(__spreadValues({}, form), {
      attachments: attachmentsObj
    });
    setForm(nextFormState);
    updateService(nextFormState, index);
    updateErrorState(attachmentsObj, "attachments");
  };
  const serviceTypeOption = (serviceData) => {
    const serviceNameData = serviceData.map((service) => ({
      value: service,
      label: service
    }));
    return serviceNameData;
  };
  const dateSelected = (e) => {
    const day = e.day.toString().padStart(2, "0");
    const month = e.month.toString().padStart(2, "0");
    setIsCalendarVisible(false);
    const datePicked = {
      target: {
        id: "dateOfService",
        value: `${month}/${day}/${e.year}`
      }
    };
    onUpdateField(datePicked);
  };
  const onBlurField = (event) => {
    const { id } = event.target;
    if (id === "expenseIncurred") {
      const currency = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(form.expenseValue);
      const nextFormState = __spreadProps(__spreadValues({}, form), {
        [id]: currency
      });
      setForm(nextFormState);
      updateService(nextFormState, index);
      updateTotalExpenses(nextFormState, "update");
    }
    updateErrorState(event.target.value, event.target.id);
  };
  const onKeyPressField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  return /* @__PURE__ */ React32.createElement(
    StackLayout31,
    {
      css: {
        backgroundColor: "White",
        width: "100%"
      }
    },
    /* @__PURE__ */ React32.createElement(
      Box28,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$one $none",
          width: "100%"
        }
      },
      /* @__PURE__ */ React32.createElement(
        Box28,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$oneAndHalf $twoAndHalf $none $none"
          }
        },
        /* @__PURE__ */ React32.createElement(
          FormField15,
          {
            id: "serviceType",
            label: "Service Type",
            inputStatus: errors.serviceType ? "error" : void 0,
            statusIconLabel: errors.serviceType ? "Error" : "",
            statusMessage: errors.serviceType ? errors.serviceType : ""
          },
          /* @__PURE__ */ React32.createElement(
            Select11,
            {
              options: serviceTypeOption(SERVICE_TYPE_VALUE),
              onChange: onUpdateField,
              value: form.serviceType
            }
          )
        )
      ),
      /* @__PURE__ */ React32.createElement(
        Box28,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$oneAndHalf $twoAndHalf $none $none"
          }
        },
        /* @__PURE__ */ React32.createElement(
          FormField15,
          {
            id: "dateOfService",
            label: "Date of Service (MM/DD/YYYY)",
            inputStatus: errors.dateOfService ? "error" : void 0,
            statusIconLabel: errors.dateOfService ? "Error" : "",
            statusMessage: errors.dateOfService ? errors.dateOfService : ""
          },
          /* @__PURE__ */ React32.createElement(
            TextInput15,
            {
              value: form.dateOfService,
              placeholder: "MM/DD/YYYY",
              onClick: () => setIsCalendarVisible(true)
            }
          )
        )
      ),
      isCalendarVisible && /* @__PURE__ */ React32.createElement(
        Box28,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$oneAndHalf $twoAndHalf $none $none"
          }
        },
        /* @__PURE__ */ React32.createElement(
          FormField15,
          {
            id: "calendarDate",
            label: "Date of Service (MM/DD/YYYY)",
            css: {
              width: "550px"
            }
          },
          /* @__PURE__ */ React32.createElement(
            CalendarView2,
            {
              onChange: (e) => dateSelected(e),
              css: {
                width: "fit-content"
              }
            }
          )
        )
      ),
      /* @__PURE__ */ React32.createElement(
        Box28,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "$oneAndHalf $twoAndHalf $none $none"
          }
        },
        /* @__PURE__ */ React32.createElement(
          FormField15,
          {
            id: "expenseIncurred",
            label: "Expense Incurred",
            inputStatus: errors.expenseIncurred ? "error" : void 0,
            statusIconLabel: errors.expenseIncurred ? "Error" : "",
            statusMessage: errors.expenseIncurred ? errors.expenseIncurred : ""
          },
          /* @__PURE__ */ React32.createElement(
            TextInput15,
            {
              onChange: onUpdateField,
              value: form.expenseIncurred,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ),
      /* @__PURE__ */ React32.createElement(Box28, null, /* @__PURE__ */ React32.createElement(
        AttachmentReusableComponent,
        {
          displayText: "Attach Itemized Bill or Receipt",
          acceptTypes: [".pdf", ".doc", ".png", ".gif", ".jpg"],
          onUpdate: attachmentsAdded,
          attachments: form.attachments,
          serviceIndex: `vision-service-${index}`
        }
      ))
    )
  );
}

// src/components/forms/forms-type/directreimbursement/pages/service-information.component.tsx
function ServiceInformation() {
  const [form] = useState25({
    serviceType: "",
    dateOfService: "",
    expenseIncurred: "",
    expenseValue: 0,
    attachments: []
  });
  const [serviceArr, setServiceArr] = useState25([
    {
      serviceType: "",
      dateOfService: "",
      expenseIncurred: "",
      expenseValue: 0,
      attachments: []
    }
  ]);
  const [totalExpenses, setTotalExpenses] = useState25("$0.00");
  const [indexToRemove, setIndexToRemove] = useState25(0);
  const [isRemoveServiceSuccessModal, setIsRemoveServiceSuccessModal] = useState25(false);
  const addService = () => {
    const serviceArrCopy = [...serviceArr];
    serviceArrCopy.push(form);
    setServiceArr(serviceArrCopy);
  };
  const updateService = (serviceData, index) => {
    const serviceArrCopy = [...serviceArr];
    serviceArrCopy[index] = serviceData;
    setServiceArr(serviceArrCopy);
  };
  const updateTotalExpenses = (serviceData, type) => {
    let newTotal = Number(totalExpenses.substring(1, totalExpenses.length));
    if (type === "update") {
      newTotal += serviceData.expenseValue;
    }
    if (type === "remove") {
      newTotal -= serviceData.expenseValue;
    }
    const currency = Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(newTotal);
    setTotalExpenses(currency);
  };
  const removeService = () => {
    const index = indexToRemove;
    const serviceRemoved = serviceArr[index];
    const serviceArrCopy = [...serviceArr];
    serviceArrCopy.splice(index, 1);
    setServiceArr(serviceArrCopy);
    setIsRemoveServiceSuccessModal(true);
    updateTotalExpenses(serviceRemoved, "remove");
  };
  useEffect31(() => {
    setServiceArr(serviceArr);
  }, [serviceArr]);
  console.log("Service Array -> ", serviceArr);
  return /* @__PURE__ */ React33.createElement(
    StackLayout32,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    isRemoveServiceSuccessModal && /* @__PURE__ */ React33.createElement(
      RemoveServiceSuccessModal,
      {
        onClose: () => setIsRemoveServiceSuccessModal(false),
        openSuccessModal: isRemoveServiceSuccessModal
      }
    ),
    /* @__PURE__ */ React33.createElement(
      Box29,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $five $one $none"
        }
      },
      /* @__PURE__ */ React33.createElement(
        HeadingText27,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Direct Reimbursement Claim Form"
      )
    ),
    /* @__PURE__ */ React33.createElement(
      Box29,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$two $four $three $five",
          width: "740px"
        }
      },
      /* @__PURE__ */ React33.createElement(Box29, null, /* @__PURE__ */ React33.createElement(
        HeadingText27,
        {
          level: "3",
          size: {
            "@initial": "xl",
            "@mobile": "lg"
          }
        },
        "Step 3: Service Information"
      ))
    ),
    serviceArr.map((ser, index) => /* @__PURE__ */ React33.createElement(
      Box29,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$none $four $one $four"
        }
      },
      /* @__PURE__ */ React33.createElement(
        HeadingText27,
        {
          level: "3",
          size: {
            "@initial": "xl",
            "@mobile": "lg"
          }
        },
        "Service ",
        index + 1
      ),
      /* @__PURE__ */ React33.createElement(
        ServiceDetailsInformation,
        {
          serviceDetails: ser,
          index,
          updateService,
          updateTotalExpenses
        }
      ),
      serviceArr.length > 1 && /* @__PURE__ */ React33.createElement(
        Box29,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            padding: "$two $four $none $four",
            alignItems: "end"
          }
        },
        /* @__PURE__ */ React33.createElement(
          RemoveServiceWarningModal,
          {
            onClose: removeService,
            indexSelected: index,
            setIndexToRemove
          }
        )
      ),
      /* @__PURE__ */ React33.createElement(Divider, null)
    )),
    serviceArr.length < 9 && /* @__PURE__ */ React33.createElement(
      Box29,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$none $four $one $four"
        }
      },
      /* @__PURE__ */ React33.createElement(
        TextAction9,
        {
          icon: handleStaticAsset11("ADD_ICON" /* ADD_ICON */),
          size: {
            "@initial": "large",
            "@mobile": "medium",
            "@tablet": "large"
          },
          as: "button",
          onClick: addService
        },
        "Add Another Service"
      )
    ),
    /* @__PURE__ */ React33.createElement(
      Box29,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "$oneAndHalf $five $one $four",
          width: "700px"
        }
      },
      /* @__PURE__ */ React33.createElement(FormField16, { id: "totalExpenses", label: "Total Expenses" }, /* @__PURE__ */ React33.createElement(TextInput16, { disabled: true, value: totalExpenses }))
    )
  );
}

// src/components/forms/forms-type/directreimbursement/pages/examinerDispenser-information.component.tsx
import React34, { useEffect as useEffect32, useState as useState26 } from "react";
import {
  Box as Box30,
  HeadingText as HeadingText28,
  FormField as FormField17,
  TextInput as TextInput17,
  Select as Select12,
  StackLayout as StackLayout33,
  UtilityText as UtilityText17,
  Fieldset as Fieldset8,
  Radio as Radio6
} from "@leagueplatform/genesis-core";
function ExaminerDispenserInformation(props) {
  const { errorHandling, nextButtonClicked } = props;
  const [phNumError, setPhNumError] = useState26("");
  const [zipCodeError, setZipCodeError] = useState26("");
  const [faxNumberError, setFaxNumberError] = useState26("");
  const [isDispenserSame, setisDispenserSame] = useState26("");
  const [form, setForm] = useState26({
    fullName: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
    prescriberPhoneNumber: "",
    faxNumber: ""
  });
  const [errors, setErrors] = useState26({
    fullName: false,
    addressLine1: false,
    city: false,
    state: false,
    zipCode: false,
    prescriberPhoneNumber: false,
    faxNumber: false
  });
  const formField = isEmpty(form.fullName) || isEmpty(form.addressLine1) || isEmpty(form.city) || isEmpty(form.state) || isEmpty(form.zipCode) || isEmpty(form.prescriberPhoneNumber) || isValidatePhoneLength(form.prescriberPhoneNumber) || isValidZipCodeLength(form.zipCode) || isValidatePhoneLength(form.faxNumber);
  const isValid = isNotEmpty(form.fullName) && isNotEmpty(form.addressLine1) && isNotEmpty(form.city) && isNotEmpty(form.state) && isNotEmpty(form.zipCode) && isNotEmpty(form.prescriberPhoneNumber) && !isValidatePhoneLength(form.prescriberPhoneNumber) && !isValidZipCodeLength(form.zipCode);
  useEffect32(() => {
    if (formField || errors.faxNumber || errors.prescriberPhoneNumber || errors.zipCode) {
      errorHandling(false);
      if (isEmpty(form.zipCode)) {
        setZipCodeError("This field is required.");
      } else if (isValidZipCodeLength(form.zipCode)) {
        setZipCodeError("Enter a valid zip code.");
      } else {
        setZipCodeError("");
      }
      if (isValidatePhoneLength(form.faxNumber)) {
        setFaxNumberError("Enter a valid fax number.");
      } else {
        setFaxNumberError("");
      }
      if (isEmpty(form.prescriberPhoneNumber)) {
        setPhNumError("Your prescriber's phone number is required.");
      } else if (isValidatePhoneLength(form.prescriberPhoneNumber)) {
        setPhNumError("Enter a valid phone number.");
      } else {
        setPhNumError("");
      }
    } else {
      errorHandling(true);
    }
  }, [formField, errors.faxNumber, errorHandling, form, errors]);
  useEffect32(() => {
    if (nextButtonClicked) {
      if (!isValid || isValidatePhoneLength(form.faxNumber)) {
        setErrors({
          fullName: isEmpty(form.fullName),
          addressLine1: isEmpty(form.addressLine1),
          city: isEmpty(form.city),
          state: isEmpty(form.state),
          zipCode: isEmpty(form.zipCode) || isValidZipCodeLength(form.zipCode),
          prescriberPhoneNumber: isEmpty(form.prescriberPhoneNumber) || isValidatePhoneLength(form.prescriberPhoneNumber),
          faxNumber: isValidatePhoneLength(form.faxNumber)
        });
      }
    }
  }, [nextButtonClicked, isValid, form]);
  const updateErrorState = (value, id) => {
    if (id === "prescriberPhoneNumber") {
      if (isEmpty(form.prescriberPhoneNumber)) {
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          prescriberPhoneNumber: true
        }));
      } else if (isValidatePhoneLength(value)) {
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          prescriberPhoneNumber: true
        }));
      } else {
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          prescriberPhoneNumber: false
        }));
      }
    } else if (id === "zipCode") {
      if (isEmpty(value)) {
        setZipCodeError("This field is required.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          zipCode: true
        }));
      } else if (isValidZipCodeLength(value)) {
        setZipCodeError("Enter a valid zip code.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          zipCode: true
        }));
      } else {
        setZipCodeError("");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          zipCode: false
        }));
      }
    } else if (id === "faxNumber") {
      if (isValidatePhoneLength(value)) {
        setFaxNumberError("Enter a valid fax number.");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          faxNumber: true
        }));
      } else {
        setFaxNumberError("");
        setErrors((prevState) => __spreadProps(__spreadValues({}, prevState), {
          faxNumber: false
        }));
      }
    } else {
      const nextErrorState = __spreadProps(__spreadValues({}, errors), {
        [id]: isEmpty(value)
      });
      setErrors(nextErrorState);
    }
  };
  const onUpdateField = (event) => {
    const { value, id } = event.target;
    const nextFormState = __spreadProps(__spreadValues({}, form), {
      [event.target.id]: /^\s/.test(event.target.value) ? "" : event.target.value
    });
    setForm(nextFormState);
    updateErrorState(event.target.value, event.target.id);
    if (id === "fullName") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        fullName: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^a-zA-Z0-9 ]+/gi, "")
      }));
    }
    if (id === "city") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        city: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^a-zA-Z ]+/gi, "")
      }));
    }
    if (id === "zipCode") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        zipCode: isNoSpace(value) ? "" : value == null ? void 0 : value.replace(/[^0-9]+/gi, "")
      }));
    }
    if (id === "faxNumber") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        faxNumber: isNoSpace(value) ? "" : formatPhoneNumber(value)
      }));
    }
    if (id === "prescriberPhoneNumber") {
      setForm((prevState) => __spreadProps(__spreadValues({}, prevState), {
        prescriberPhoneNumber: isNoSpace(value) ? "" : formatPhoneNumber(value)
      }));
    }
  };
  useEffect32(() => {
    const pInfo = JSON.parse(sessionStorage.getItem("formData") || "{}");
    if (pInfo) {
      setForm({
        fullName: pInfo == null ? void 0 : pInfo.fullName,
        addressLine1: pInfo == null ? void 0 : pInfo.examinerAddressLine1,
        addressLine2: pInfo == null ? void 0 : pInfo.examinerAddressLine2,
        city: pInfo == null ? void 0 : pInfo.examinerCity,
        state: pInfo == null ? void 0 : pInfo.examinerState,
        zipCode: pInfo == null ? void 0 : pInfo.examinerZipCode,
        prescriberPhoneNumber: pInfo == null ? void 0 : pInfo.examinerPhoneNumber,
        faxNumber: pInfo == null ? void 0 : pInfo.examinerFaxNumber
      });
    }
  }, []);
  const onBlurField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  const onKeyPressField = (event) => {
    updateErrorState(event.target.value, event.target.id);
  };
  useEffect32(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);
  return /* @__PURE__ */ React34.createElement(
    StackLayout33,
    {
      css: {
        backgroundColor: "White",
        width: "800px",
        marginLeft: "70px"
      },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React34.createElement(
      Box30,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $four $one $four"
        }
      },
      /* @__PURE__ */ React34.createElement(
        HeadingText28,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Direct Reimbursement Claim Form"
      ),
      /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            marginTop: "$two",
            marginBottom: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          HeadingText28,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 4: Examiner's Information"
        )
      ),
      /* @__PURE__ */ React34.createElement(Box30, null, /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "fullName",
            label: "Examiner Name (First, Last)",
            statusIconLabel: "Error",
            inputStatus: errors.fullName ? "error" : void 0,
            statusMessage: errors.fullName ? "Prescriber's full name is required." : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "fullName",
              value: form.fullName,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "addressLine1",
            label: "Examiner Address Line 1",
            statusIconLabel: "Error",
            inputStatus: errors.addressLine1 ? "error" : void 0,
            statusMessage: errors.addressLine1 ? "This field is required." : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "addressLine1",
              value: form.addressLine1,
              onChange: onUpdateField,
              maxLength: 50,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "addressLine2",
            label: "Examiner Address Line 2 (Optional)"
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "addressLine2",
              value: form.addressLine2,
              onChange: onUpdateField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "city",
            label: "City",
            statusIconLabel: "Error",
            inputStatus: errors.city ? "error" : void 0,
            statusMessage: errors.city ? "This field is required." : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "city",
              value: form.city,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "state",
            label: "State",
            statusIconLabel: "Error",
            inputStatus: errors.state ? "error" : void 0,
            statusMessage: errors.state ? "This field is required." : ""
          },
          /* @__PURE__ */ React34.createElement(
            Select12,
            {
              name: "state",
              options: stateOption(),
              placeholder: "Please Select",
              id: "select-error",
              value: form.state,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "zipCode",
            label: "Zip Code",
            statusIconLabel: "Error",
            inputStatus: errors.zipCode ? "error" : void 0,
            statusMessage: errors.zipCode ? zipCodeError : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              pattern: "[0-9]*",
              name: "zipCode",
              value: form.zipCode,
              onChange: onUpdateField,
              maxLength: 5,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "faxNumber",
            label: "State License Number (Optional)",
            statusIconLabel: "Error",
            inputStatus: errors.faxNumber ? "error" : void 0,
            statusMessage: errors.faxNumber ? faxNumberError : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "faxNumber",
              value: form.faxNumber,
              onChange: onUpdateField,
              maxLength: 14
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "prescriberPhoneNumber",
            label: "Phone Number",
            statusIconLabel: "Error",
            inputStatus: errors.prescriberPhoneNumber ? "error" : void 0,
            statusMessage: errors.prescriberPhoneNumber ? phNumError : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "prescriberPhoneNumber",
              value: form.prescriberPhoneNumber,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 14
            }
          )
        )
      )),
      /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            marginTop: "$two",
            marginBottom: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          HeadingText28,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Dispenser's Information"
        ),
        /* @__PURE__ */ React34.createElement(UtilityText17, null, /* @__PURE__ */ React34.createElement("p", null, "Fill out the dispenser information if the claims you are submitting include dispenser services."), /* @__PURE__ */ React34.createElement("p", null, "Is the dispenser's information the same as the Examiner?")),
        /* @__PURE__ */ React34.createElement(
          Fieldset8,
          {
            legend: "",
            css: {
              display: "flex",
              width: "436px",
              height: "24px"
            }
          },
          /* @__PURE__ */ React34.createElement(
            Radio6,
            {
              id: "direct-reimbursement-1",
              name: isDispenserSame,
              checked: isDispenserSame === "YES",
              value: "Yes" /* YES */,
              label: "Yes" /* YES */,
              onChange: () => {
                setisDispenserSame("YES");
              }
            }
          ),
          /* @__PURE__ */ React34.createElement(
            Radio6,
            {
              id: "direct-reimbursement-2",
              name: isDispenserSame,
              checked: isDispenserSame === "NO",
              value: "No" /* NO */,
              label: "No" /* NO */,
              onChange: () => {
                setisDispenserSame("NO");
              }
            }
          )
        )
      ),
      isDispenserSame === "NO" && /* @__PURE__ */ React34.createElement(Box30, null, /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "fullName",
            label: "Dispenser Name (First, Last)",
            statusIconLabel: "Error",
            inputStatus: errors.fullName ? "error" : void 0,
            statusMessage: errors.fullName ? "Prescriber's full name is required." : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "fullName",
              value: form.fullName,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "addressLine1",
            label: "Dispenser Address Line 1",
            statusIconLabel: "Error",
            inputStatus: errors.addressLine1 ? "error" : void 0,
            statusMessage: errors.addressLine1 ? "This field is required." : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "addressLine1",
              value: form.addressLine1,
              onChange: onUpdateField,
              maxLength: 50,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "addressLine2",
            label: "Dispenser Address Line 2 (Optional)"
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "addressLine2",
              value: form.addressLine2,
              onChange: onUpdateField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "city",
            label: "City",
            statusIconLabel: "Error",
            inputStatus: errors.city ? "error" : void 0,
            statusMessage: errors.city ? "This field is required." : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "city",
              value: form.city,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 50
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "state",
            label: "State",
            statusIconLabel: "Error",
            inputStatus: errors.state ? "error" : void 0,
            statusMessage: errors.state ? "This field is required." : ""
          },
          /* @__PURE__ */ React34.createElement(
            Select12,
            {
              name: "state",
              options: stateOption(),
              placeholder: "Please Select",
              id: "select-error",
              value: form.state,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "zipCode",
            label: "Zip Code",
            statusIconLabel: "Error",
            inputStatus: errors.zipCode ? "error" : void 0,
            statusMessage: errors.zipCode ? zipCodeError : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              pattern: "[0-9]*",
              name: "zipCode",
              value: form.zipCode,
              onChange: onUpdateField,
              maxLength: 5,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "faxNumber",
            label: "State License Number (Optional)",
            statusIconLabel: "Error",
            inputStatus: errors.faxNumber ? "error" : void 0,
            statusMessage: errors.faxNumber ? faxNumberError : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "faxNumber",
              value: form.faxNumber,
              onChange: onUpdateField,
              maxLength: 14
            }
          )
        )
      ), /* @__PURE__ */ React34.createElement(
        Box30,
        {
          css: {
            padding: "$one"
          }
        },
        /* @__PURE__ */ React34.createElement(
          FormField17,
          {
            id: "prescriberPhoneNumber",
            label: "Phone Number",
            statusIconLabel: "Error",
            inputStatus: errors.prescriberPhoneNumber ? "error" : void 0,
            statusMessage: errors.prescriberPhoneNumber ? phNumError : ""
          },
          /* @__PURE__ */ React34.createElement(
            TextInput17,
            {
              name: "prescriberPhoneNumber",
              value: form.prescriberPhoneNumber,
              onChange: onUpdateField,
              onBlur: onBlurField,
              onKeyPress: onKeyPressField,
              maxLength: 14
            }
          )
        )
      ))
    )
  );
}

// src/components/forms/forms-type/directreimbursement/pages/acknowledgement-information.component.tsx
import React35, { useEffect as useEffect33, useState as useState27 } from "react";
import {
  Box as Box31,
  HeadingText as HeadingText29,
  StackLayout as StackLayout34,
  UtilityText as UtilityText18,
  Checkbox as Checkbox4
} from "@leagueplatform/genesis-core";
function AcknowledgementInformation(props) {
  const { errorHandling } = props;
  const [fraudAcknowledgementTicked, setFraudAcknowledgementTicked] = useState27(false);
  useEffect33(() => {
    if (fraudAcknowledgementTicked) {
      errorHandling(true);
    } else {
      errorHandling(false);
    }
  }, [fraudAcknowledgementTicked, errorHandling]);
  return /* @__PURE__ */ React35.createElement(
    StackLayout34,
    {
      css: { backgroundColor: "White" },
      horizontalAlignment: "center"
    },
    /* @__PURE__ */ React35.createElement(
      Box31,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          padding: "$three $four $one $four"
        }
      },
      /* @__PURE__ */ React35.createElement(
        HeadingText29,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        "Direct Reimbursement Claim Form"
      ),
      /* @__PURE__ */ React35.createElement(
        Box31,
        {
          css: {
            marginTop: "$two",
            marginBottom: "$one"
          }
        },
        /* @__PURE__ */ React35.createElement(
          HeadingText29,
          {
            level: "3",
            size: {
              "@initial": "xl",
              "@mobile": "lg"
            }
          },
          "Step 5: Acknowledgement/Certification"
        )
      ),
      /* @__PURE__ */ React35.createElement(
        Box31,
        {
          css: {
            display: "flex",
            width: "600px"
          }
        },
        /* @__PURE__ */ React35.createElement(UtilityText18, null, "I certify that the information on this form is correct and authorize the provider to release appropriate information necessary to process the claim to plan provisions. Additionally, I have read and understand the fraud statement.")
      ),
      /* @__PURE__ */ React35.createElement(Box31, null, /* @__PURE__ */ React35.createElement(FraudModal, { fraudLabel: "Fraud Statement" }), /* @__PURE__ */ React35.createElement(
        UtilityText18,
        {
          css: {
            display: "flex",
            width: "600px"
          }
        },
        /* @__PURE__ */ React35.createElement(
          Checkbox4,
          {
            id: "fraud-acknowledgement",
            name: "fraud-acknowledgement",
            label: "",
            checked: fraudAcknowledgementTicked,
            onChange: () => setFraudAcknowledgementTicked(!fraudAcknowledgementTicked)
          }
        ),
        "By checking this box and clicking \u2018Submit\u2019 below, I am electronically signing this Vision Claim Form."
      ))
    )
  );
}

// src/components/forms/forms-type/directreimbursement/directreimbursement-forms.component.tsx
function DirectReimbursementForm(props) {
  const { closeForm } = props;
  const apiResponse1 = useFetchProfileData();
  const apiResponse2 = useFetchPlanDetailsData("vision");
  const apiData1 = apiResponse1[0];
  const apiData2 = apiResponse2[0];
  const errMsg1 = apiResponse1[1];
  const errMsg2 = apiResponse2[1];
  const [isErrorHandling, setErrorHandling] = useState28(false);
  const [isValidateForm, setIsValidateForm] = useState28(false);
  useEffect34(() => {
    emptyStorage();
  }, []);
  const componentList = [
    /* @__PURE__ */ React36.createElement(
      PolicyHolderInformation2,
      {
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData1,
        planDetailsResponseData: apiData2
      }
    ),
    /* @__PURE__ */ React36.createElement(
      PatientInformation2,
      {
        errorHandling: (val) => setErrorHandling(val),
        profileResponseData: apiData1
      }
    ),
    /* @__PURE__ */ React36.createElement(ServiceInformation, null),
    /* @__PURE__ */ React36.createElement(
      ExaminerDispenserInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val)
      }
    ),
    /* @__PURE__ */ React36.createElement(
      AcknowledgementInformation,
      {
        nextButtonClicked: isValidateForm,
        errorHandling: (val) => setErrorHandling(val)
      }
    )
  ];
  return /* @__PURE__ */ React36.createElement(
    StackLayout35,
    {
      horizontalAlignment: "center",
      css: { position: "relative", minHeight: "100vh" }
    },
    apiData1 && apiData2 && /* @__PURE__ */ React36.createElement(
      FooterMultiStepProgress,
      {
        list: componentList,
        handleFormOrNext: isErrorHandling,
        isValidateForm: (val) => setIsValidateForm(val),
        closeForm,
        formName: "medicationexception" /* MEDICATION_EXCEPTION */
      }
    ),
    (errMsg1 || errMsg2) && /* @__PURE__ */ React36.createElement(ErrorModal, { onClose: closeForm }),
    (!apiData1 || !apiData2) && (!errMsg1 || !errMsg2) && /* @__PURE__ */ React36.createElement(
      Spinner5,
      {
        loading: !apiData1,
        loadingText: "Fetching the online form data!",
        size: "40px"
      }
    )
  );
}

// src/components/tabs-component/tabs.component.tsx
import React38, { useEffect as useEffect35, useState as useState29 } from "react";
import {
  Box as Box33,
  ParagraphText as ParagraphText17,
  Tabs,
  Spinner as Spinner6,
  StackLayout as StackLayout36
} from "@leagueplatform/genesis-core";
import { getInitializationConfig } from "@leagueplatform/core";
import { handleStaticAsset as handleStaticAsset13 } from "@leagueplatform/asset-config";

// src/components/reusable-components/form-structure.component.tsx
import React37 from "react";
import {
  Card,
  Box as Box32,
  HeadingText as HeadingText30,
  Button as Button3,
  ParagraphText as ParagraphText16
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset12 } from "@leagueplatform/asset-config";
function FormsReusableComponent(props) {
  const { formData, openForm, groupNumber } = props;
  const {
    headingText,
    description,
    altFormIdentifiers,
    details,
    instructions,
    forms
  } = formData;
  return /* @__PURE__ */ React37.createElement(
    Card.Elevated,
    {
      backgroundColor: "primary",
      css: {
        width: "898px",
        margin: "12px 0 12px 0"
      }
    },
    /* @__PURE__ */ React37.createElement(Card.Section, null, /* @__PURE__ */ React37.createElement(
      Box32,
      {
        css: {
          width: "850px"
        }
      },
      /* @__PURE__ */ React37.createElement(
        HeadingText30,
        {
          size: "md",
          level: "1",
          css: {
            display: "inline-flex",
            width: "850px"
          }
        },
        /* @__PURE__ */ React37.createElement(
          "span",
          {
            style: {
              display: "grid",
              alignItems: "center",
              height: "108px",
              width: "658px"
            }
          },
          headingText
        ),
        /* @__PURE__ */ React37.createElement(
          "span",
          {
            style: {
              display: "grid",
              alignItems: "center",
              position: "relative",
              margin: "0 0 0 280px"
            }
          },
          forms.map((form) => /* @__PURE__ */ React37.createElement(
            Button3,
            {
              key: form,
              css: {
                height: "60px",
                width: "210px",
                marginBottom: "12px"
              },
              onClick: () => openForm(
                form.type,
                form.url,
                headingText,
                form.prefillInfo,
                groupNumber
              )
            },
            /* @__PURE__ */ React37.createElement(
              "span",
              {
                style: {
                  display: "inline-flex",
                  alignItems: "center",
                  padding: form.title === "PDF Form" ? "15px" : "15px 0px"
                }
              },
              /* @__PURE__ */ React37.createElement(
                "img",
                {
                  src: handleStaticAsset12(
                    "FORM_ICON" /* FORM_ICON */
                  ),
                  alt: "Visual Icon",
                  width: "24px",
                  height: "24px",
                  style: {
                    marginRight: "12px"
                  }
                }
              ),
              form.title
            )
          ))
        )
      ),
      /* @__PURE__ */ React37.createElement(
        ParagraphText16,
        {
          css: {
            width: "670px"
          }
        },
        description && description.map((desc) => /* @__PURE__ */ React37.createElement("p", { key: desc }, desc)),
        /* @__PURE__ */ React37.createElement("p", null, altFormIdentifiers.titles && /* @__PURE__ */ React37.createElement(React37.Fragment, null, /* @__PURE__ */ React37.createElement("span", { style: { fontStyle: "italic" } }, altFormIdentifiers.descriptorText), " ", /* @__PURE__ */ React37.createElement("span", null, altFormIdentifiers.titles.join(", ")))),
        /* @__PURE__ */ React37.createElement("p", { style: { marginLeft: "9px" } }, details && details.map((det) => /* @__PURE__ */ React37.createElement("li", { key: det }, det)))
      )
    ), instructions && /* @__PURE__ */ React37.createElement(
      Card.Elevated,
      {
        backgroundColor: "highlight",
        css: {
          marginTop: "18px",
          width: "850px"
        }
      },
      /* @__PURE__ */ React37.createElement(
        Card.Section,
        {
          css: {
            padding: "6px",
            width: "850px"
          }
        },
        instructions.map((inst) => /* @__PURE__ */ React37.createElement(ParagraphText16, { key: inst }, /* @__PURE__ */ React37.createElement("p", null, inst.descriptorText), inst.type === "email" ? inst.contents.map((content) => (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          /* @__PURE__ */ React37.createElement(
            "a",
            {
              key: content,
              href: "",
              onClick: (e) => e.preventDefault()
            },
            content
          )
        )) : inst.contents.map((content) => /* @__PURE__ */ React37.createElement("p", { key: content }, content))))
      )
    ))
  );
}

// src/components/tabs-component/tabs.component.tsx
var ENV_STORAGE_KEY = "hm-env";
function TabsComponent(props) {
  const { openForm, closeForm, ubk } = props;
  const { tenantId } = getInitializationConfig();
  const [tabsData, setTabsData] = useState29();
  const [selectedTab, setSelectedTab] = useState29("");
  const [formsData, setFormsData] = useState29({});
  const [loading, setLoading] = useState29(false);
  const [errMsg, setErrMsg] = useState29(null);
  const [groupNumber, setGroupNumber] = useState29(null);
  const getPlans = (planData) => {
    const plans = [];
    const planDetailsData = [];
    planData.forEach((plan) => {
      const casingPlanType = plan.planType.charAt(0).toUpperCase() + plan.planType.slice(1);
      if (plans.indexOf(casingPlanType) === -1) {
        plans.push(casingPlanType);
        if (casingPlanType === "Dental" || casingPlanType === "Vision") {
          planDetailsData.push(plan);
        }
      }
      if (plan.integrated) {
        getPlans(plan.integrated).map((planType) => {
          if (plans.indexOf(planType) === -1) {
            plans.push(planType);
          }
          return 0;
        });
      }
    });
    sessionStorage.setItem("planDetailsKeys", JSON.stringify(planDetailsData));
    return plans;
  };
  const config = formsLibrary.getConfig();
  const { HIGHMARK_API_URL } = config;
  const plansUrl = `${HIGHMARK_API_URL}/members/benefits/plans?planYear=all`;
  const getPlanData = () => {
    getAccessToken(plansUrl).then((result) => {
      const plansData = result == null ? void 0 : result.plans;
      const errData = result == null ? void 0 : result.errMsg;
      const sortingOrder = Object.values(FORM_PLAN_TYPE);
      if (plansData) {
        const gpNumber = plansData == null ? void 0 : plansData.find((val) => val.groupNumber);
        setGroupNumber(gpNumber);
        const planDataType = getPlans(plansData);
        const filteredPlanDataType = planDataType == null ? void 0 : planDataType.filter(
          (val) => Object.values(FORM_PLAN_TYPE).toString().split(",").indexOf(val) > -1
        );
        const sortedPlanDataType = filteredPlanDataType == null ? void 0 : filteredPlanDataType.sort(
          (tab1, tab2) => sortingOrder.indexOf(tab1) - sortingOrder.indexOf(tab2)
        );
        const appName = tenantId || sessionStorage.getItem(ENV_STORAGE_KEY);
        if (appName === "hm-allmyhealth" /* AMH */) {
          const withoutDental = sortedPlanDataType == null ? void 0 : sortedPlanDataType.filter(
            (val) => val !== "Dental" /* DENTAL */
          );
          setTabsData(withoutDental);
        } else {
          setTabsData(sortedPlanDataType);
        }
        setSelectedTab("medical");
      } else if (errData) {
        setErrMsg(errData);
      }
    });
  };
  const getFormsData = () => {
    const formsDataUrl = `${HIGHMARK_API_URL}/members/forms-library/forms?ubk=${ubk}&formType=${selectedTab}`;
    setLoading(true);
    getAccessToken(formsDataUrl, "forms").then((result) => {
      const formsApiData = result == null ? void 0 : result.forms;
      const formType = result == null ? void 0 : result.type;
      const errData = result == null ? void 0 : result.errMsg;
      if (formType === selectedTab) {
        if (formsApiData) {
          setLoading(false);
          result.forms.sort((formA, formB) => {
            const textA = formA.headingText.toLowerCase();
            const textB = formB.headingText.toLowerCase();
            if (textA < textB)
              return -1;
            if (textA > textB)
              return 1;
            return 0;
          });
          setFormsData(result);
        } else if (errData) {
          setErrMsg(errData);
        }
      }
    });
  };
  const clearErrMsg = () => {
    setErrMsg(null);
    getPlanData();
    getFormsData();
    closeForm();
  };
  useEffect35(() => {
    getPlanData();
  }, []);
  useEffect35(() => {
    if (selectedTab) {
      getFormsData();
    }
  }, [selectedTab, ubk]);
  const tabChange = (tab) => {
    setSelectedTab(tab);
  };
  return /* @__PURE__ */ React38.createElement(
    StackLayout36,
    {
      css: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "$two $none"
      }
    },
    errMsg && /* @__PURE__ */ React38.createElement(ErrorModal, { onClose: clearErrMsg }),
    tabsData && /* @__PURE__ */ React38.createElement(
      Box33,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "$two $none"
        }
      },
      /* @__PURE__ */ React38.createElement(
        "img",
        {
          src: handleStaticAsset13("VISUAL_ICON" /* VISUAL_ICON */),
          alt: "Visual Icon",
          width: "150px",
          height: "150px"
        }
      ),
      /* @__PURE__ */ React38.createElement(
        ParagraphText17,
        {
          css: {
            margin: "24px 0px"
          }
        },
        "Access your health plan forms all in one place. Download PDFs to mail or fax, or access online forms for easy submission."
      ),
      /* @__PURE__ */ React38.createElement(
        Tabs.Root,
        {
          activationMode: "manual",
          css: {
            width: "898px",
            height: "38px",
            margin: "0 0 12px 0"
          },
          defaultValue: "medical"
        },
        /* @__PURE__ */ React38.createElement(
          Tabs.TabList,
          {
            "aria-label": "tabs example",
            tabDistribution: "distributeEvenly"
          },
          tabsData.map((tab) => /* @__PURE__ */ React38.createElement(
            Tabs.Tab,
            {
              key: tab,
              value: tab === "Drug" /* DRUG */ ? "pharmacy" : tab.toLocaleLowerCase(),
              onClick: () => tab === "Drug" /* DRUG */ ? tabChange("pharmacy") : tabChange(tab.toLocaleLowerCase())
            },
            tab === "Drug" /* DRUG */ ? "Pharmacy/Rx" /* PHARMACY */ : tab
          ))
        ),
        loading ? /* @__PURE__ */ React38.createElement(
          Spinner6,
          {
            loading,
            loadingText: "Fetching the Forms Data..!",
            size: "40px",
            css: {
              margin: "0 0 0 450px"
            }
          }
        ) : /* @__PURE__ */ React38.createElement(Box33, null, formsData && formsData.forms && /* @__PURE__ */ React38.createElement(Tabs.TabPanel, { value: selectedTab }, formsData.forms.map((form) => /* @__PURE__ */ React38.createElement(
          FormsReusableComponent,
          {
            formData: form,
            groupNumber,
            openForm
          }
        ))))
      )
    ),
    !errMsg && !tabsData && /* @__PURE__ */ React38.createElement(
      Spinner6,
      {
        loading: !tabsData,
        loadingText: "Fetching the Forms Data..!",
        size: "40px"
      }
    )
  );
}

// src/components/forms-library.component.tsx
function FormsLibraryComponent() {
  const { tenantId } = getInitializationConfig2();
  const [showForm, setShowForm] = useState30("");
  const [ubk, setUbk] = useState30("");
  const [errMsg, setErrMsg] = useState30(null);
  const config = formsLibrary.getConfig();
  const {
    HIGHMARK_API_URL,
    AMH_CDN_URL,
    HIGHMARK_CDN_URL,
    STAGING_URL,
    LOCAL_URL
  } = config;
  const url = `${HIGHMARK_API_URL}/members/eligibility/eligible/my-highmark-app`;
  const getUbk = useCallback(() => {
    getAccessToken(url).then((result) => {
      const eligibilityData = result == null ? void 0 : result.eligibility;
      const errData = result == null ? void 0 : result.errMsg;
      if (eligibilityData) {
        setUbk(eligibilityData.brandUbk);
      } else if (errData) {
        setErrMsg(errData);
      }
    });
  }, [url]);
  useEffect36(() => {
    sessionStorage.removeItem("planDetailsKeys");
  }, []);
  useEffect36(() => {
    getUbk();
  }, [getUbk]);
  const displayPreFillPdf = (prefillInfo, groupNumber, formUrl) => {
    const PREFILL_PDF_URL = `${HIGHMARK_API_URL}/members/forms-library/prefill-pdf?formName=${prefillInfo == null ? void 0 : prefillInfo.prefillFormName}&groupNumber=${groupNumber == null ? void 0 : groupNumber.groupNumber}`;
    getAccessToken(PREFILL_PDF_URL).then((res) => {
      const { status, content } = res;
      if (status === 200) {
        openPrefilledPdf(content);
      } else {
        const hostUrl = window.location.origin;
        let baseUrl = HIGHMARK_CDN_URL;
        if (tenantId === "hm-allmyhealth" /* AMH */) {
          baseUrl = AMH_CDN_URL;
        }
        const staticFormUrl = `${baseUrl}${formUrl}`;
        if (hostUrl === STAGING_URL || hostUrl === LOCAL_URL) {
          window.open(staticFormUrl, "_blank");
        } else {
          window.open(formUrl, "_blank");
        }
      }
    });
  };
  const openForm = (formType, formUrl, identifier, prefillInfo, groupNumber) => {
    if (formType === "link" /* ONLINE_FORM */) {
      switch (identifier) {
        case "Medication Exception Request Form" /* MEDICATION */:
          setShowForm("medication");
          break;
        case "Step Therapy Exception Request Form" /* STEP_THERAPY */:
          setShowForm("stepTherapy");
          break;
        case "Member Submitted Dental Claim Form" /* DENTAL */:
          break;
        case "Direct Reimbursement Claim Form" /* DIRECT_REIMBURSEMENT */:
          break;
        default:
          break;
      }
    } else if (formType === "pdf" /* PDF_FORM */) {
      const hostUrl = window.location.origin;
      let baseUrl = HIGHMARK_CDN_URL;
      if (tenantId === "hm-allmyhealth" /* AMH */) {
        baseUrl = AMH_CDN_URL;
      }
      const staticFormUrl = `${baseUrl}${formUrl}`;
      if (prefillInfo == null ? void 0 : prefillInfo.available) {
        displayPreFillPdf(prefillInfo, groupNumber, formUrl);
      } else if (hostUrl === STAGING_URL || hostUrl === LOCAL_URL) {
        window.open(staticFormUrl, "_blank");
      } else {
        window.open(formUrl, "_blank");
      }
    }
  };
  const closeForm = () => {
    setShowForm("");
    emptyStorage();
    setErrMsg(null);
    getUbk();
  };
  const goBack = () => {
    history.goBack();
  };
  return /* @__PURE__ */ React39.createElement(
    Box34,
    {
      css: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: !showForm ? "#ffffff" : "#F8F8F8",
        padding: !showForm ? "" : "$one"
      }
    },
    errMsg && /* @__PURE__ */ React39.createElement(ErrorModal, { onClose: closeForm }),
    !showForm && !errMsg && (ubk === "" ? /* @__PURE__ */ React39.createElement(
      Spinner7,
      {
        loading: !ubk,
        loadingText: "Fetching the Forms Data..!",
        size: "40px",
        css: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "$two $none"
        }
      }
    ) : /* @__PURE__ */ React39.createElement(React39.Fragment, null, /* @__PURE__ */ React39.createElement(
      Card2.Flat,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          paddingLeft: "20%",
          paddingTop: "30px",
          backgroundColor: "#EAF5FD",
          height: "152px"
        }
      },
      /* @__PURE__ */ React39.createElement(Card2.Section, null, /* @__PURE__ */ React39.createElement(
        HeadingText31,
        {
          level: "1",
          size: {
            "@initial": "xxl",
            "@mobile": "xl"
          }
        },
        /* @__PURE__ */ React39.createElement(TextAction10, { onClick: goBack }, /* @__PURE__ */ React39.createElement(
          "img",
          {
            src: handleStaticAsset14(
              "LEFT_ARROW_BLACK_ICON" /* LEFT_ARROW_BLACK_ICON */
            ),
            alt: "Back Button",
            style: {
              cursor: "pointer"
            }
          }
        )),
        /* @__PURE__ */ React39.createElement("span", { style: { paddingLeft: "20px" } }, "Forms Library")
      ))
    ), /* @__PURE__ */ React39.createElement(
      TabsComponent,
      {
        openForm,
        ubk,
        closeForm
      }
    ))),
    showForm === "medication" && /* @__PURE__ */ React39.createElement(MedicationForm, { closeForm }),
    showForm === "stepTherapy" && /* @__PURE__ */ React39.createElement(StepTherapyForm, { closeForm }),
    showForm === "dentalClaim" && /* @__PURE__ */ React39.createElement(DentalClaimForm, { closeForm }),
    showForm === "directReimbursement" && /* @__PURE__ */ React39.createElement(DirectReimbursementForm, { closeForm })
  );
}

// src/forms-library.routes.tsx
var FormsLibraryRoutes = () => {
  const { path } = useRouteMatch();
  return /* @__PURE__ */ React40.createElement(Switch, null, /* @__PURE__ */ React40.createElement(Route, { exact: true, path, component: FormsLibraryComponent }));
};

// src/index.ts
initModule();
export {
  FormsLibraryRoutes,
  formsLibrary
};
//# sourceMappingURL=index.js.map